// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const LR: IClientSubSystemModel = {
  Code: 'LR',
  DisplayLabel: 'Leverantörsreskontra',
  BusinessModels: {
    LRAttestantReferenskod: {
      CollectionName: 'LRAttestantReferenskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestantReferenskod',
        Abstract: false,
        SOLabel: 'Attestant, referenskod',
        SOGLabel: 'Attestant, referenskods',
        SBLabel: 'Attestant, referenskoden',
        SBGLabel: 'Attestant, referenskodens',
        POLabel: 'Attestant, referenskoder',
        POGLabel: 'Attestant, referenskoders',
        PBLabel: 'Attestant, referenskoderna',
        PBGLabel: 'Attestant, referenskodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestant, referenskodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestant, referenskodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestant, referenskodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REFERENSKOD: {
          AttributeName: 'REFERENSKOD',
          DisplayLabel: 'Alternativ referenskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestantKontobegr: {
      CollectionName: 'LRAttestantKontobegr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestantKontobegr',
        Abstract: false,
        SOLabel: 'Attestantens kodbegränsning',
        SOGLabel: 'Attestantens kodbegränsning',
        SBLabel: 'Attestantens kodbegränsning',
        SBGLabel: 'Attestantens kodbegränsning',
        POLabel: 'Attestantens kodbegränsning',
        POGLabel: 'Attestantens kodbegränsning',
        PBLabel: 'Attestantens kodbegränsning',
        PBGLabel: 'Attestantens kodbegränsning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestantens kodbegränsning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestantens kodbegränsning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestantens kodbegränsning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONV_TO_VIEW_ID: {
          AttributeName: 'KONV_TO_VIEW_ID',
          DisplayLabel: 'Konverteras till kodbeh viewid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestant: {
      CollectionName: 'LRAttestant',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '10003'], ['AllowSelection', '17001'], ['AllowEdit', '17001']]),
      RootType: {
        TypeValue: 'Attestant',
        Abstract: false,
        SOLabel: 'Attestant',
        SOGLabel: 'Attestant',
        SBLabel: 'Attestanten',
        SBGLabel: 'Attestanten',
        POLabel: 'Attestanter',
        POGLabel: 'Attestanter',
        PBLabel: 'Attestanterna',
        PBGLabel: 'Attestanterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestanten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestanten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attestanten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestanten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KONTOINT_TYP: {
          AttributeName: 'KONTOINT_TYP',
          DisplayLabel: 'Kontobehörighet, typ',
          Hint: 'Angivet kontointervall',
          DataType: 'Enum',
          EnumValues: new Map([['ANGIVET_KONTOINTERVALL', 'Angivet kontointervall']]),
          EnumSortValues: new Map([['ANGIVET_KONTOINTERVALL', 'V']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANGIVET_KONTOINTERVALL=Angivet kontointervall"',
          GUIEditable: true,
          Required: true,
        },
        MAX_BELOPP: {
          AttributeName: 'MAX_BELOPP',
          DisplayLabel: 'Max belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Kontobehörighet för attestant',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRANVARANDE: {
          AttributeName: 'FRANVARANDE',
          DisplayLabel: 'Frånvarande',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        FRANVARANDE_FROM: {
          AttributeName: 'FRANVARANDE_FROM',
          DisplayLabel: 'Frånvarande, från datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        FRANVARANDE_TOM: {
          AttributeName: 'FRANVARANDE_TOM',
          DisplayLabel: 'Frånvarande, till datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        FRANVARANDE_NOTERING: {
          AttributeName: 'FRANVARANDE_NOTERING',
          DisplayLabel: 'Frånvarande, notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        Sign_Namn: {
          AttributeName: 'Sign_Namn',
          DisplayLabel: 'Signatur och namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KBPrelarkonto: {
          AttributeName: 'KBPrelarkonto',
          DisplayLabel: 'KBPrelarkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FranvDatum: {
          AttributeName: 'FranvDatum',
          DisplayLabel: 'Frånvarande, datum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ELEKTRONISK_ATTEST: {
          AttributeName: 'ELEKTRONISK_ATTEST',
          DisplayLabel: 'Attesterar elektroniska fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          Required: true,
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestomraden: {
          AttributeName: 'Attestomraden',
          DisplayLabel: 'Attestområden',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IsFranvarande: {
          AttributeName: 'IsFranvarande',
          DisplayLabel: 'Är frånvarande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        IsFranvarandeFrom: {
          AttributeName: 'IsFranvarandeFrom',
          DisplayLabel: 'Är frånvarande fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IsFranvarandeTom: {
          AttributeName: 'IsFranvarandeTom',
          DisplayLabel: 'Är frånvarande t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IsFranvarandeDatum: {
          AttributeName: 'IsFranvarandeDatum',
          DisplayLabel: 'Frånvarande datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        IsFranvarandeTomString: {
          AttributeName: 'IsFranvarandeTomString',
          DisplayLabel: 'IsFranvarandeTomString',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Prelarkonto: {
          AssociationName: 'Prelarkonto',
          DisplayLabel: 'Preliminärkonto vid ankreg',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsrecept: {
          AssociationName: 'Konteringsrecept',
          DisplayLabel: 'Konteringsrecept',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRKonteringsrecept',
          AssociatedComponentName: 'Konteringsrecept',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegransning: {
          AssociationName: 'Kontobegransning',
          DisplayLabel: 'Attestbegränsning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestantKontobegr',
          AssociatedComponentName: 'AttestantKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Referenskoder: {
          AssociationName: 'Referenskoder',
          DisplayLabel: 'Alternativa referenskoder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestantReferenskod',
          AssociatedComponentName: 'AttestantReferenskod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Reserver: {
          AssociationName: 'Reserver',
          DisplayLabel: 'Reserver',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestrattReserv',
          AssociatedComponentName: 'AttestrattReserv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestforslagDelAttestant: {
      CollectionName: 'LRAttestforslagDelAttestant',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestforslagDelAttestant',
        Abstract: false,
        SOLabel: 'Attestant',
        SOGLabel: 'Attestants',
        SBLabel: 'Attestanten',
        SBGLabel: 'Attestantens',
        POLabel: 'Attestanter',
        POGLabel: 'Attestanters',
        PBLabel: 'Attestanterna',
        PBGLabel: 'Attestanternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestantens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestantens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestantens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Beslutsattestant/Mottagningsattestant',
          DataType: 'Enum',
          EnumValues: new Map([['BESLUTSATTESTANT', 'Beslutsattestant'], ['MOTTAGNINGSATTESTANT', 'Mottagningsattestant']]),
          EnumSortValues: new Map([['BESLUTSATTESTANT', 'B'], ['MOTTAGNINGSATTESTANT', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESLUTSATTESTANT=Beslutsattestant;MOTTAGNINGSATTESTANT=Mottagningsattestant"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Id, attestområde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Id, attesträtt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ForslagDel: {
          AssociationName: 'ForslagDel',
          DisplayLabel: 'Förslagsdel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslagDel',
          AssociatedComponentName: 'AttestforslagDel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLevfaktAttestant: {
      CollectionName: 'LRLevfaktAttestant',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LevfaktAttestant',
        Abstract: false,
        SOLabel: 'Attestant för faktura',
        SOGLabel: 'Attestant för faktura',
        SBLabel: 'Attestanten för fakturan',
        SBGLabel: 'Attestanten för fakturan',
        POLabel: 'Attestanter för fakturor',
        POGLabel: 'Attestanter för fakturor',
        PBLabel: 'Attestanterna för fakturorna',
        PBGLabel: 'Attestanterna för fakturorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestanten för fakturan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestanten för fakturan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestanten för fakturan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Attestant: {
          AttributeName: 'Attestant',
          DisplayLabel: 'Attestant',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestforslagDel: {
      CollectionName: 'LRAttestforslagDel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestforslagDel',
        Abstract: false,
        SOLabel: 'Attestdel',
        SOGLabel: 'Attestdels',
        SBLabel: 'Attestdelen',
        SBGLabel: 'Attestdelens',
        POLabel: 'Attestdelar',
        POGLabel: 'Attestdelars',
        PBLabel: 'Attestdelarnas',
        PBGLabel: 'Attestdelarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestdelens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestdelens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestdelens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTGRUPP_ID: {
          AttributeName: 'ATTESTGRUPP_ID',
          DisplayLabel: 'Id, attestgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestforslag: {
          AssociationName: 'Attestforslag',
          DisplayLabel: 'Attestförslag',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslag',
          AssociatedComponentName: 'Attestforslag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ForslagDelAttestant: {
          AssociationName: 'ForslagDelAttestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslagDelAttestant',
          AssociatedComponentName: 'AttestforslagDelAttestant',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestGrupp: {
      CollectionName: 'LRAttestGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestGrupp',
        Abstract: false,
        SOLabel: 'Attestgrupp',
        SOGLabel: 'Attestgrupp',
        SBLabel: 'Attestgruppen',
        SBGLabel: 'Attestgruppen',
        POLabel: 'Attestgrupper',
        POGLabel: 'Attestgrupper',
        PBLabel: 'Attestgrupperna',
        PBGLabel: 'Attestgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attestgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DGR_TILL_FORFALLODATUM: {
          AttributeName: 'DGR_TILL_FORFALLODATUM',
          DisplayLabel: 'Antal dagar till förfallodatum',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        STANDARD_ATTESTOMRADE_ID: {
          AttributeName: 'STANDARD_ATTESTOMRADE_ID',
          DisplayLabel: 'Standard, attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_ATTESTRATT_LOPNR: {
          AttributeName: 'STANDARD_ATTESTRATT_LOPNR',
          DisplayLabel: 'Standard, attesträtt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Defintivbokningsgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ELEKTRONISK_ATTEST: {
          AttributeName: 'ELEKTRONISK_ATTEST',
          DisplayLabel: 'Elektronisk attest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BEH_KONTROLL: {
          AttributeName: 'BEH_KONTROLL',
          DisplayLabel: 'Behörighetskontroll',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_FORENKLAD_ATTESTOMRADE_ID: {
          AttributeName: 'STANDARD_FORENKLAD_ATTESTOMRADE_ID',
          DisplayLabel: 'Standard, attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_FORENKLAD_ATTESTRATT_LOPNR: {
          AttributeName: 'STANDARD_FORENKLAD_ATTESTRATT_LOPNR',
          DisplayLabel: 'Standard, attesträtt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_FORENKLAD_BA_ATTESTOMRADE_ID: {
          AttributeName: 'STANDARD_FORENKLAD_BA_ATTESTOMRADE_ID',
          DisplayLabel: 'Standard, attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_FORENKLAD_BA_ATTESTRATT_LOPNR: {
          AttributeName: 'STANDARD_FORENKLAD_BA_ATTESTRATT_LOPNR',
          DisplayLabel: 'Standard, attesträtt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        StandardAttestratt: {
          AssociationName: 'StandardAttestratt',
          DisplayLabel: 'Standard attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        StandardForenkladAttestratt: {
          AssociationName: 'StandardForenkladAttestratt',
          DisplayLabel: 'Standard förenklad attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        StandardForenkladBAAttestratt: {
          AssociationName: 'StandardForenkladBAAttestratt',
          DisplayLabel: 'Standard förenklad attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestOmrade',
          AssociatedComponentName: 'AttestOmrade',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Administratorer: {
          AssociationName: 'Administratorer',
          DisplayLabel: 'Administratörer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestGruppAdm',
          AssociatedComponentName: 'AttestgruppAdm',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGruppAttestgrupp',
          AssociatedComponentName: 'GruppAttestgrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestGruppAdm: {
      CollectionName: 'LRAttestGruppAdm',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestGruppAdm',
        Abstract: false,
        SOLabel: 'Attestgruppsadministratör',
        SOGLabel: 'Attestgruppsadministratör',
        SBLabel: 'Attestgruppsadministratören',
        SBGLabel: 'Attestgruppsadministratören',
        POLabel: 'Attestgruppsadministratörer',
        POGLabel: 'Attestgruppsadministratörer',
        PBLabel: 'Attestgruppsadministratörerna',
        PBGLabel: 'Attestgruppsadministratörerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestgruppsadministratören primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestgruppsadministratören versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestgruppsadministratören fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Signatur: {
          AttributeName: 'Signatur',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestgrupp: {
          AssociationName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestGrupp',
          AssociatedComponentName: 'AttestGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LRAttestmeddelande: {
      CollectionName: 'LRAttestmeddelande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'Attestmeddelande',
        Abstract: false,
        SOLabel: 'Attestmeddelande',
        SOGLabel: 'Attestmeddelande',
        SBLabel: 'Attestmeddelande',
        SBGLabel: 'Attestmeddelande',
        POLabel: 'Attestmeddelande',
        POGLabel: 'Attestmeddelande',
        PBLabel: 'Attestmeddelande',
        PBGLabel: 'Attestmeddelande',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestmeddelande primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestmeddelande versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attestmeddelande id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        AVSANDAR_TYP: {
          AttributeName: 'AVSANDAR_TYP',
          DisplayLabel: 'Avsändartyp',
          Hint: 'Attestant/Administratör/Ej definierat',
          DataType: 'Enum',
          EnumValues: new Map([['ATTESTANT', 'Attestant'], ['ADMINISTRATOR', 'Administratör'], ['EJ_DEFINIERAT', 'Ej definierat']]),
          EnumSortValues: new Map([['ATTESTANT', 'A'], ['ADMINISTRATOR', 'E'], ['EJ_DEFINIERAT', 'G']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATTESTANT=Attestant;ADMINISTRATOR=Administratör;EJ_DEFINIERAT=Ej definierat"',
        },
        AVS_ATTESTOMRADE_ID: {
          AttributeName: 'AVS_ATTESTOMRADE_ID',
          DisplayLabel: 'Avsändare, attestområde id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVS_ATTESTRATT_LOPNR: {
          AttributeName: 'AVS_ATTESTRATT_LOPNR',
          DisplayLabel: 'Avsändare, attesträtt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVS_ADMIN_USER_ID: {
          AttributeName: 'AVS_ADMIN_USER_ID',
          DisplayLabel: 'Avsändare, administratör',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGAR_TYP: {
          AttributeName: 'MOTTAGAR_TYP',
          DisplayLabel: 'Mottagartyp',
          Hint: 'Attestant/Administratör/Alla',
          DataType: 'Enum',
          EnumValues: new Map([['ATTESTANT', 'Attestant'], ['ADMINISTRATOR', 'Administratör'], ['ALLA', 'Alla']]),
          EnumSortValues: new Map([['ATTESTANT', 'A'], ['ADMINISTRATOR', 'E'], ['ALLA', 'G']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATTESTANT=Attestant;ADMINISTRATOR=Administratör;ALLA=Alla"',
        },
        MOT_ATTESTOMRADE_ID: {
          AttributeName: 'MOT_ATTESTOMRADE_ID',
          DisplayLabel: 'Mottagare, attestområde id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOT_ATTESTRATT_LOPNR: {
          AttributeName: 'MOT_ATTESTRATT_LOPNR',
          DisplayLabel: 'Mottagare, attesträtt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        Attestmeddelande: {
          AttributeName: 'Attestmeddelande',
          DisplayLabel: 'Attestmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Avsandare: {
          AttributeName: 'Avsandare',
          DisplayLabel: 'Avsändare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rubrik: {
          AttributeName: 'Rubrik',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvsandareSignatur: {
          AttributeName: 'AvsandareSignatur',
          DisplayLabel: 'Avsändare, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE_KORT: {
          AttributeName: 'MEDDELANDE_KORT',
          DisplayLabel: 'Meddelande',
          Hint: 'Används endast för att man ska kunna se meddelande i loggen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AvsandarAttestratt: {
          AssociationName: 'AvsandarAttestratt',
          DisplayLabel: 'Avsändande attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvsandarAdminUser: {
          AssociationName: 'AvsandarAdminUser',
          DisplayLabel: 'Avsändande administratör',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        MottagarAttestratt: {
          AssociationName: 'MottagarAttestratt',
          DisplayLabel: 'Mottagande attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kvittenser: {
          AssociationName: 'Kvittenser',
          DisplayLabel: 'Meddelandets kvittenser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestmedKvittens',
          AssociatedComponentName: 'AttestmedKvittens',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestOmrade: {
      CollectionName: 'LRAttestOmrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'AttestOmrade',
        Abstract: false,
        SOLabel: 'Attestområde',
        SOGLabel: 'Attestområde',
        SBLabel: 'Attestområdet',
        SBGLabel: 'Attestområdet',
        POLabel: 'Attestområde',
        POGLabel: 'Attestområde',
        PBLabel: 'Attestområden',
        PBGLabel: 'Attestområden',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestområdet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestområdet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attestområdet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestområdet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Attestområde, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        ATTEST_GRUPP_ID: {
          AttributeName: 'ATTEST_GRUPP_ID',
          DisplayLabel: 'Attestgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Kontointervall, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnsvarigNamn: {
          AttributeName: 'AnsvarigNamn',
          DisplayLabel: 'Ansvarig',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'KodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontobehorighet: {
          AttributeName: 'Kontobehorighet',
          DisplayLabel: 'Kontobehörighet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDS_FROM: {
          AttributeName: 'ANVANDS_FROM',
          DisplayLabel: 'Används fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANVANDS_TOM: {
          AttributeName: 'ANVANDS_TOM',
          DisplayLabel: 'Används t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestgrupp: {
          AssociationName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestGrupp',
          AssociatedComponentName: 'AttestGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegransning: {
          AssociationName: 'Kontobegransning',
          DisplayLabel: 'Attestbegränsning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestomradeKontobegr',
          AssociatedComponentName: 'AttestomradeKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestomradeKontobegr: {
      CollectionName: 'LRAttestomradeKontobegr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestomradeKontobegr',
        Abstract: false,
        SOLabel: 'Attestområdets kodbegränsning',
        SOGLabel: 'Attestområdets kodbegränsning',
        SBLabel: 'Attestområdets kodbegränsning',
        SBGLabel: 'Attestområdets kodbegränsning',
        POLabel: 'Attestområdets kodbegränsning',
        POGLabel: 'Attestområdets kodbegränsning',
        PBLabel: 'Attestområdets kodbegränsning',
        PBGLabel: 'Attestområdets kodbegränsning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestområdets kodbegränsning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestområdets kodbegränsning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestområdets kodbegränsning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestOmrade',
          AssociatedComponentName: 'Attestomrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestrattKontobegr: {
      CollectionName: 'LRAttestrattKontobegr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestrattKontobegr',
        Abstract: false,
        SOLabel: 'Attesträttens kodbegränsning',
        SOGLabel: 'Attesträttens kodbegränsning',
        SBLabel: 'Attesträttens kodbegränsning',
        SBGLabel: 'Attesträttens kodbegränsning',
        POLabel: 'Attesträttens kodbegränsning',
        POGLabel: 'Attesträttens kodbegränsning',
        PBLabel: 'Attesträttens kodbegränsning',
        PBGLabel: 'Attesträttens kodbegränsning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attesträttens kodbegränsning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attesträttens kodbegränsning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attesträttens kodbegränsning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Attesträtt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONV_TO_VIEW_ID: {
          AttributeName: 'KONV_TO_VIEW_ID',
          DisplayLabel: 'Konverteras till kodbeh viewid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestratt: {
      CollectionName: 'LRAttestratt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Attestratt',
        Abstract: false,
        SOLabel: 'Attesträtt',
        SOGLabel: 'Attesträtt',
        SBLabel: 'Attesträtten',
        SBGLabel: 'Attesträtten',
        POLabel: 'Attesträtter',
        POGLabel: 'Attesträtter',
        PBLabel: 'Attesträtterna',
        PBGLabel: 'Attesträtterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attesträtten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attesträtten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attesträtten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attesträtten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SORT_ORDNING: {
          AttributeName: 'SORT_ORDNING',
          DisplayLabel: 'Sorteringsordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Befattning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ANSVARIG: {
          AttributeName: 'ANSVARIG',
          DisplayLabel: 'Ansvarig',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        MOTTAGN_ATTEST: {
          AttributeName: 'MOTTAGN_ATTEST',
          DisplayLabel: 'Mottagningsattest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        MOTTAGN_KONTERING: {
          AttributeName: 'MOTTAGN_KONTERING',
          DisplayLabel: 'Mottagningsattest, kontering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BESLUT_ATTEST: {
          AttributeName: 'BESLUT_ATTEST',
          DisplayLabel: 'Beslutsattest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KONTOINT_ENL_ATTESTANT: {
          AttributeName: 'KONTOINT_ENL_ATTESTANT',
          DisplayLabel: 'Kontobehörighet enligt attestant',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Kontobehörighet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESLUT_MAXBELOPP: {
          AttributeName: 'BESLUT_MAXBELOPP',
          DisplayLabel: 'Maxbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MaxValue="99999999"',
          GUIEditable: true,
        },
        KONTROLL_ATTESTOMRADE_ID: {
          AttributeName: 'KONTROLL_ATTESTOMRADE_ID',
          DisplayLabel: 'Kontrolleras av, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTROLL_LOPNR: {
          AttributeName: 'KONTROLL_LOPNR',
          DisplayLabel: 'Kontrolleras av, löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTROLL_BELOPP: {
          AttributeName: 'KONTROLL_BELOPP',
          DisplayLabel: 'Kontrolleras av, belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MaxValue="99999999"',
          GUIEditable: true,
        },
        MEDDELA_EPOST: {
          AttributeName: 'MEDDELA_EPOST',
          DisplayLabel: 'Meddelande via e-post',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        GRANSKNING_ATTEST: {
          AttributeName: 'GRANSKNING_ATTEST',
          DisplayLabel: 'Granskningsattest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        AttestNamnTitel: {
          AttributeName: 'AttestNamnTitel',
          DisplayLabel: 'Attestant, namn, område och titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontobehorighet2: {
          AttributeName: 'Kontobehorighet2',
          DisplayLabel: 'Kontobehörighet2',
          Hint: 'Används av Kontobehorighet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Maxbelopp: {
          AttributeName: 'Maxbelopp',
          DisplayLabel: 'Maxbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Franvarande: {
          AttributeName: 'Franvarande',
          DisplayLabel: 'Franvarande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Franvarande_from: {
          AttributeName: 'Franvarande_from',
          DisplayLabel: 'Franvarande_from',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Franvarande_tom: {
          AttributeName: 'Franvarande_tom',
          DisplayLabel: 'Franvarande_tom',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Franvarande_notering: {
          AttributeName: 'Franvarande_notering',
          DisplayLabel: 'Franvarande_notering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestSignTitel: {
          AttributeName: 'AttestSignTitel',
          DisplayLabel: 'Attestant, signatur, titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ElektroniskAttest: {
          AttributeName: 'ElektroniskAttest',
          DisplayLabel: 'ElektroniskAttest',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGN_REFUSERA: {
          AttributeName: 'MOTTAGN_REFUSERA',
          DisplayLabel: 'Mottagningsattest, skicka till utredning',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        xUrvalsidLista: {
          AttributeName: 'xUrvalsidLista',
          DisplayLabel: 'UrvalsidLista',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestgruppid: {
          AttributeName: 'Attestgruppid',
          DisplayLabel: 'Attestgruppid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontobehorighet: {
          AttributeName: 'Kontobehorighet',
          DisplayLabel: 'Kontobehörighet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontobehorighetAttestratt: {
          AttributeName: 'KontobehorighetAttestratt',
          DisplayLabel: 'KontobehorighetAttestratt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UrvalsidLista: {
          AttributeName: 'UrvalsidLista',
          DisplayLabel: 'UrvalsidLista',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestKodTitel: {
          AttributeName: 'AttestKodTitel',
          DisplayLabel: 'AttestKodTitel',
          Hint: 'Används i WebAveny',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarKontrollAttestant: {
          AttributeName: 'HarKontrollAttestant',
          DisplayLabel: 'Har kontrollattestant',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        MinstaKontrollbelopp: {
          AttributeName: 'MinstaKontrollbelopp',
          DisplayLabel: 'MinstaKontrollbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        MottagUrvalsidLista: {
          AttributeName: 'MottagUrvalsidLista',
          DisplayLabel: 'MottagUrvalsidLista',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MottagKontobehorighet: {
          AttributeName: 'MottagKontobehorighet',
          DisplayLabel: 'MottagKontobehorighet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarFakturareferenser: {
          AttributeName: 'HarFakturareferenser',
          DisplayLabel: 'Har fakturareferenser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRANSKA_FORANKLAD_DEFBOK: {
          AttributeName: 'GRANSKA_FORANKLAD_DEFBOK',
          DisplayLabel: 'Granska i förenklade definitivbokningen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestOmrade',
          AssociatedComponentName: 'AttestOmrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontrollattestratt: {
          AssociationName: 'Kontrollattestratt',
          DisplayLabel: 'Kontrollattesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Reserver: {
          AssociationName: 'Reserver',
          DisplayLabel: 'Reserver',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestrattReserv',
          AssociatedComponentName: 'AttestrattReserv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegransning: {
          AssociationName: 'Kontobegransning',
          DisplayLabel: 'Attestbegränsning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestrattKontobegr',
          AssociatedComponentName: 'AttestrattKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestbegransningar: {
          AssociationName: 'Attestbegransningar',
          DisplayLabel: 'Kodbehörighet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAnvKontobegr',
          AssociatedComponentName: 'AnvKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestrattReserv: {
      CollectionName: 'LRAttestrattReserv',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17001,17002,2060'], ['AllowEdit', '17001']]),
      RootType: {
        TypeValue: 'AttestrattReserv',
        Abstract: false,
        SOLabel: 'Attesträtt reserv',
        SOGLabel: 'Attesträtt reserv',
        SBLabel: 'Attesträtten reserv',
        SBGLabel: 'Attesträtten reserv',
        POLabel: 'Attesträtter reserv',
        POGLabel: 'Attesträtter reserv',
        PBLabel: 'Attesträtterna reserv',
        PBGLabel: 'Attesträtterna reserv',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attesträtten reserv primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attesträtten reserv versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attesträtten reserv fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM_FROM: {
          AttributeName: 'DATUM_FROM',
          DisplayLabel: 'Från datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUM_TOM: {
          AttributeName: 'DATUM_TOM',
          DisplayLabel: 'Till datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        RESERV_ATTESTOMRADE_ID: {
          AttributeName: 'RESERV_ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde reserv',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESERV_ATTESTRATT_LOPNR: {
          AttributeName: 'RESERV_ATTESTRATT_LOPNR',
          DisplayLabel: 'Attesträtt löpnummer reserv',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        Reserv: {
          AttributeName: 'Reserv',
          DisplayLabel: 'Reserv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Frånvaroperiod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestgruppid: {
          AttributeName: 'Attestgruppid',
          DisplayLabel: 'Attestgruppid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOSKAPAD: {
          AttributeName: 'AUTOSKAPAD',
          DisplayLabel: 'Automatiskt, skapad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AUTOSKAPAD_ATTESTOMRADE_ID: {
          AttributeName: 'AUTOSKAPAD_ATTESTOMRADE_ID',
          DisplayLabel: 'Autoskapad från, attestområde id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOSKAPAD_ATTESTRATT_LOPNR: {
          AttributeName: 'AUTOSKAPAD_ATTESTRATT_LOPNR',
          DisplayLabel: 'Autoskapad från, attesträtt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOSKAPAD_LEVEL: {
          AttributeName: 'AUTOSKAPAD_LEVEL',
          DisplayLabel: 'Autoskapad, nivå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELEGERA_VIDARE: {
          AttributeName: 'DELEGERA_VIDARE',
          DisplayLabel: 'Delegera vidare(används inte ännu)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AttestantId: {
          AttributeName: 'AttestantId',
          DisplayLabel: 'AttestantId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DelegeradFranPath: {
          AttributeName: 'DelegeradFranPath',
          DisplayLabel: 'Delegeringsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradFranPathSort: {
          AttributeName: 'DelegeradFranPathSort',
          DisplayLabel: 'Delegeringsväg, med datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradReservForPath: {
          AttributeName: 'DelegeradReservForPath',
          DisplayLabel: 'Reserv för delegeringsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradReservForPathSort: {
          AttributeName: 'DelegeradReservForPathSort',
          DisplayLabel: 'Reserv för delegeringsväg, med datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TomDatumStr: {
          AttributeName: 'TomDatumStr',
          DisplayLabel: 'TomDatumStr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TomDatum: {
          AttributeName: 'TomDatum',
          DisplayLabel: 'TomDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
      },
      Associations: {
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Reserv: {
          AssociationName: 'Reserv',
          DisplayLabel: 'Reserv',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AutoskapadFran: {
          AssociationName: 'AutoskapadFran',
          DisplayLabel: 'Delegerad från',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRBetalredovisningAvrakning: {
      CollectionName: 'LRBetalredovisningAvrakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetalredovisningAvrakning',
        Abstract: false,
        SOLabel: 'Avräkning',
        SOGLabel: 'Avräknings',
        SBLabel: 'Avräkningen',
        SBGLabel: 'Avräkningens',
        POLabel: 'Avräkningar',
        POGLabel: 'Avräkningars',
        PBLabel: 'Avräkningarna',
        PBGLabel: 'Avräkningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avräkningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avräkningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avräkningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_ID: {
          AttributeName: 'FIL_ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        POST_LOPNR: {
          AttributeName: 'POST_LOPNR',
          DisplayLabel: 'Löpnummer, post',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TRANSKOD: {
          AttributeName: 'TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRBeloppsattest: {
      CollectionName: 'LRBeloppsattest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Beloppsattest',
        Abstract: false,
        SOLabel: 'Beloppsattest',
        SOGLabel: 'Beloppsattest',
        SBLabel: 'Beloppsattesten',
        SBGLabel: 'Beloppsattesten',
        POLabel: 'Beloppsattester',
        POGLabel: 'Beloppsattester',
        PBLabel: 'Beloppsattesterna',
        PBGLabel: 'Beloppsattesterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Beloppsattesten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Beloppsattesten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Beloppsattesten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestant: {
          AttributeName: 'Attestant',
          DisplayLabel: 'Attestant',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Fakturaattest: {
          AssociationName: 'Fakturaattest',
          DisplayLabel: 'Fakturaattest',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRFakturaAttest',
          AssociatedComponentName: 'Fakturaattest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRBetalning: {
      CollectionName: 'LRBetalning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalning',
        Abstract: false,
        SOLabel: 'Betalning',
        SOGLabel: 'Betalning',
        SBLabel: 'Betalningen',
        SBGLabel: 'Betalningen',
        POLabel: 'Betalningar',
        POGLabel: 'Betalningar',
        PBLabel: 'Betalningarna',
        PBGLabel: 'Betalningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLAN_UTBET_DATUM: {
          AttributeName: 'PLAN_UTBET_DATUM',
          DisplayLabel: 'Planerat utbetalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+36m";MinDate="-12m";MaxRecommendedDate="+3m";MinRecommendedDate="-0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        UTBET_DATUM: {
          AttributeName: 'UTBET_DATUM',
          DisplayLabel: 'Utbetalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VALUTA_BELOPP: {
          AttributeName: 'VALUTA_BELOPP',
          DisplayLabel: 'Belopp i valuta',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BETALNINGSUPPDRAG_ID: {
          AttributeName: 'BETALNINGSUPPDRAG_ID',
          DisplayLabel: 'Betalningsuppdrag ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Betalningsstatus',
          Hint: 'Ankomstregistrerad/Definitivbokad/Spärrad/På väg till betalning/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['ANKOMSTREGISTRERAD', 'Ankomstregistrerad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['SPARRAD', 'Spärrad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['ANKOMSTREGISTRERAD', 'A'], ['DEFINITIVBOKAD', 'D'], ['SPARRAD', 'S'], ['PA_VAG_TILL_BETALNING', 'P'], ['BETALD', 'B'], ['MAKULERAD', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANKOMSTREGISTRERAD=Ankomstregistrerad;DEFINITIVBOKAD=Definitivbokad;SPARRAD=Spärrad;PA_VAG_TILL_BETALNING=På väg till betalning;BETALD=Betald;MAKULERAD=Makulerad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        HANDELSE_BOKF_GRUPP_ID: {
          AttributeName: 'HANDELSE_BOKF_GRUPP_ID',
          DisplayLabel: 'Betalningens bokf.grupp id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Betalningens händelseid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETSATT_ID: {
          AttributeName: 'BETSATT_ID',
          DisplayLabel: 'Utbetalningssätt ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        OCR: {
          AttributeName: 'OCR',
          DisplayLabel: 'OCR',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BANK_ID: {
          AttributeName: 'BANK_ID',
          DisplayLabel: 'Bank ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTO_NR: {
          AttributeName: 'KONTO_NR',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        UTB_EXPRESS: {
          AttributeName: 'UTB_EXPRESS',
          DisplayLabel: 'Utbetalning express',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        RIKSBANKSKOD: {
          AttributeName: 'RIKSBANKSKOD',
          DisplayLabel: 'Riksbankskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VALUTA_FICKA: {
          AttributeName: 'VALUTA_FICKA',
          DisplayLabel: 'Valutaficka',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MEDDELANDE_1: {
          AttributeName: 'MEDDELANDE_1',
          DisplayLabel: 'Meddelande 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 27,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MEDDELANDE_2: {
          AttributeName: 'MEDDELANDE_2',
          DisplayLabel: 'Meddelande 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MEDDELANDE_3: {
          AttributeName: 'MEDDELANDE_3',
          DisplayLabel: 'Meddelande 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_4: {
          AttributeName: 'MEDDELANDE_4',
          DisplayLabel: 'Meddelande 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_5: {
          AttributeName: 'MEDDELANDE_5',
          DisplayLabel: 'Meddelande 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_6: {
          AttributeName: 'MEDDELANDE_6',
          DisplayLabel: 'Meddelande 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_7: {
          AttributeName: 'MEDDELANDE_7',
          DisplayLabel: 'Meddelande 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_8: {
          AttributeName: 'MEDDELANDE_8',
          DisplayLabel: 'Meddelande 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        MEDDELANDE_9: {
          AttributeName: 'MEDDELANDE_9',
          DisplayLabel: 'Meddelande 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BETALT_BELOPP: {
          AttributeName: 'BETALT_BELOPP',
          DisplayLabel: 'Betalt belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        BELASTNINGSKOD: {
          AttributeName: 'BELASTNINGSKOD',
          DisplayLabel: 'Belastningskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AVGIFTSKOD: {
          AttributeName: 'AVGIFTSKOD',
          DisplayLabel: 'Avgiftskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MATCHNINGS_KOD: {
          AttributeName: 'MATCHNINGS_KOD',
          DisplayLabel: 'Matchningskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Utbetalningsvag: {
          AttributeName: 'Utbetalningsvag',
          DisplayLabel: 'Utbetalningsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SkickadDatum: {
          AttributeName: 'SkickadDatum',
          DisplayLabel: 'Skickad datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Leverantor: {
          AttributeName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UtbetsattBank: {
          AttributeName: 'UtbetsattBank',
          DisplayLabel: 'UtbetsattBank',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Utbetalningssatt: {
          AttributeName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturadatum: {
          AttributeName: 'Fakturadatum',
          DisplayLabel: 'Fakturadatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Forfallodatum: {
          AttributeName: 'Forfallodatum',
          DisplayLabel: 'Förfallodatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RegVernr: {
          AttributeName: 'RegVernr',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RegValutaId: {
          AttributeName: 'RegValutaId',
          DisplayLabel: 'RegValutaid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegBokfgruppId: {
          AttributeName: 'RegBokfgruppId',
          DisplayLabel: 'RegBokfgruppID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FakturaRubrik: {
          AttributeName: 'FakturaRubrik',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        leverantorNamn: {
          AttributeName: 'leverantorNamn',
          DisplayLabel: 'leverantör',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturatyp: {
          AttributeName: 'Fakturatyp',
          DisplayLabel: 'Fakturatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS_ELEKTRONISK_BETALNING: {
          AttributeName: 'STATUS_ELEKTRONISK_BETALNING',
          DisplayLabel: 'Status, elektronisk betalning',
          Hint: 'Skickad/Mottagen/Felaktig/Ej skickad/Betald',
          DataType: 'Enum',
          EnumValues: new Map([['SKICKAD', 'Skickad'], ['MOTTAGEN', 'Mottagen'], ['FELAKTIG', 'Felaktig'], ['EJ_SKICKAD', 'Ej skickad'], ['BETALD', 'Betald']]),
          EnumSortValues: new Map([['SKICKAD', 'S'], ['MOTTAGEN', 'M'], ['FELAKTIG', 'F'], ['EJ_SKICKAD', 'E'], ['BETALD', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKICKAD=Skickad;MOTTAGEN=Mottagen;FELAKTIG=Felaktig;EJ_SKICKAD=Ej skickad;BETALD=Betald"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FELTEXT: {
          AttributeName: 'FELTEXT',
          DisplayLabel: 'Feltext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTBETBEKRAFTELSE_ID: {
          AttributeName: 'UTBETBEKRAFTELSE_ID',
          DisplayLabel: 'UTBETBEKRAFTELSE_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VARNING_IGNORERA: {
          AttributeName: 'VARNING_IGNORERA',
          DisplayLabel: 'Ignorera varning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VARNING_SIGNATUR: {
          AttributeName: 'VARNING_SIGNATUR',
          DisplayLabel: 'Varning, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VARNING_DATUM: {
          AttributeName: 'VARNING_DATUM',
          DisplayLabel: 'Varning, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MatchadMotDebet: {
          AttributeName: 'MatchadMotDebet',
          DisplayLabel: 'Matchad mot debetfaktura',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UseOCR: {
          AttributeName: 'UseOCR',
          DisplayLabel: 'OCR',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        UseOCR2: {
          AttributeName: 'UseOCR2',
          DisplayLabel: 'OCR -  intern användning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UTLAND_BETSATT_TYP: {
          AttributeName: 'UTLAND_BETSATT_TYP',
          DisplayLabel: 'Typ av utlandsbetalning',
          Hint: 'IBAN/BBAN',
          DataType: 'Enum',
          EnumValues: new Map([['IBAN', 'IBAN'], ['BBAN', 'BBAN']]),
          EnumSortValues: new Map([['IBAN', 'I'], ['BBAN', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="IBAN=IBAN;BBAN=BBAN"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MatchadMotFaktura: {
          AttributeName: 'MatchadMotFaktura',
          DisplayLabel: 'Matchad mot faktura',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AUTOGIRO: {
          AttributeName: 'AUTOGIRO',
          DisplayLabel: 'Autogiro',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Betalningsuppdrag: {
          AssociationName: 'Betalningsuppdrag',
          DisplayLabel: 'Utbetalningsorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalningsuppdrag',
          AssociatedComponentName: 'Betalningsuppdrag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Utbetalningssatt: {
          AssociationName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRBetalredovisning: {
      CollectionName: 'LRBetalredovisning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningsredovisning',
        Abstract: false,
        SOLabel: 'Betalningsredovisning',
        SOGLabel: 'Betalningsredovisnings',
        SBLabel: 'Betalningsredovisningen',
        SBGLabel: 'Betalningsredovisningens',
        POLabel: 'Betalningsredovisningar',
        POGLabel: 'Betalningsredovisningars',
        PBLabel: 'Betalningsredovisningarna',
        PBGLabel: 'Betalningsredovisningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningsredovisningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningsredovisningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningsredovisningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Betalningsspecifikation/Felaktiga betalningar/Debiteringsbesked/Avvisade betalningar/Makulerade betalningar/Stoppade betalningar/ISO20022',
          DataType: 'Enum',
          EnumValues: new Map([['BETALNINGSSPECIFIKATION', 'Betalningsspecifikation'], ['FELAKTIGA_BETALNINGAR', 'Felaktiga betalningar'], ['DEBITERINGSBESKED', 'Debiteringsbesked'], ['AVVISADE_BETALNINGAR', 'Avvisade betalningar'], ['MAKULERADE_BETALNINGAR', 'Makulerade betalningar'], ['STOPPADE_BETALNINGAR', 'Stoppade betalningar'], ['ISO20022', 'ISO20022']]),
          EnumSortValues: new Map([['BETALNINGSSPECIFIKATION', 'B'], ['FELAKTIGA_BETALNINGAR', 'F'], ['DEBITERINGSBESKED', 'D'], ['AVVISADE_BETALNINGAR', 'A'], ['MAKULERADE_BETALNINGAR', 'M'], ['STOPPADE_BETALNINGAR', 'S'], ['ISO20022', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALNINGSSPECIFIKATION=Betalningsspecifikation;FELAKTIGA_BETALNINGAR=Felaktiga betalningar;DEBITERINGSBESKED=Debiteringsbesked;AVVISADE_BETALNINGAR=Avvisade betalningar;MAKULERADE_BETALNINGAR=Makulerade betalningar;STOPPADE_BETALNINGAR=Stoppade betalningar;ISO20022=ISO20022"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BG_INL_TRANSKOD: {
          AttributeName: 'BG_INL_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_AVSBGNR: {
          AttributeName: 'BG_INL_AVSBGNR',
          DisplayLabel: 'Avsändarens bankgironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_SKRIVDATUM: {
          AttributeName: 'BG_INL_SKRIVDATUM',
          DisplayLabel: 'Skrivdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_PRODUKT: {
          AttributeName: 'BG_INL_PRODUKT',
          DisplayLabel: 'Produkt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 22,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_BETDATUM: {
          AttributeName: 'BG_INL_BETDATUM',
          DisplayLabel: 'Betalningsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_REDOVISNINGSKOD: {
          AttributeName: 'BG_INL_REDOVISNINGSKOD',
          DisplayLabel: 'Redovisningskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_INL_VALUTAKOD: {
          AttributeName: 'BG_INL_VALUTAKOD',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVS_TRANSKOD: {
          AttributeName: 'BG_AVS_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVS_AVSBGNR: {
          AttributeName: 'BG_AVS_AVSBGNR',
          DisplayLabel: 'Avsändarens bankgironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVS_ANTALBETPOSTER: {
          AttributeName: 'BG_AVS_ANTALBETPOSTER',
          DisplayLabel: 'Antal betalningsposter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVS_TOTALBELOPP: {
          AttributeName: 'BG_AVS_TOTALBELOPP',
          DisplayLabel: 'Totalbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_SERVBYRANR: {
          AttributeName: 'PG_SERVBYRANR',
          DisplayLabel: 'Servicebyrånummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_KUNDNR: {
          AttributeName: 'PG_KUNDNR',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_AVSKONTO: {
          AttributeName: 'PG_AVSKONTO',
          DisplayLabel: 'Avsändarkonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_REDOVMOTTAGARE: {
          AttributeName: 'PG_REDOVMOTTAGARE',
          DisplayLabel: 'Redovisningsmottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 27,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_ATERREDDATUM: {
          AttributeName: 'PG_ATERREDDATUM',
          DisplayLabel: 'Återredovisningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_VALUTAFICKA: {
          AttributeName: 'PG_VALUTAFICKA',
          DisplayLabel: 'Valutaficka',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_BELOPPSVALUTA: {
          AttributeName: 'PG_BELOPPSVALUTA',
          DisplayLabel: 'Beloppsvaluta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AvsandarKonto: {
          AttributeName: 'AvsandarKonto',
          DisplayLabel: 'Avsändarkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Datum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fildatum: {
          AttributeName: 'Fildatum',
          DisplayLabel: 'Fildatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
        },
        FIL_ID: {
          AttributeName: 'FIL_ID',
          DisplayLabel: 'Fil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Totalbelopp: {
          AttributeName: 'Totalbelopp',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        PG_PO3_INL_POSTTYP: {
          AttributeName: 'PG_PO3_INL_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_INL_AVSORGNR: {
          AttributeName: 'PG_PO3_INL_AVSORGNR',
          DisplayLabel: 'Avsändarens orgnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_INL_AVSKONTONR: {
          AttributeName: 'PG_PO3_INL_AVSKONTONR',
          DisplayLabel: 'Avsändarens kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_INL_VALUTA: {
          AttributeName: 'PG_PO3_INL_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_INL_VALUTAFICKA: {
          AttributeName: 'PG_PO3_INL_VALUTAFICKA',
          DisplayLabel: 'Valutaficka',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_AVS_POSTTYP: {
          AttributeName: 'PG_PO3_AVS_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_AVS_ANTALBET: {
          AttributeName: 'PG_PO3_AVS_ANTALBET',
          DisplayLabel: 'Antal betalningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 7,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_PO3_AVS_SUMMABELOPP: {
          AttributeName: 'PG_PO3_AVS_SUMMABELOPP',
          DisplayLabel: 'Summabelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AntalTrans: {
          AttributeName: 'AntalTrans',
          DisplayLabel: 'Antal transaktioner',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PG_DA1_INL_POSTTYP: {
          AttributeName: 'PG_DA1_INL_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_AVSORGNR: {
          AttributeName: 'PG_DA1_INL_AVSORGNR',
          DisplayLabel: 'Avsändarens orgnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_DEBADV: {
          AttributeName: 'PG_DA1_INL_DEBADV',
          DisplayLabel: 'DEBADV',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_AVSKONTONR: {
          AttributeName: 'PG_DA1_INL_AVSKONTONR',
          DisplayLabel: 'Avsändarens kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_BOKFDAG: {
          AttributeName: 'PG_DA1_INL_BOKFDAG',
          DisplayLabel: 'Bokföringsdag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_VALUTA: {
          AttributeName: 'PG_DA1_INL_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_INL_VALUTAFICKA: {
          AttributeName: 'PG_DA1_INL_VALUTAFICKA',
          DisplayLabel: 'Valutaficka',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_AVS_POSTTYP: {
          AttributeName: 'PG_DA1_AVS_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_AVS_ANTALBET: {
          AttributeName: 'PG_DA1_AVS_ANTALBET',
          DisplayLabel: 'Antal betalningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 7,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DA1_AVS_TOTBELOPP: {
          AttributeName: 'PG_DA1_AVS_TOTBELOPP',
          DisplayLabel: 'Totalt belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_FASTINFO_TRANSKOD: {
          AttributeName: 'BG_FASTINFO_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_FASTINFO_INFOTEXT: {
          AttributeName: 'BG_FASTINFO_INFOTEXT',
          DisplayLabel: 'Informationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_FASTINFO_SLUTDATUM: {
          AttributeName: 'BG_FASTINFO_SLUTDATUM',
          DisplayLabel: 'Slutdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAD: {
          AttributeName: 'HANTERAD',
          DisplayLabel: 'Hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAD_DATUM: {
          AttributeName: 'HANTERAD_DATUM',
          DisplayLabel: 'Hanterad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HANTERAD_SIGN: {
          AttributeName: 'HANTERAD_SIGN',
          DisplayLabel: 'Hanterad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Hanterad_Text: {
          AttributeName: 'Hanterad_Text',
          DisplayLabel: 'Hanterad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ISO_MSGID: {
          AttributeName: 'ISO_MSGID',
          DisplayLabel: 'MsgId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_GRPHDR_CREDTTM: {
          AttributeName: 'ISO_GRPHDR_CREDTTM',
          DisplayLabel: 'GrpHdr_CreDtTm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_MSGRCPT_ID: {
          AttributeName: 'ISO_MSGRCPT_ID',
          DisplayLabel: 'MsgRcpt_Id_OrgId_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_MSGRCPT_CD: {
          AttributeName: 'ISO_MSGRCPT_CD',
          DisplayLabel: 'MsgRcpt_Id_OrgId_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_GRPHDR_ADDTLINF: {
          AttributeName: 'ISO_GRPHDR_ADDTLINF',
          DisplayLabel: 'GrpHdr_AddtlInf',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_ID: {
          AttributeName: 'ISO_ACCT_ID',
          DisplayLabel: 'Acct_Id_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_SCHMENM_CD: {
          AttributeName: 'ISO_ACCT_SCHMENM_CD',
          DisplayLabel: 'Acct_Id_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_SCHMENM_PRTRY: {
          AttributeName: 'ISO_ACCT_SCHMENM_PRTRY',
          DisplayLabel: 'Acct_Id_Othr_SchmeNm_Prtry',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_CCY: {
          AttributeName: 'ISO_ACCT_CCY',
          DisplayLabel: 'Acct_Ccy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_NM: {
          AttributeName: 'ISO_ACCT_OWNR_NM',
          DisplayLabel: 'Acct_Ownr_Nm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_ID: {
          AttributeName: 'ISO_ACCT_OWNR_ID',
          DisplayLabel: 'Acct_Ownr_Id_OrgId_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_CD: {
          AttributeName: 'ISO_ACCT_OWNR_CD',
          DisplayLabel: 'Acct_Ownr_Id_OrgId_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_SVCR_BIC: {
          AttributeName: 'ISO_SVCR_BIC',
          DisplayLabel: 'Acct_Svcr_FinInstnId_BIC',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_NBOFNTRIES: {
          AttributeName: 'ISO_NBOFNTRIES',
          DisplayLabel: 'Ntfctn_NbOfNtries',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_SUM: {
          AttributeName: 'ISO_SUM',
          DisplayLabel: 'Ntfctn_Sum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Betalningsdatum: {
          AttributeName: 'Betalningsdatum',
          DisplayLabel: 'Betalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
        },
        Totalbelopp_ISO: {
          AttributeName: 'Totalbelopp_ISO',
          DisplayLabel: 'Totalbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kommunikationsfil: {
          AssociationName: 'Kommunikationsfil',
          DisplayLabel: 'Kommunikationsfil',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKommunikationsfil',
          AssociatedComponentName: 'Kommunikationsfil',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        Post: {
          AssociationName: 'Post',
          DisplayLabel: 'Post',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningPost',
          AssociatedComponentName: 'BetalredovisningPost',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LRBetalredovisningDebKreb: {
      CollectionName: 'LRBetalredovisningDebKreb',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetalredovisningDebKreb',
        Abstract: false,
        SOLabel: 'BetalredovisningDebKreb',
        SOGLabel: 'BetalredovisningDebKreb',
        SBLabel: 'BetalredovisningDebKreb',
        SBGLabel: 'BetalredovisningDebKreb',
        POLabel: 'BetalredovisningDebKreb',
        POGLabel: 'BetalredovisningDebKreb',
        PBLabel: 'BetalredovisningDebKreb',
        PBGLabel: 'BetalredovisningDebKreb',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BetalredovisningDebKreb primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BetalredovisningDebKreb versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BetalredovisningDebKreb fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        POSTTYP: {
          AttributeName: 'POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REF: {
          AttributeName: 'REF',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Debet/Kredit',
          DataType: 'Enum',
          EnumValues: new Map([['DEBET', 'Debet'], ['KREDIT', 'Kredit']]),
          EnumSortValues: new Map([['DEBET', 'D'], ['KREDIT', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBET=Debet;KREDIT=Kredit"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        EGENREF: {
          AttributeName: 'EGENREF',
          DisplayLabel: 'Egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 28,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BETALNING_BOKF_GRUPP_ID: {
          AttributeName: 'BETALNING_BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BETALNING_LEVFAKT_ID: {
          AttributeName: 'BETALNING_LEVFAKT_ID',
          DisplayLabel: 'Leverantörsfaktura',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BETALNING_LOPNR: {
          AttributeName: 'BETALNING_LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FormatBelopp: {
          AttributeName: 'FormatBelopp',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        VER_BOKF_AR: {
          AttributeName: 'VER_BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VER_VER_NR: {
          AttributeName: 'VER_VER_NR',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Post: {
          AssociationName: 'Post',
          DisplayLabel: 'Post',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningPost',
          AssociatedComponentName: 'BetalredovisningPost',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LRFakturaDok: {
      CollectionName: 'LRFakturaDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'FakturaDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokument',
        SBGLabel: 'Dokument',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokument',
        PBGLabel: 'Dokument',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokument primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokument versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokument id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokument fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTURABILAGA_ID: {
          AttributeName: 'FAKTURABILAGA_ID',
          DisplayLabel: 'Fakturabilaga',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        fakturabilagor: {
          AssociationName: 'fakturabilagor',
          DisplayLabel: 'Fakturabilagor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabilaga',
          AssociatedComponentName: 'Fakturabilaga',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturaAttest: {
      CollectionName: 'LRFakturaAttest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17001,17002,2060']]),
      RootType: {
        TypeValue: 'FakturaAttest',
        Abstract: false,
        SOLabel: 'Faktura attest',
        SOGLabel: 'Faktura attest',
        SBLabel: 'Faktura attesten',
        SBGLabel: 'Faktura attesten',
        POLabel: 'Faktura attester',
        POGLabel: 'Faktura attester',
        PBLabel: 'Faktura attesterna',
        PBGLabel: 'Faktura attesterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Faktura attesten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Faktura attesten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Faktura attesten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVFAKTURA_ID: {
          AttributeName: 'LEVFAKTURA_ID',
          DisplayLabel: 'Faktura',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Mottagningsattest/Beslutsattest',
          DataType: 'Enum',
          EnumValues: new Map([['MOTTAGNINGSATTEST', 'Mottagningsattest'], ['BESLUTSATTEST', 'Beslutsattest']]),
          EnumSortValues: new Map([['MOTTAGNINGSATTEST', 'M'], ['BESLUTSATTEST', 'B']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MOTTAGNINGSATTEST=Mottagningsattest;BESLUTSATTEST=Beslutsattest"',
          InterfaceType: 'ifChecklist',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Attestområde löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESERV_ID: {
          AttributeName: 'RESERV_ID',
          DisplayLabel: 'Reserv',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESERV_LOPNR: {
          AttributeName: 'RESERV_LOPNR',
          DisplayLabel: 'Reserv löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Atteststatus',
          Hint: 'Attesterad/I utkorg/Hos central administratör/Under utredning/Utdelad',
          DataType: 'Enum',
          EnumValues: new Map([['ATTESTERAD', 'Attesterad'], ['I_UTKORG', 'I utkorg'], ['HOS_CENTRAL_ADMINISTRATOR', 'Hos central administratör'], ['UNDER_UTREDNING', 'Under utredning'], ['UTDELAD', 'Utdelad']]),
          EnumSortValues: new Map([['ATTESTERAD', 'G'], ['I_UTKORG', 'P'], ['HOS_CENTRAL_ADMINISTRATOR', 'M'], ['UNDER_UTREDNING', 'R'], ['UTDELAD', 'U']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATTESTERAD=Attesterad;I_UTKORG=I utkorg;HOS_CENTRAL_ADMINISTRATOR=Hos central administratör;UNDER_UTREDNING=Under utredning;UTDELAD=Utdelad"',
          InterfaceType: 'ifChecklist',
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Statusdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Reserv: {
          AttributeName: 'Reserv',
          DisplayLabel: 'Reserv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestgrupp: {
          AttributeName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Attestant: {
          AttributeName: 'Attestant',
          DisplayLabel: 'Attestant',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestNamnTitel: {
          AttributeName: 'AttestNamnTitel',
          DisplayLabel: 'AttestNamnTitel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestSignTitel: {
          AttributeName: 'AttestSignTitel',
          DisplayLabel: 'AttestSignTitel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ReservSignTitel: {
          AttributeName: 'ReservSignTitel',
          DisplayLabel: 'ReservSignTitel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestantSign: {
          AttributeName: 'AttestantSign',
          DisplayLabel: 'Attestant, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ReservSign: {
          AttributeName: 'ReservSign',
          DisplayLabel: 'Reserv, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalDgrStatusAndrad: {
          AttributeName: 'AntalDgrStatusAndrad',
          DisplayLabel: 'Antal dgr efter statusdatum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        Fakturabelopp2: {
          AttributeName: 'Fakturabelopp2',
          DisplayLabel: 'Fakturabelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        PAMINNELSE_DATUM: {
          AttributeName: 'PAMINNELSE_DATUM',
          DisplayLabel: 'Senaste påminnelse',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        AttesteratBelopp: {
          AttributeName: 'AttesteratBelopp',
          DisplayLabel: 'Attesterat belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        STATUS_TID: {
          AttributeName: 'STATUS_TID',
          DisplayLabel: 'Statustid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTROLLATTEST: {
          AttributeName: 'KONTROLLATTEST',
          DisplayLabel: 'Kontrollattest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AttestTyp: {
          AttributeName: 'AttestTyp',
          DisplayLabel: 'AttestTyp',
          Hint: 'Mottagningsattest/Beslutsattest/Kontrollattest',
          DataType: 'Enum',
          EnumValues: new Map([['MOTTAGNINGSATTEST', 'Mottagningsattest'], ['BESLUTSATTEST', 'Beslutsattest'], ['KONTROLLATTEST', 'Kontrollattest']]),
          EnumSortValues: new Map([['MOTTAGNINGSATTEST', 'M'], ['BESLUTSATTEST', 'B'], ['KONTROLLATTEST', 'K']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MOTTAGNINGSATTEST=Mottagningsattest;BESLUTSATTEST=Beslutsattest;KONTROLLATTEST=Kontrollattest"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Reserv: {
          AssociationName: 'Reserv',
          DisplayLabel: 'Reserv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturadel: {
          AssociationName: 'Fakturadel',
          DisplayLabel: 'Fakturadel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRFakturaDel',
          AssociatedComponentName: 'FakturaDel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Beloppsattest: {
          AssociationName: 'Beloppsattest',
          DisplayLabel: 'Beloppsattester',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBeloppsattest',
          AssociatedComponentName: 'Beloppsattest',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Beloppsrader: {
          AssociationName: 'Beloppsrader',
          DisplayLabel: 'Beloppsrader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRKonteringsForslag',
          AssociatedComponentName: 'Konteringsforslag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturabilaga: {
      CollectionName: 'LRFakturabilaga',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturabilaga',
        Abstract: false,
        SOLabel: 'Fakturabilaga',
        SOGLabel: 'Fakturabilagas',
        SBLabel: 'Fakturabilagan',
        SBGLabel: 'Fakturabilagans',
        POLabel: 'Fakturabilagor',
        POGLabel: 'Fakturabilagors',
        PBLabel: 'Fakturabilagorna',
        PBGLabel: 'Fakturabilagornas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturabilagans primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturabilagans versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturabilagans id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturabilagans fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURABILD_ID: {
          AttributeName: 'FAKTURABILD_ID',
          DisplayLabel: 'FAKTURABILD_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        URL: {
          AttributeName: 'URL',
          DisplayLabel: 'URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        hamtad: {
          AttributeName: 'hamtad',
          DisplayLabel: 'Hämtad till fakturadokument',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Fakturabunt: {
          AssociationName: 'Fakturabunt',
          DisplayLabel: 'Fakturabunt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabunt',
          AssociatedComponentName: 'Fakturabunt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturabild: {
      CollectionName: 'LRFakturabild',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Fakturabild',
        Abstract: false,
        SOLabel: 'Fakturabild',
        SOGLabel: 'Fakturabild',
        SBLabel: 'Fakturabilden',
        SBGLabel: 'Fakturabilden',
        POLabel: 'Fakturabilder',
        POGLabel: 'Fakturabilder',
        PBLabel: 'Fakturabilderna',
        PBGLabel: 'Fakturabilderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturabilden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturabilden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturabilden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUNT_ID: {
          AttributeName: 'BUNT_ID',
          DisplayLabel: 'Bunt id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_NAMN: {
          AttributeName: 'FIL_NAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_DATUM: {
          AttributeName: 'FIL_DATUM',
          DisplayLabel: 'Fil, datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FIL_KLOCKSLAG: {
          AttributeName: 'FIL_KLOCKSLAG',
          DisplayLabel: 'Fil, klockslag',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FAKTURA_BOKF_GRUPP_ID: {
          AttributeName: 'FAKTURA_BOKF_GRUPP_ID',
          DisplayLabel: 'Fakturans bokf. grupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_ID: {
          AttributeName: 'FAKTURA_ID',
          DisplayLabel: 'Faktura, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIDNR: {
          AttributeName: 'SIDNR',
          DisplayLabel: 'Sidnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INVOICE_ID: {
          AttributeName: 'INVOICE_ID',
          DisplayLabel: 'Inläst, id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        INVOICE_DATESTR: {
          AttributeName: 'INVOICE_DATESTR',
          DisplayLabel: 'Inläst, datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
          AttributeGroup: 'Inläst',
        },
        INVOICE_TIMESTR: {
          AttributeName: 'INVOICE_TIMESTR',
          DisplayLabel: 'Inläst, tid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INVOICE_DEBKRED: {
          AttributeName: 'INVOICE_DEBKRED',
          DisplayLabel: 'Inläst, debet/kredit',
          Hint: 'Debet/Kredit',
          DataType: 'Enum',
          EnumValues: new Map([['DEBET', 'Debet'], ['KREDIT', 'Kredit']]),
          EnumSortValues: new Map([['DEBET', 'D'], ['KREDIT', 'K']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBET=Debet;KREDIT=Kredit"',
          GUIEditable: true,
          AttributeGroup: 'Inläst',
          Required: true,
        },
        INVOICE_FAKTURADATUM: {
          AttributeName: 'INVOICE_FAKTURADATUM',
          DisplayLabel: 'Inläst, fakturadatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Inläst',
        },
        INVOICE_FORFALLODATUM: {
          AttributeName: 'INVOICE_FORFALLODATUM',
          DisplayLabel: 'Inläst, förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Inläst',
        },
        INVOICE_MOMSSATS: {
          AttributeName: 'INVOICE_MOMSSATS',
          DisplayLabel: 'Inläst, momssats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
          AttributeGroup: 'Inläst',
        },
        INVOICE_MOMSBELOPP: {
          AttributeName: 'INVOICE_MOMSBELOPP',
          DisplayLabel: 'Inläst, moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Inläst',
        },
        INVOICE_BRUTTOBELOPP: {
          AttributeName: 'INVOICE_BRUTTOBELOPP',
          DisplayLabel: 'Inläst, bruttobelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Inläst',
        },
        INVOICE_VALUTA: {
          AttributeName: 'INVOICE_VALUTA',
          DisplayLabel: 'Inläst, valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_BANKGIRONR: {
          AttributeName: 'INVOICE_BANKGIRONR',
          DisplayLabel: 'Inläst, bankgironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_FAKTURANR: {
          AttributeName: 'INVOICE_FAKTURANR',
          DisplayLabel: 'Inläst, fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 27,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        INVOICE_PLUSGIRONR: {
          AttributeName: 'INVOICE_PLUSGIRONR',
          DisplayLabel: 'Inläst, plusgironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_ER_REF: {
          AttributeName: 'INVOICE_ER_REF',
          DisplayLabel: 'Inläst, er referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_KUNDNR: {
          AttributeName: 'INVOICE_KUNDNR',
          DisplayLabel: 'Inläst, kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        calcStatus: {
          AttributeName: 'calcStatus',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcStorlek: {
          AttributeName: 'calcStorlek',
          DisplayLabel: 'Storlek (kB)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        AntalSidor: {
          AttributeName: 'AntalSidor',
          DisplayLabel: 'AntalSidor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Sida: {
          AttributeName: 'Sida',
          DisplayLabel: 'Sida',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAGD_AT_SIDAN: {
          AttributeName: 'LAGD_AT_SIDAN',
          DisplayLabel: 'Fakturan lagd åt sidan',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        INVOICE_BUNTNR: {
          AttributeName: 'INVOICE_BUNTNR',
          DisplayLabel: 'Inläst, buntnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_ANKOMSTDATUM: {
          AttributeName: 'INVOICE_ANKOMSTDATUM',
          DisplayLabel: 'Inläst, ankomstdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Inläst',
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Format',
          Hint: 'JPEG/JPG/TIF/TIFF/TIF/TIFF/BMP/Invoice/INV/KOB/Svefaktura',
          DataType: 'Enum',
          EnumValues: new Map([['JPEG', 'JPEG'], ['JPG', 'JPG'], ['TIF', 'TIF'], ['TIFF', 'TIFF'], ['TIF_TIFF', 'TIF/TIFF'], ['BMP', 'BMP'], ['INVOICE', 'Invoice'], ['INV', 'INV'], ['KOB', 'KOB'], ['SVEFAKTURA', 'Svefaktura']]),
          EnumSortValues: new Map([['JPEG', 'JPG'], ['JPG', 'JPG'], ['TIF', 'TIF'], ['TIFF', 'TIF'], ['TIF_TIFF', 'TIF'], ['BMP', 'BMP'], ['INVOICE', 'INV'], ['INV', 'INV'], ['KOB', 'KOB'], ['SVEFAKTURA', 'SVE']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JPEG=JPEG;JPG=JPG;TIF=TIF;TIFF=TIFF;TIF_TIFF=TIF/TIFF;BMP=BMP;INVOICE=Invoice;INV=INV;KOB=KOB;SVEFAKTURA=Svefaktura"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        ORG_NR: {
          AttributeName: 'ORG_NR',
          DisplayLabel: 'Leverantörens organisationsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatOrgNr',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Inläst',
        },
        INVOICE_MOTTAGANDE_ENHET: {
          AttributeName: 'INVOICE_MOTTAGANDE_ENHET',
          DisplayLabel: 'Inläst, mottagande enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Inläst',
        },
        INVOICE_FAKTURAKOD: {
          AttributeName: 'INVOICE_FAKTURAKOD',
          DisplayLabel: 'Inläst, fakturakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Inläst',
        },
        ElektroniskFaktura: {
          AttributeName: 'ElektroniskFaktura',
          DisplayLabel: 'Elektronisk faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        ORGANISATIONSAR: {
          AttributeName: 'ORGANISATIONSAR',
          DisplayLabel: 'KOB, organisationsår',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1900";MaxValue="2100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Inläst',
        },
        KOB_PERS_NR: {
          AttributeName: 'KOB_PERS_NR',
          DisplayLabel: 'KOB, personnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Inläst',
        },
        REFERENSER: {
          AttributeName: 'REFERENSER',
          DisplayLabel: 'Övriga referenser',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        TILLGANGLIG_DATUM: {
          AttributeName: 'TILLGANGLIG_DATUM',
          DisplayLabel: 'Tillgänglig datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAKULERAD_ELLER_BACKAD: {
          AttributeName: 'MAKULERAD_ELLER_BACKAD',
          DisplayLabel: 'Makulerad/Backad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FA_FELMEDDELANDE: {
          AttributeName: 'FA_FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande vid förenklad ankomstregistrering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        INVOICE_BANKKONTONR: {
          AttributeName: 'INVOICE_BANKKONTONR',
          DisplayLabel: 'Inläst, bankkontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Inläst',
        },
        Fakturaformat: {
          AttributeName: 'Fakturaformat',
          DisplayLabel: 'Fakturaformat',
          Hint: 'KOB\0A-faktura/Skannad och tolkad/E-faktura/Bild, JPG/Bild, Tif/Bild, BMP/Bild, ReadSoft',
          DataType: 'Enum',
          EnumValues: new Map([['KOB__FAKTURA', 'KOB\0A-faktura'], ['SKANNAD_OCH_TOLKAD', 'Skannad och tolkad'], ['E_FAKTURA', 'E-faktura'], ['BILD__JPG', 'Bild, JPG'], ['BILD__TIF', 'Bild, Tif'], ['BILD__BMP', 'Bild, BMP'], ['BILD__READSOFT', 'Bild, ReadSoft']]),
          EnumSortValues: new Map([['KOB__FAKTURA', 'KOB'], ['SKANNAD_OCH_TOLKAD', 'TOLKAD'], ['E_FAKTURA', 'EFAKT'], ['BILD__JPG', 'JPG'], ['BILD__TIF', 'TIF'], ['BILD__BMP', 'BMP'], ['BILD__READSOFT', 'INV']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KOB__FAKTURA=KOB#0A-faktura;SKANNAD_OCH_TOLKAD=Skannad och tolkad;E_FAKTURA=E-faktura;BILD__JPG=Bild, JPG;BILD__TIF=Bild, Tif;BILD__BMP=Bild, BMP;BILD__READSOFT=Bild, ReadSoft"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Övrigt',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRFakturabildBlob',
          AssociatedComponentName: 'FakturabildBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturabunt: {
          AssociationName: 'Fakturabunt',
          DisplayLabel: 'Fakturabunt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRFakturabunt',
          AssociatedComponentName: 'Fakturabunt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturakod: {
          AssociationName: 'Fakturakod',
          DisplayLabel: 'Fakturakod',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturakod',
          AssociatedComponentName: 'Fakturakod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        fakturarad: {
          AssociationName: 'fakturarad',
          DisplayLabel: 'Fakturarad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturaRad',
          AssociatedComponentName: 'Fakturarad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturabilaga: {
          AssociationName: 'Fakturabilaga',
          DisplayLabel: 'Fakturabilaga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabilaga',
          AssociatedComponentName: 'Fakturabilaga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturabildBlob: {
      CollectionName: 'LRFakturabildBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FakturabildBlob',
        Abstract: false,
        SOLabel: 'Fakturabild, blob',
        SOGLabel: 'Fakturabild, blob',
        SBLabel: 'Fakturabild, blob',
        SBGLabel: 'Fakturabild, blob',
        POLabel: 'Fakturabild, blob',
        POGLabel: 'Fakturabild, blob',
        PBLabel: 'Fakturabild, blob',
        PBGLabel: 'Fakturabild, blob',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturabild, blob primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturabild, blob versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturabild, blob fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Stretch',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        XML: {
          AttributeName: 'XML',
          DisplayLabel: 'XML',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BildUrler: {
          AttributeName: 'BildUrler',
          DisplayLabel: 'BildUrler',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRFakturabunt: {
      CollectionName: 'LRFakturabunt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'BokfGrupp']]),
      RootType: {
        TypeValue: 'Fakturabunt',
        Abstract: false,
        SOLabel: 'Fakturabunt',
        SOGLabel: 'Fakturabunt',
        SBLabel: 'Fakturabunten',
        SBGLabel: 'Fakturabunten',
        POLabel: 'Fakturabuntar',
        POGLabel: 'Fakturabuntar',
        PBLabel: 'Fakturabuntarna',
        PBGLabel: 'Fakturabuntarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturabunten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturabunten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturabunten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturabunten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUNTNR: {
          AttributeName: 'BUNTNR',
          DisplayLabel: 'Buntnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL_FAKTUROR: {
          AttributeName: 'ANTAL_FAKTUROR',
          DisplayLabel: 'Antal fakturor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BUNTSUMMA: {
          AttributeName: 'BUNTSUMMA',
          DisplayLabel: 'Buntsumma',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
        },
        INLAST_DATUM: {
          AttributeName: 'INLAST_DATUM',
          DisplayLabel: 'Inläst datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        INLAST_KLOCKSLAG: {
          AttributeName: 'INLAST_KLOCKSLAG',
          DisplayLabel: 'Inläst, klockslag',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
          GUIEditable: true,
        },
        INLAST_SIGNATUR: {
          AttributeName: 'INLAST_SIGNATUR',
          DisplayLabel: 'Inläst av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        IMPORTTYP: {
          AttributeName: 'IMPORTTYP',
          DisplayLabel: 'Importtyp',
          Hint: 'Bilder/Invoice-fakturor/KOB/Svefakturor',
          DataType: 'Enum',
          EnumValues: new Map([['BILDER', 'Bilder'], ['INVOICE_FAKTUROR', 'Invoice-fakturor'], ['KOB', 'KOB'], ['SVEFAKTUROR', 'Svefakturor']]),
          EnumSortValues: new Map([['BILDER', 'B'], ['INVOICE_FAKTUROR', 'I'], ['KOB', 'K'], ['SVEFAKTUROR', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BILDER=Bilder;INVOICE_FAKTUROR=Invoice-fakturor;KOB=KOB;SVEFAKTUROR=Svefakturor"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        DatumBuntnr: {
          AttributeName: 'DatumBuntnr',
          DisplayLabel: 'DatumBuntnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XML: {
          AttributeName: 'XML',
          DisplayLabel: 'XML',
          Hint: 'Svefaktura',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURAMOTTAGNINGSVAG_ID: {
          AttributeName: 'FAKTURAMOTTAGNINGSVAG_ID',
          DisplayLabel: 'Fakturamottagningsväg, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        BokfGrupp: {
          AssociationName: 'BokfGrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Fakturamottagningsvag: {
          AssociationName: 'Fakturamottagningsvag',
          DisplayLabel: 'Fakturamottagningsväg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturamottagningsvag',
          AssociatedComponentName: 'Fakturamottagningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturabilder: {
          AssociationName: 'Fakturabilder',
          DisplayLabel: 'Fakturasidor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabild',
          AssociatedComponentName: 'Fakturabild',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturamottagningsvag: {
      CollectionName: 'LRFakturamottagningsvag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturamottagningsvag',
        Abstract: false,
        SOLabel: 'Fakturamottagningsväg',
        SOGLabel: 'Fakturamottagningsvägs',
        SBLabel: 'Fakturamottagningsvägen',
        SBGLabel: 'Fakturamottagningsvägens',
        POLabel: 'Fakturamottagningsvägar',
        POGLabel: 'Fakturamottagningsvägars',
        PBLabel: 'Fakturamottagningsvägarna',
        PBGLabel: 'Fakturamottagningsvägarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturamottagningsvägens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturamottagningsvägens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturamottagningsvägens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturamottagningsvägens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        IMPORTTYP: {
          AttributeName: 'IMPORTTYP',
          DisplayLabel: 'Importtyp',
          Hint: 'Bilder/Invoice-fakturor/KOB/Svefaktura, skannade och tolkade/Svefaktura, direkt från leverantör',
          DataType: 'Enum',
          EnumValues: new Map([['BILDER', 'Bilder'], ['INVOICE_FAKTUROR', 'Invoice-fakturor'], ['KOB', 'KOB'], ['SVEFAKTURA__SKANNADE_OCH_TOLKADE', 'Svefaktura, skannade och tolkade']]),
          EnumSortValues: new Map([['BILDER', 'B'], ['INVOICE_FAKTUROR', 'I'], ['KOB', 'K'], ['SVEFAKTURA__SKANNADE_OCH_TOLKADE', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BILDER=Bilder;INVOICE_FAKTUROR=Invoice-fakturor;KOB=KOB;SVEFAKTURA__SKANNADE_OCH_TOLKADE=Svefaktura, skannade och tolkade"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTKATALOG: {
          AttributeName: 'IMPORTKATALOG',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTBETSATT_ID: {
          AttributeName: 'UTBETSATT_ID',
          DisplayLabel: 'Utbetalningssätt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XSL: {
          AttributeName: 'XSL',
          DisplayLabel: 'XSL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        KalkImportkatalog: {
          AttributeName: 'KalkImportkatalog',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        utbetalningssatt: {
          AssociationName: 'utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        bokforingsgrupp: {
          AssociationName: 'bokforingsgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturaRad: {
      CollectionName: 'LRFakturaRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturarad',
        Abstract: false,
        SOLabel: 'Fakturarad',
        SOGLabel: 'Fakturarads',
        SBLabel: 'Fakturaraden',
        SBGLabel: 'Fakturaradens',
        POLabel: 'Fakturarader',
        POGLabel: 'Fakturaraders',
        PBLabel: 'Fakturaraderna',
        PBGLabel: 'Fakturaradernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaradens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaradens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaradens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaradens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD_ID: {
          AttributeName: 'BILD_ID',
          DisplayLabel: 'BILD_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'LOPNR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_NR: {
          AttributeName: 'ARTIKEL_NR',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOB_ARTIKEL_NR: {
          AttributeName: 'KOB_ARTIKEL_NR',
          DisplayLabel: 'KOB-Clearingartikel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KOB_ARTIKEL_ID: {
          AttributeName: 'KOB_ARTIKEL_ID',
          DisplayLabel: 'KOB, Artikelid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        FAKTURARADSKOD_ID: {
          AttributeName: 'FAKTURARADSKOD_ID',
          DisplayLabel: 'Fakturaradskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS: {
          AttributeName: 'MOMS',
          DisplayLabel: 'Moms',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DisplayArtikelNr: {
          AttributeName: 'DisplayArtikelNr',
          DisplayLabel: 'ArtikelNr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        fakturabild: {
          AssociationName: 'fakturabild',
          DisplayLabel: 'Fakturabild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabild',
          AssociatedComponentName: 'Fakturabild',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kobartikel: {
          AssociationName: 'Kobartikel',
          DisplayLabel: 'Kobartikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKOBArtikel',
          AssociatedComponentName: 'Kobartikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaradskod: {
          AssociationName: 'Fakturaradskod',
          DisplayLabel: 'Fakturaradskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFakturaradskod',
          AssociatedComponentName: 'Fakturaradskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestforslagKontering: {
      CollectionName: 'LRAttestforslagKontering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AttestforslagKontering',
        Abstract: false,
        SOLabel: 'Fakturastyrning, kontering',
        SOGLabel: 'Fakturastyrning, kontering',
        SBLabel: 'Fakturastyrning, kontering',
        SBGLabel: 'Fakturastyrning, kontering',
        POLabel: 'Fakturastyrning, kontering',
        POGLabel: 'Fakturastyrning, kontering',
        PBLabel: 'Fakturastyrning, kontering',
        PBGLabel: 'Fakturastyrning, kontering',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturastyrning, kontering primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturastyrning, kontering versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturastyrning, kontering fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTFORSLAG_ID: {
          AttributeName: 'ATTESTFORSLAG_ID',
          DisplayLabel: 'Attestförslag, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKostnadskonto: {
          AttributeName: 'KBKostnadskonto',
          DisplayLabel: 'KBKostnadskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleATTESTFORSLAG_ID: {
          AttributeName: 'RuleATTESTFORSLAG_ID',
          DisplayLabel: 'RuleATTESTFORSLAG_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleLOPNR: {
          AttributeName: 'RuleLOPNR',
          DisplayLabel: 'RuleLOPNR',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROCENT: {
          AttributeName: 'PROCENT',
          DisplayLabel: 'Procentsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kostnadskonto: {
          AssociationName: 'Kostnadskonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestforslag: {
          AssociationName: 'Attestforslag',
          DisplayLabel: 'Attestförslag',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslag',
          AssociatedComponentName: 'Attestforslag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRFakturaDel: {
      CollectionName: 'LRFakturaDel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '10014'], ['AllowEdit', '17001'], ['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'FakturaDel',
        Abstract: false,
        SOLabel: 'Faktura',
        SOGLabel: 'Fakturas',
        SBLabel: 'Fakturan',
        SBGLabel: 'Fakturans',
        POLabel: 'Fakturor',
        POGLabel: 'Fakturors',
        PBLabel: 'Fakturorna',
        PBGLabel: 'Fakturornas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturans primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturans versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturans id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturans fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTEST_GRUPP_ID: {
          AttributeName: 'ATTEST_GRUPP_ID',
          DisplayLabel: 'Attestgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        Atteststatus: {
          AttributeName: 'Atteststatus',
          DisplayLabel: 'Gammal detaljerad status',
          Hint: 'Använd inte denna - Status ej definierad/Ej utdelad för attest/Ej utdelad för beslutsattest/Hos central administratör/Under utredning/Felaktig beloppsattest/Mottagningsattesteras/Beslutsattesteras/I utkorg/Attesterad/Definitivbokad/På väg till betalning/Spärrad/Delbetald/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['STATUS_EJ_DEFINIERAD', 'Status ej definierad'], ['EJ_UTDELAD_FOR_ATTEST', 'Ej utdelad för attest'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', 'Ej utdelad för beslutsattest'], ['HOS_CENTRAL_ADMINISTRATOR', 'Hos central administratör'], ['UNDER_UTREDNING', 'Under utredning'], ['FELAKTIG_BELOPPSATTEST', 'Felaktig beloppsattest'], ['MOTTAGNINGSATTESTERAS', 'Mottagningsattesteras'], ['BESLUTSATTESTERAS', 'Beslutsattesteras'], ['I_UTKORG', 'I utkorg'], ['ATTESTERAD', 'Attesterad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['SPARRAD', 'Spärrad'], ['DELBETALD', 'Delbetald'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['STATUS_EJ_DEFINIERAD', '010'], ['EJ_UTDELAD_FOR_ATTEST', '020'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', '022'], ['HOS_CENTRAL_ADMINISTRATOR', '025'], ['UNDER_UTREDNING', '030'], ['FELAKTIG_BELOPPSATTEST', '035'], ['MOTTAGNINGSATTESTERAS', '040'], ['BESLUTSATTESTERAS', '050'], ['I_UTKORG', '055'], ['ATTESTERAD', '060'], ['DEFINITIVBOKAD', '070'], ['PA_VAG_TILL_BETALNING', '080'], ['SPARRAD', '090'], ['DELBETALD', '100'], ['BETALD', '110'], ['MAKULERAD', '120']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STATUS_EJ_DEFINIERAD=Status ej definierad;EJ_UTDELAD_FOR_ATTEST=Ej utdelad för attest;EJ_UTDELAD_FOR_BESLUTSATTEST=Ej utdelad för beslutsattest;HOS_CENTRAL_ADMINISTRATOR=Hos central administratör;UNDER_UTREDNING=Under utredning;FELAKTIG_BELOPPSATTEST=Felaktig beloppsattest;MOTTAGNINGSATTESTERAS=Mottagningsattesteras;BESLUTSATTESTERAS=Beslutsattesteras;I_UTKORG=I utkorg;ATTESTERAD=Attesterad;DEFINITIVBOKAD=Definitivbokad;PA_VAG_TILL_BETALNING=På väg till betalning;SPARRAD=Spärrad;DELBETALD=Delbetald;BETALD=Betald;MAKULERAD=Makulerad"',
        },
        oldAttestgrupp: {
          AttributeName: 'oldAttestgrupp',
          DisplayLabel: 'Attestgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Leverantor: {
          AttributeName: 'Leverantor',
          DisplayLabel: 'Leverantor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Forfallodatum: {
          AttributeName: 'Forfallodatum',
          DisplayLabel: 'Förfallodatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        FakturaBelopp2: {
          AttributeName: 'FakturaBelopp2',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Belopp',
        },
        RegVernr: {
          AttributeName: 'RegVernr',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegVerdatum: {
          AttributeName: 'RegVerdatum',
          DisplayLabel: 'Bokföringsdatum för registrering',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        AttesterasAv3: {
          AttributeName: 'AttesterasAv3',
          DisplayLabel: 'Attesteras av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturadatum: {
          AttributeName: 'Fakturadatum',
          DisplayLabel: 'Fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        AntalDgrTillForfallodatum: {
          AttributeName: 'AntalDgrTillForfallodatum',
          DisplayLabel: 'Dagar till förfallodatum',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          AttributeGroup: 'Datum',
        },
        Meddelande: {
          AttributeName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Levnr: {
          AttributeName: 'Levnr',
          DisplayLabel: 'Levnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTEST_STATUS: {
          AttributeName: 'ATTEST_STATUS',
          DisplayLabel: 'Detaljerad status',
          Hint: 'Status ej definierad/Ej utdelad för attest/Ej utdelad för beslutsattest/Hos central administratör/Under utredning/Felaktig beloppsattest/Otillräcklig attest/Mottagningsattesteras/Beslutsattesteras/I utkorg/Attesterad/Definitivbokad/På väg till betalning/Spärrad/Delbetald/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['STATUS_EJ_DEFINIERAD', 'Status ej definierad'], ['EJ_UTDELAD_FOR_ATTEST', 'Ej utdelad för attest'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', 'Ej utdelad för beslutsattest'], ['HOS_CENTRAL_ADMINISTRATOR', 'Hos central administratör'], ['UNDER_UTREDNING', 'Under utredning'], ['FELAKTIG_BELOPPSATTEST', 'Felaktig beloppsattest'], ['OTILLRACKLIG_ATTEST', 'Otillräcklig attest'], ['MOTTAGNINGSATTESTERAS', 'Mottagningsattesteras'], ['BESLUTSATTESTERAS', 'Beslutsattesteras'], ['I_UTKORG', 'I utkorg'], ['ATTESTERAD', 'Attesterad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['SPARRAD', 'Spärrad'], ['DELBETALD', 'Delbetald'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['STATUS_EJ_DEFINIERAD', '010'], ['EJ_UTDELAD_FOR_ATTEST', '020'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', '022'], ['HOS_CENTRAL_ADMINISTRATOR', '025'], ['UNDER_UTREDNING', '030'], ['FELAKTIG_BELOPPSATTEST', '035'], ['OTILLRACKLIG_ATTEST', '038'], ['MOTTAGNINGSATTESTERAS', '040'], ['BESLUTSATTESTERAS', '050'], ['I_UTKORG', '055'], ['ATTESTERAD', '060'], ['DEFINITIVBOKAD', '070'], ['PA_VAG_TILL_BETALNING', '080'], ['SPARRAD', '090'], ['DELBETALD', '100'], ['BETALD', '110'], ['MAKULERAD', '120']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STATUS_EJ_DEFINIERAD=Status ej definierad;EJ_UTDELAD_FOR_ATTEST=Ej utdelad för attest;EJ_UTDELAD_FOR_BESLUTSATTEST=Ej utdelad för beslutsattest;HOS_CENTRAL_ADMINISTRATOR=Hos central administratör;UNDER_UTREDNING=Under utredning;FELAKTIG_BELOPPSATTEST=Felaktig beloppsattest;OTILLRACKLIG_ATTEST=Otillräcklig attest;MOTTAGNINGSATTESTERAS=Mottagningsattesteras;BESLUTSATTESTERAS=Beslutsattesteras;I_UTKORG=I utkorg;ATTESTERAD=Attesterad;DEFINITIVBOKAD=Definitivbokad;PA_VAG_TILL_BETALNING=På väg till betalning;SPARRAD=Spärrad;DELBETALD=Delbetald;BETALD=Betald;MAKULERAD=Makulerad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Attestdel',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
          Required: true,
        },
        ATTEST_STATUS_SIGNATUR: {
          AttributeName: 'ATTEST_STATUS_SIGNATUR',
          DisplayLabel: 'Atteststatus, ändrad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        VarnaForfallodatum: {
          AttributeName: 'VarnaForfallodatum',
          DisplayLabel: 'VarnaForfallodatum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        AttesterasAv: {
          AttributeName: 'AttesterasAv',
          DisplayLabel: 'På tur att attestera',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Attestdel',
        },
        AnkregBokford: {
          AttributeName: 'AnkregBokford',
          DisplayLabel: 'Ank.reg bokförd',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        DefAnkVernr: {
          AttributeName: 'DefAnkVernr',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bestnr: {
          AttributeName: 'Bestnr',
          DisplayLabel: 'Arbetsorder/Bestnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkickaPaminnelse: {
          AttributeName: 'SkickaPaminnelse',
          DisplayLabel: 'Skicka påminnelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        calcAttestStatus: {
          AttributeName: 'calcAttestStatus',
          DisplayLabel: 'Detaljerad status',
          Hint: 'Status ej definierad/Ej utdelad för attest/Ej utdelad för beslutsattest/Attest makulerad/Under utredning/Felaktig beloppsattest/Mottagningsattesteras/Beslutsattesteras/I utkorg/Attesterad/Definitivbokad/På väg till betalning/Spärrad/Delbetald/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['STATUS_EJ_DEFINIERAD', 'Status ej definierad'], ['EJ_UTDELAD_FOR_ATTEST', 'Ej utdelad för attest'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', 'Ej utdelad för beslutsattest'], ['ATTEST_MAKULERAD', 'Attest makulerad'], ['UNDER_UTREDNING', 'Under utredning'], ['FELAKTIG_BELOPPSATTEST', 'Felaktig beloppsattest'], ['MOTTAGNINGSATTESTERAS', 'Mottagningsattesteras'], ['BESLUTSATTESTERAS', 'Beslutsattesteras'], ['I_UTKORG', 'I utkorg'], ['ATTESTERAD', 'Attesterad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['SPARRAD', 'Spärrad'], ['DELBETALD', 'Delbetald'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['STATUS_EJ_DEFINIERAD', '010'], ['EJ_UTDELAD_FOR_ATTEST', '020'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', '022'], ['ATTEST_MAKULERAD', '025'], ['UNDER_UTREDNING', '030'], ['FELAKTIG_BELOPPSATTEST', '035'], ['MOTTAGNINGSATTESTERAS', '040'], ['BESLUTSATTESTERAS', '050'], ['I_UTKORG', '055'], ['ATTESTERAD', '060'], ['DEFINITIVBOKAD', '070'], ['PA_VAG_TILL_BETALNING', '080'], ['SPARRAD', '090'], ['DELBETALD', '100'], ['BETALD', '110'], ['MAKULERAD', '120']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STATUS_EJ_DEFINIERAD=Status ej definierad;EJ_UTDELAD_FOR_ATTEST=Ej utdelad för attest;EJ_UTDELAD_FOR_BESLUTSATTEST=Ej utdelad för beslutsattest;ATTEST_MAKULERAD=Attest makulerad;UNDER_UTREDNING=Under utredning;FELAKTIG_BELOPPSATTEST=Felaktig beloppsattest;MOTTAGNINGSATTESTERAS=Mottagningsattesteras;BESLUTSATTESTERAS=Beslutsattesteras;I_UTKORG=I utkorg;ATTESTERAD=Attesterad;DEFINITIVBOKAD=Definitivbokad;PA_VAG_TILL_BETALNING=På väg till betalning;SPARRAD=Spärrad;DELBETALD=Delbetald;BETALD=Betald;MAKULERAD=Makulerad"',
        },
        Attestdel: {
          AttributeName: 'Attestdel',
          DisplayLabel: 'Attestdel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Attestdel',
        },
        SortRegVernr: {
          AttributeName: 'SortRegVernr',
          DisplayLabel: 'SortRegVernr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Elektronisk_attest: {
          AttributeName: 'Elektronisk_attest',
          DisplayLabel: 'Elektronisk attest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        Kontonr: {
          AttributeName: 'Kontonr',
          DisplayLabel: 'Bank/Plusgironr',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        EXTRA_STATUS: {
          AttributeName: 'EXTRA_STATUS',
          DisplayLabel: 'Extra status',
          Hint: 'Under utredning/Skickad till central administratör',
          DataType: 'Enum',
          EnumValues: new Map([['UNDER_UTREDNING', 'Under utredning'], ['SKICKAD_TILL_CENTRAL_ADMINISTRATOR', 'Skickad till central administratör']]),
          EnumSortValues: new Map([['UNDER_UTREDNING', 'R'], ['SKICKAD_TILL_CENTRAL_ADMINISTRATOR', 'M']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UNDER_UTREDNING=Under utredning;SKICKAD_TILL_CENTRAL_ADMINISTRATOR=Skickad till central administratör"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AttesterasAvPaminnelseDatum: {
          AttributeName: 'AttesterasAvPaminnelseDatum',
          DisplayLabel: 'Senaste påminnelse',
          Hint: 'Datum då den attestanten som har fakturan senast fick en påminnelse',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          AttributeGroup: 'Attestdel',
        },
        SkickaPaminnelse2: {
          AttributeName: 'SkickaPaminnelse2',
          DisplayLabel: 'Skicka påminnelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AttesterasAv2: {
          AttributeName: 'AttesterasAv2',
          DisplayLabel: 'AttesterasAv2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NastaAttestant: {
          AttributeName: 'NastaAttestant',
          DisplayLabel: 'Nästa attestant',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusPerAttestant: {
          AttributeName: 'StatusPerAttestant',
          DisplayLabel: 'StatusPerAttestant',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'AttestantID': {type: 'String', defaultValue: ''}},
        },
        SenasteMottagnattestDatum: {
          AttributeName: 'SenasteMottagnattestDatum',
          DisplayLabel: 'Mottagningsattesterad, datum',
          Hint: 'Datum för senaste mottagningsattest',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        SenasteBeslutsattestDatum: {
          AttributeName: 'SenasteBeslutsattestDatum',
          DisplayLabel: 'Beslutsattesterad, datum',
          Hint: 'Datum för senaste besluts-/kontrollattest',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        SenastMottagnattestAttestantId: {
          AttributeName: 'SenastMottagnattestAttestantId',
          DisplayLabel: 'Mottagningsattest, attestantid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenastBeslutattestAttestantID: {
          AttributeName: 'SenastBeslutattestAttestantID',
          DisplayLabel: 'Beslutsattestant, attestantid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteMottagnAttestNamn: {
          AttributeName: 'SenasteMottagnAttestNamn',
          DisplayLabel: 'Mottagningsattesterad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenasteBeslutsAttestNamn: {
          AttributeName: 'SenasteBeslutsAttestNamn',
          DisplayLabel: 'Beslutsattesterad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AntalDgrTillMottagnattest: {
          AttributeName: 'AntalDgrTillMottagnattest',
          DisplayLabel: 'Antal dgr till mottagn attest',
          Hint: 'Antal dgr från ankomstreg till sista mottagn.attest',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        AntalDgrTillBeslutattest: {
          AttributeName: 'AntalDgrTillBeslutattest',
          DisplayLabel: 'Antal dagar mellan mottagn.attest och beslutsattest',
          Hint: 'Antal dagar mellan senaste mottagningsattesten och senaste beslutsattesten',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        AttesterasAvAnvSign: {
          AttributeName: 'AttesterasAvAnvSign',
          DisplayLabel: 'På tur att attestera användare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Attestdel',
        },
        AttestMinaStatus: {
          AttributeName: 'AttestMinaStatus',
          DisplayLabel: 'Min fakturastatus',
          Hint: 'Mottagningsattesteras/Beslutsattesteras/Kontrollattesteras/Under utredning/Felaktiga/Ej attesterad, hos annan attestant/Attesterad, hos annan attestant/Attesterad, ej definitivbokad/Attesterad, definitivbokad/Attesterad, på väg till betalning/Attesterad, delbetald/Attesterad, betald/Attesterad, spärrad/Attesterad, makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['MOTTAGNINGSATTESTERAS', 'Mottagningsattesteras'], ['BESLUTSATTESTERAS', 'Beslutsattesteras'], ['KONTROLLATTESTERAS', 'Kontrollattesteras'], ['UNDER_UTREDNING', 'Under utredning'], ['FELAKTIGA', 'Felaktiga'], ['EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT', 'Ej attesterad, hos annan attestant'], ['ATTESTERAD__HOS_ANNAN_ATTESTANT', 'Attesterad, hos annan attestant'], ['ATTESTERAD__EJ_DEFINITIVBOKAD', 'Attesterad, ej definitivbokad'], ['ATTESTERAD__DEFINITIVBOKAD', 'Attesterad, definitivbokad'], ['ATTESTERAD__PA_VAG_TILL_BETALNING', 'Attesterad, på väg till betalning'], ['ATTESTERAD__DELBETALD', 'Attesterad, delbetald'], ['ATTESTERAD__BETALD', 'Attesterad, betald'], ['ATTESTERAD__SPARRAD', 'Attesterad, spärrad'], ['ATTESTERAD__MAKULERAD', 'Attesterad, makulerad']]),
          EnumSortValues: new Map([['MOTTAGNINGSATTESTERAS', 'M'], ['BESLUTSATTESTERAS', 'B'], ['KONTROLLATTESTERAS', 'K'], ['UNDER_UTREDNING', 'U'], ['FELAKTIGA', 'F'], ['EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT', 'H'], ['ATTESTERAD__HOS_ANNAN_ATTESTANT', 'I'], ['ATTESTERAD__EJ_DEFINITIVBOKAD', 'A'], ['ATTESTERAD__DEFINITIVBOKAD', 'D'], ['ATTESTERAD__PA_VAG_TILL_BETALNING', 'P'], ['ATTESTERAD__DELBETALD', '1'], ['ATTESTERAD__BETALD', '2'], ['ATTESTERAD__SPARRAD', '3'], ['ATTESTERAD__MAKULERAD', '4']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MOTTAGNINGSATTESTERAS=Mottagningsattesteras;BESLUTSATTESTERAS=Beslutsattesteras;KONTROLLATTESTERAS=Kontrollattesteras;UNDER_UTREDNING=Under utredning;FELAKTIGA=Felaktiga;EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT=Ej attesterad, hos annan attestant;ATTESTERAD__HOS_ANNAN_ATTESTANT=Attesterad, hos annan attestant;ATTESTERAD__EJ_DEFINITIVBOKAD=Attesterad, ej definitivbokad;ATTESTERAD__DEFINITIVBOKAD=Attesterad, definitivbokad;ATTESTERAD__PA_VAG_TILL_BETALNING=Attesterad, på väg till betalning;ATTESTERAD__DELBETALD=Attesterad, delbetald;ATTESTERAD__BETALD=Attesterad, betald;ATTESTERAD__SPARRAD=Attesterad, spärrad;ATTESTERAD__MAKULERAD=Attesterad, makulerad"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Attesteras',
        },
        NastaAttestantSignNamn: {
          AttributeName: 'NastaAttestantSignNamn',
          DisplayLabel: 'På tur att attestera',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Attestdel',
        },
        FaktnrAttestdel: {
          AttributeName: 'FaktnrAttestdel',
          DisplayLabel: 'Fakturanr och attestdel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Attestdel',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttesteradeMinaKanAterta: {
          AttributeName: 'AttesteradeMinaKanAterta',
          DisplayLabel: 'Mina attesterade, möjliga att återta',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Attesteras',
        },
        PaminnelseStatus: {
          AttributeName: 'PaminnelseStatus',
          DisplayLabel: 'Påminnelse status',
          Hint: 'Påminn mottagningsattestant/Påminn beslutsattestant/Ingen påminnelse/Påminn utredning',
          DataType: 'Enum',
          EnumValues: new Map([['PAMINN_MOTTAGNINGSATTESTANT', 'Påminn mottagningsattestant'], ['PAMINN_BESLUTSATTESTANT', 'Påminn beslutsattestant'], ['INGEN_PAMINNELSE', 'Ingen påminnelse'], ['PAMINN_UTREDNING', 'Påminn utredning']]),
          EnumSortValues: new Map([['PAMINN_MOTTAGNINGSATTESTANT', 'M'], ['PAMINN_BESLUTSATTESTANT', 'B'], ['INGEN_PAMINNELSE', 'I'], ['PAMINN_UTREDNING', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PAMINN_MOTTAGNINGSATTESTANT=Påminn mottagningsattestant;PAMINN_BESLUTSATTESTANT=Påminn beslutsattestant;INGEN_PAMINNELSE=Ingen påminnelse;PAMINN_UTREDNING=Påminn utredning"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Attesteras',
        },
        ForfalloDatumMedIkon: {
          AttributeName: 'ForfalloDatumMedIkon',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        TrimAttestOrdningsnr: {
          AttributeName: 'TrimAttestOrdningsnr',
          DisplayLabel: 'TrimAttestOrdningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTREDNING_ATTEST_LOPNR: {
          AttributeName: 'UTREDNING_ATTEST_LOPNR',
          DisplayLabel: 'Lagd till utredning av attest löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteBeslutsattestNamn2: {
          AttributeName: 'SenasteBeslutsattestNamn2',
          DisplayLabel: 'SenasteBeslutsattestNamn2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Attestgrupp: {
          AssociationName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestGrupp',
          AssociatedComponentName: 'AttestGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        UtredningAttest: {
          AssociationName: 'UtredningAttest',
          DisplayLabel: 'Skickad till utredning av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturaAttest',
          AssociatedComponentName: 'FakturaAttest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaattest: {
          AssociationName: 'Fakturaattest',
          DisplayLabel: 'Fakturaattester',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturaAttest',
          AssociatedComponentName: 'FakturaAttest',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRInkopsrapportLogg: {
      CollectionName: 'LRInkopsrapportLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InkopsrapportLogg',
        Abstract: false,
        SOLabel: 'Inköpsrapportlogg',
        SOGLabel: 'Inköpsrapportloggs',
        SBLabel: 'Inköpsrapportloggen',
        SBGLabel: 'Inköpsrapportloggens',
        POLabel: 'Inköpsrapportloggar',
        POGLabel: 'Inköpsrapportloggars',
        PBLabel: 'Inköpsrapportloggarna',
        PBGLabel: 'Inköpsrapportloggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inköpsrapportloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inköpsrapportloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inköpsrapportloggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REQUEST_NR: {
          AttributeName: 'REQUEST_NR',
          DisplayLabel: 'Nummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_RAPPORT: {
          AttributeName: 'TOM_RAPPORT',
          DisplayLabel: 'Tom rapport skickad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANTAL_RADER: {
          AttributeName: 'ANTAL_RADER',
          DisplayLabel: 'Antal rader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    LRKonteringsForslag: {
      CollectionName: 'LRKonteringsForslag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'KonteringsForslag',
        Abstract: false,
        SOLabel: 'Konteringsförslag',
        SOGLabel: 'Konteringsförslag',
        SBLabel: 'Konteringsförslaget',
        SBGLabel: 'Konteringsförslaget',
        POLabel: 'Konteringsförslagen',
        POGLabel: 'Konteringsförslagen',
        PBLabel: 'Konteringsförslagen',
        PBGLabel: 'Konteringsförslagen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringsförslaget primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringsförslaget versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringsförslaget id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        PER_FROM_DATUM: {
          AttributeName: 'PER_FROM_DATUM',
          DisplayLabel: 'Periodiserad fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        PER_TOM_DATUM: {
          AttributeName: 'PER_TOM_DATUM',
          DisplayLabel: 'Periodiserad t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        MOMS: {
          AttributeName: 'MOMS',
          DisplayLabel: 'Moms',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KONT_BOKF_AR: {
          AttributeName: 'KONT_BOKF_AR',
          DisplayLabel: 'Kontering, bokf.år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        KONT_VER_NR: {
          AttributeName: 'KONT_VER_NR',
          DisplayLabel: 'Kontering, verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_LOPNR: {
          AttributeName: 'KONT_LOPNR',
          DisplayLabel: 'Kontering, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturadatum: {
          AttributeName: 'Fakturadatum',
          DisplayLabel: 'Fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Konto benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Konto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben1: {
          AttributeName: 'Kontoben1',
          DisplayLabel: 'Kontoben1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben2: {
          AttributeName: 'Kontoben2',
          DisplayLabel: 'Kontoben2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben3: {
          AttributeName: 'Kontoben3',
          DisplayLabel: 'Kontoben3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben4: {
          AttributeName: 'Kontoben4',
          DisplayLabel: 'Kontoben4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben5: {
          AttributeName: 'Kontoben5',
          DisplayLabel: 'Kontoben5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben6: {
          AttributeName: 'Kontoben6',
          DisplayLabel: 'Kontoben6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben7: {
          AttributeName: 'Kontoben7',
          DisplayLabel: 'Kontoben7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben8: {
          AttributeName: 'Kontoben8',
          DisplayLabel: 'Kontoben8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben9: {
          AttributeName: 'Kontoben9',
          DisplayLabel: 'Kontoben9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben10: {
          AttributeName: 'Kontoben10',
          DisplayLabel: 'Kontoben10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLAGGSINFO_KOD: {
          AttributeName: 'TILLAGGSINFO_KOD',
          DisplayLabel: 'Tilläggsinfo, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AR_BENAMNING: {
          AttributeName: 'AR_BENAMNING',
          DisplayLabel: 'Benämning, investering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_KOMPONENT_ID: {
          AttributeName: 'AR_KOMPONENT_ID',
          DisplayLabel: 'Komponentyp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_TID: {
          AttributeName: 'AR_AVSKR_TID',
          DisplayLabel: 'Avskrivningstid (år)',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinRecommendedValue="5"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_INV_DATUM: {
          AttributeName: 'AR_INV_DATUM',
          DisplayLabel: 'Datum (tagen i bruk)',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_NY: {
          AttributeName: 'AR_NY',
          DisplayLabel: 'Ny tillgång',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterDisplayParams: 'TranslateValues="Y=Ja;N=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_TILLGANG_ID: {
          AttributeName: 'AR_TILLGANG_ID',
          DisplayLabel: 'Tillhör tillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_TILLGANG_BEN: {
          AttributeName: 'AR_TILLGANG_BEN',
          DisplayLabel: 'Anl.tillgång, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_OMRADE_ID: {
          AttributeName: 'AR_OMRADE_ID',
          DisplayLabel: 'Område, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KDEL_1: {
          AttributeName: 'AR_AVSKR_KDEL_1',
          DisplayLabel: 'Avskr konto 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_2: {
          AttributeName: 'AR_AVSKR_KDEL_2',
          DisplayLabel: 'Avskr konto 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_3: {
          AttributeName: 'AR_AVSKR_KDEL_3',
          DisplayLabel: 'Avskr konto 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_4: {
          AttributeName: 'AR_AVSKR_KDEL_4',
          DisplayLabel: 'Avskr konto 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_5: {
          AttributeName: 'AR_AVSKR_KDEL_5',
          DisplayLabel: 'Avskr konto 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_6: {
          AttributeName: 'AR_AVSKR_KDEL_6',
          DisplayLabel: 'Avskr konto 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_7: {
          AttributeName: 'AR_AVSKR_KDEL_7',
          DisplayLabel: 'Avskr konto 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_8: {
          AttributeName: 'AR_AVSKR_KDEL_8',
          DisplayLabel: 'Avskr konto 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_9: {
          AttributeName: 'AR_AVSKR_KDEL_9',
          DisplayLabel: 'Avskr konto 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AR_AVSKR_KDEL_10: {
          AttributeName: 'AR_AVSKR_KDEL_10',
          DisplayLabel: 'Avskr konto 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
          Properties: new Map([['HIDE_IN_NYA_AVENY', 'Y']]),
        },
        AvskrKontostrang: {
          AttributeName: 'AvskrKontostrang',
          DisplayLabel: 'Avskr.konto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AvskrKontoben: {
          AttributeName: 'AvskrKontoben',
          DisplayLabel: 'Avskrkonto, benamning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_KOMMENTAR: {
          AttributeName: 'AR_KOMMENTAR',
          DisplayLabel: 'Tillägg, kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kodplan, ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REFERENSTYP_KODDEL: {
          AttributeName: 'REFERENSTYP_KODDEL',
          DisplayLabel: 'Referenstyp, koddel',
          Hint: 'Sträng/Referens',
          DataType: 'Enum',
          EnumValues: new Map([['STRANG', 'Sträng'], ['REFERENS', 'Referens']]),
          EnumSortValues: new Map([['STRANG', 'S'], ['REFERENS', 'R']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STRANG=Sträng;REFERENS=Referens"',
        },
        AR_AVSKR_ORDNINGS_NR_1: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_1',
          DisplayLabel: 'Avskr ordnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_1: {
          AttributeName: 'AR_AVSKR_KONTOID_1',
          DisplayLabel: 'Avskr kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_2: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_2',
          DisplayLabel: 'Avskr ordnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_2: {
          AttributeName: 'AR_AVSKR_KONTOID_2',
          DisplayLabel: 'Avskr kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_3: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_3',
          DisplayLabel: 'Avskr ordnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_3: {
          AttributeName: 'AR_AVSKR_KONTOID_3',
          DisplayLabel: 'Avskr kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_4: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_4',
          DisplayLabel: 'Avskr ordnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_4: {
          AttributeName: 'AR_AVSKR_KONTOID_4',
          DisplayLabel: 'Avskr kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_5: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_5',
          DisplayLabel: 'Avskr ordnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_5: {
          AttributeName: 'AR_AVSKR_KONTOID_5',
          DisplayLabel: 'Avskr kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_6: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_6',
          DisplayLabel: 'Avskr ordnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_6: {
          AttributeName: 'AR_AVSKR_KONTOID_6',
          DisplayLabel: 'Avskr kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_7: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_7',
          DisplayLabel: 'Avskr ordnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_7: {
          AttributeName: 'AR_AVSKR_KONTOID_7',
          DisplayLabel: 'Avskr kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_8: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_8',
          DisplayLabel: 'Avskr ordnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_8: {
          AttributeName: 'AR_AVSKR_KONTOID_8',
          DisplayLabel: 'Avskr kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_9: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_9',
          DisplayLabel: 'Avskr ordnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_9: {
          AttributeName: 'AR_AVSKR_KONTOID_9',
          DisplayLabel: 'Avskr kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_ORDNINGS_NR_10: {
          AttributeName: 'AR_AVSKR_ORDNINGS_NR_10',
          DisplayLabel: 'Avskr ordnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KONTOID_10: {
          AttributeName: 'AR_AVSKR_KONTOID_10',
          DisplayLabel: 'Avskr kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        KontodelToKontoid1: {
          AttributeName: 'KontodelToKontoid1',
          DisplayLabel: 'KontodelToKontoid1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid2: {
          AttributeName: 'KontodelToKontoid2',
          DisplayLabel: 'KontodelToKontoid2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid3: {
          AttributeName: 'KontodelToKontoid3',
          DisplayLabel: 'KontodelToKontoid3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid4: {
          AttributeName: 'KontodelToKontoid4',
          DisplayLabel: 'KontodelToKontoid4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid5: {
          AttributeName: 'KontodelToKontoid5',
          DisplayLabel: 'KontodelToKontoid5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid6: {
          AttributeName: 'KontodelToKontoid6',
          DisplayLabel: 'KontodelToKontoid6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid7: {
          AttributeName: 'KontodelToKontoid7',
          DisplayLabel: 'KontodelToKontoid7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid8: {
          AttributeName: 'KontodelToKontoid8',
          DisplayLabel: 'KontodelToKontoid8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid9: {
          AttributeName: 'KontodelToKontoid9',
          DisplayLabel: 'KontodelToKontoid9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontodelToKontoid10: {
          AttributeName: 'KontodelToKontoid10',
          DisplayLabel: 'KontodelToKontoid10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_AVSKR_KontodelToKontoid1: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid1',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid2: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid2',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid3: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid3',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid4: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid4',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid5: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid5',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid6: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid6',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid7: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid7',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid8: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid8',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid9: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid9',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontodelToKontoid10: {
          AttributeName: 'AR_AVSKR_KontodelToKontoid10',
          DisplayLabel: 'AR_AVSKR_KontodelToKontoid10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        KontoidToKontodel1: {
          AttributeName: 'KontoidToKontodel1',
          DisplayLabel: 'KontoidToKontodel1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel2: {
          AttributeName: 'KontoidToKontodel2',
          DisplayLabel: 'KontoidToKontodel2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel3: {
          AttributeName: 'KontoidToKontodel3',
          DisplayLabel: 'KontoidToKontodel3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel4: {
          AttributeName: 'KontoidToKontodel4',
          DisplayLabel: 'KontoidToKontodel4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel5: {
          AttributeName: 'KontoidToKontodel5',
          DisplayLabel: 'KontoidToKontodel5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel6: {
          AttributeName: 'KontoidToKontodel6',
          DisplayLabel: 'KontoidToKontodel6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel7: {
          AttributeName: 'KontoidToKontodel7',
          DisplayLabel: 'KontoidToKontodel7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel8: {
          AttributeName: 'KontoidToKontodel8',
          DisplayLabel: 'KontoidToKontodel8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel9: {
          AttributeName: 'KontoidToKontodel9',
          DisplayLabel: 'KontoidToKontodel9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoidToKontodel10: {
          AttributeName: 'KontoidToKontodel10',
          DisplayLabel: 'KontoidToKontodel10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_AVSKR_KontoidToKontodel1: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel1',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel2: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel2',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel3: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel3',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel4: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel4',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel5: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel5',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel6: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel6',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel7: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel7',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel8: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel8',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel9: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel9',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        AR_AVSKR_KontoidToKontodel10: {
          AttributeName: 'AR_AVSKR_KontoidToKontodel10',
          DisplayLabel: 'AR_AVSKR_KontoidToKontodel10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo anläggn',
        },
        PrimarBeloppsAttestrefKey: {
          AttributeName: 'PrimarBeloppsAttestrefKey',
          DisplayLabel: 'PrimarBeloppsAttestrefKey',
          Hint: 'Endast intern för översättning för gammal modell till ny',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestrefKey: {
          AttributeName: 'AttestrefKey',
          DisplayLabel: 'AttestrefKey',
          Hint: 'Endast intern för översättning för gammal modell till ny',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTEST_BOKF_GRUPP_ID: {
          AttributeName: 'ATTEST_BOKF_GRUPP_ID',
          DisplayLabel: 'Attest, bokf grupp id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTEST_LEVFAKTURA_ID: {
          AttributeName: 'ATTEST_LEVFAKTURA_ID',
          DisplayLabel: 'Attest, faktura id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTEST_DEL_LOPNR: {
          AttributeName: 'ATTEST_DEL_LOPNR',
          DisplayLabel: 'Attestdel, löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTEST_LOPNR: {
          AttributeName: 'ATTEST_LOPNR',
          DisplayLabel: 'Attest, löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del1: {
          AttributeName: 'Konto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '1']]),
        },
        Konto_del2: {
          AttributeName: 'Konto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '2']]),
        },
        Konto_del3: {
          AttributeName: 'Konto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '3']]),
        },
        Konto_del4: {
          AttributeName: 'Konto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '4']]),
        },
        Konto_del5: {
          AttributeName: 'Konto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '5']]),
        },
        Konto_del6: {
          AttributeName: 'Konto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '6']]),
        },
        Konto_del7: {
          AttributeName: 'Konto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '7']]),
        },
        Konto_del8: {
          AttributeName: 'Konto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '8']]),
        },
        Konto_del9: {
          AttributeName: 'Konto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '9']]),
        },
        Konto_del10: {
          AttributeName: 'Konto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '10']]),
        },
        AR_FI_BENAMNING: {
          AttributeName: 'AR_FI_BENAMNING',
          DisplayLabel: ' Förbrukn. inventarium, benämning inventarium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        AR_FI_DATUM: {
          AttributeName: 'AR_FI_DATUM',
          DisplayLabel: ' Förbrukn. inventarium, Inköpsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        AR_FI_ANLKAT_ID: {
          AttributeName: 'AR_FI_ANLKAT_ID',
          DisplayLabel: 'Förbrukningsinventarium, anl.kat id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        AR_FI_OMRADE_ID: {
          AttributeName: 'AR_FI_OMRADE_ID',
          DisplayLabel: 'Förbrukningsinventarium, område id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        AR_FI_BYGGNAD_ID: {
          AttributeName: 'AR_FI_BYGGNAD_ID',
          DisplayLabel: 'Förbrukningsinventarium, byggnad id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        AR_FI_KOMMENTAR: {
          AttributeName: 'AR_FI_KOMMENTAR',
          DisplayLabel: ' Förbrukn. inventarium, kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        Belopp: {
          AttributeName: 'Belopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FIKnuten: {
          AttributeName: 'FIKnuten',
          DisplayLabel: 'Knuten till förbrukningsinventarium',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FIHarTillaggsinfo: {
          AttributeName: 'FIHarTillaggsinfo',
          DisplayLabel: 'Registreras som förbrukningsinventarium',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FITillgangId: {
          AttributeName: 'FITillgangId',
          DisplayLabel: 'FITillgangId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        FIKnutenDatum: {
          AttributeName: 'FIKnutenDatum',
          DisplayLabel: 'Knuten, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FIKnutenSign: {
          AttributeName: 'FIKnutenSign',
          DisplayLabel: 'Knuten, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FI_BORTTAGEN: {
          AttributeName: 'FI_BORTTAGEN',
          DisplayLabel: 'Borttagen som förbrukn.inv.rad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FI_BORTTAGEN_DATUM: {
          AttributeName: 'FI_BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen som förbrukn.inv.rad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FI_BORTTAGEN_SIGNATUR: {
          AttributeName: 'FI_BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen som förbrukn.inv.rad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        FI_REGISTRERAS: {
          AttributeName: 'FI_REGISTRERAS',
          DisplayLabel: 'Registreras som förbrukningsinventarie',
          Hint: 'Ja/Nej/Ej angivet',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['EJ_ANGIVET', 'Ej angivet']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['EJ_ANGIVET', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;EJ_ANGIVET=Ej angivet"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Tilläggsinfo förbrukn inv',
        },
        BokfortAvvikande: {
          AttributeName: 'BokfortAvvikande',
          DisplayLabel: 'Bokfört på avvikande konto',
          Hint: 'Ja/Nej/Saknar referens',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['SAKNAR_REFERENS', 'Saknar referens']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['SAKNAR_REFERENS', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;SAKNAR_REFERENS=Saknar referens"',
        },
        BokfortAvvikandeSQL: {
          AttributeName: 'BokfortAvvikandeSQL',
          DisplayLabel: 'BokfortAvvikandeSQL',
          Hint: 'Ja/Nej/Saknar referens',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['SAKNAR_REFERENS', 'Saknar referens']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['SAKNAR_REFERENS', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;SAKNAR_REFERENS=Saknar referens"',
          InterfaceType: 'ifChecklist',
        },
        InvHarTillaggsinfo: {
          AttributeName: 'InvHarTillaggsinfo',
          DisplayLabel: 'Investering has tilläggsinformation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        HarTillaggsinfo: {
          AttributeName: 'HarTillaggsinfo',
          DisplayLabel: 'Har tilläggsinformation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        SORTERINGS_NR: {
          AttributeName: 'SORTERINGS_NR',
          DisplayLabel: 'Sorteringsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RADTYP: {
          AttributeName: 'RADTYP',
          DisplayLabel: 'radtyp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BELOPP_EXKL_MOMS: {
          AttributeName: 'BELOPP_EXKL_MOMS',
          DisplayLabel: 'Belopp exklusive moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BELOPP_INKL_MOMS: {
          AttributeName: 'BELOPP_INKL_MOMS',
          DisplayLabel: 'Belopp inklusive moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ING_MOMS_MALL: {
          AttributeName: 'ING_MOMS_MALL',
          DisplayLabel: 'Ingående momsmall',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ING_MOMS_SATS: {
          AttributeName: 'ING_MOMS_SATS',
          DisplayLabel: 'Ingående momsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VIKT: {
          AttributeName: 'VIKT',
          DisplayLabel: 'Avdrag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTL_MOMS_MALL: {
          AttributeName: 'UTL_MOMS_MALL',
          DisplayLabel: 'Utland momsmall',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTL_MOMS_SATS: {
          AttributeName: 'UTL_MOMS_SATS',
          DisplayLabel: 'Utland momsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTL_MOMS: {
          AttributeName: 'UTL_MOMS',
          DisplayLabel: 'Utland moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTL_MOMS_AVDRAG: {
          AttributeName: 'UTL_MOMS_AVDRAG',
          DisplayLabel: 'Utland momsavdrag',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MOMSPLIKTIG: {
          AttributeName: 'MOMSPLIKTIG',
          DisplayLabel: 'Momspliktig',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ING_MOMS_BELOPP: {
          AttributeName: 'ING_MOMS_BELOPP',
          DisplayLabel: 'Ingående momsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Rubrikbelopp: {
          AttributeName: 'Rubrikbelopp',
          DisplayLabel: 'Rubrikbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Kostnadbelopp: {
          AttributeName: 'Kostnadbelopp',
          DisplayLabel: 'Kostnadbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        INGEN_MOMS: {
          AttributeName: 'INGEN_MOMS',
          DisplayLabel: 'Ingen moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Anläggningstillgång',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaattest: {
          AssociationName: 'Fakturaattest',
          DisplayLabel: 'Fakturaattest',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturaAttest',
          AssociatedComponentName: 'FakturaAttest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Komponenttyp: {
          AssociationName: 'Komponenttyp',
          DisplayLabel: 'Komponenttyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARKomponent',
          AssociatedComponentName: 'Komponent',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Omrade: {
          AssociationName: 'Omrade',
          DisplayLabel: 'Område',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Plats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel1: {
          AssociationName: 'AvskrKontodel1',
          DisplayLabel: 'Avskr @KONTO1@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel2: {
          AssociationName: 'AvskrKontodel2',
          DisplayLabel: 'Avskr @KONTO2@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel3: {
          AssociationName: 'AvskrKontodel3',
          DisplayLabel: 'Avskr @KONTO3@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel4: {
          AssociationName: 'AvskrKontodel4',
          DisplayLabel: 'Avskr @KONTO4@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel5: {
          AssociationName: 'AvskrKontodel5',
          DisplayLabel: 'Avskr @KONTO5@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel6: {
          AssociationName: 'AvskrKontodel6',
          DisplayLabel: 'Avskr @KONTO6@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel7: {
          AssociationName: 'AvskrKontodel7',
          DisplayLabel: 'Avskr @KONTO7@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel8: {
          AssociationName: 'AvskrKontodel8',
          DisplayLabel: 'Avskr @KONTO8@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel9: {
          AssociationName: 'AvskrKontodel9',
          DisplayLabel: 'Avskr @KONTO9@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrKontodel10: {
          AssociationName: 'AvskrKontodel10',
          DisplayLabel: 'Avskr @KONTO10@',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfkontering: {
          AssociationName: 'Bokfkontering',
          DisplayLabel: 'Verifikationsrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'Bokfkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FITillgang: {
          AssociationName: 'FITillgang',
          DisplayLabel: 'Förbrukningsinventarium',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FIKategori: {
          AssociationName: 'FIKategori',
          DisplayLabel: 'Info förbrukn inv, kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAnlKat',
          AssociatedComponentName: 'AnlKat',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FIOmrade: {
          AssociationName: 'FIOmrade',
          DisplayLabel: 'Info förbrukn inv, område',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Omrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FIByggnad: {
          AssociationName: 'FIByggnad',
          DisplayLabel: 'Info förbrukn inv, byggnad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Byggnad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FIInvrad: {
          AssociationName: 'FIInvrad',
          DisplayLabel: 'Investeringsrad, förbrukn.inv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvesteringsrad',
          AssociatedComponentName: 'BokfInvrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        IngMoms: {
          AssociationName: 'IngMoms',
          DisplayLabel: 'Ingående momssats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtlandsMomsMall: {
          AssociationName: 'UtlandsMomsMall',
          DisplayLabel: 'Mall för utländsk moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'UtlandskMomsAutomatkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Beloppsattest: {
          AssociationName: 'Beloppsattest',
          DisplayLabel: 'Beloppsattest',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRBeloppsattest',
          AssociatedComponentName: 'Beloppsattest',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRKonteringsrecept: {
      CollectionName: 'LRKonteringsrecept',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Konteringsrecept',
        Abstract: false,
        SOLabel: 'Konteringsrecept',
        SOGLabel: 'Konteringsrecept',
        SBLabel: 'Konteringsreceptet',
        SBGLabel: 'Konteringsreceptet',
        POLabel: 'Konteringsrecepten',
        POGLabel: 'Konteringsrecepten',
        PBLabel: 'Konteringsrecepten',
        PBGLabel: 'Konteringsrecepten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringsreceptet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringsreceptet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringsreceptet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringsreceptet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        LEV_ID: {
          AttributeName: 'LEV_ID',
          DisplayLabel: 'Leverantör',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: 'Kostnadskonto, del 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: 'Kostnadskonto, del 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: 'Kostnadskonto, del 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: 'Kostnadskonto, del 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: 'Kostnadskonto, del 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: 'Kostnadskonto, del 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: 'Kostnadskonto, del 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: 'Kostnadskonto, del 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: 'Kostnadskonto, del 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: 'Kostnadskonto, del 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        Kontoben1: {
          AttributeName: 'Kontoben1',
          DisplayLabel: 'Kontoben1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben2: {
          AttributeName: 'Kontoben2',
          DisplayLabel: 'Kontoben2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben3: {
          AttributeName: 'Kontoben3',
          DisplayLabel: 'Kontoben3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben4: {
          AttributeName: 'Kontoben4',
          DisplayLabel: 'Kontoben4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben5: {
          AttributeName: 'Kontoben5',
          DisplayLabel: 'Kontoben5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben6: {
          AttributeName: 'Kontoben6',
          DisplayLabel: 'Kontoben6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben7: {
          AttributeName: 'Kontoben7',
          DisplayLabel: 'Kontoben7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben8: {
          AttributeName: 'Kontoben8',
          DisplayLabel: 'Kontoben8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben9: {
          AttributeName: 'Kontoben9',
          DisplayLabel: 'Kontoben9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontoben10: {
          AttributeName: 'Kontoben10',
          DisplayLabel: 'Kontoben10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontostrang',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontoben',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GallerFor: {
          AttributeName: 'GallerFor',
          DisplayLabel: 'Gäller för',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestOmrade',
          AssociatedComponentName: 'AttestOmrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestmedKvittens: {
      CollectionName: 'LRAttestmedKvittens',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'AttestmedKvittens',
        Abstract: false,
        SOLabel: 'Kvittens',
        SOGLabel: 'Kvittens',
        SBLabel: 'Kvittens',
        SBGLabel: 'Kvittens',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kvittens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kvittens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kvittens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kvittens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Kvitterat av, attestområde id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Kvitterat av, attesträtt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESERV_ATTESTOMRADE_ID: {
          AttributeName: 'RESERV_ATTESTOMRADE_ID',
          DisplayLabel: 'Kvitterat av reserv, attestområde id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESERV_ATTESTRATT_LOPNR: {
          AttributeName: 'RESERV_ATTESTRATT_LOPNR',
          DisplayLabel: 'Kvitterat av reserv, attesträtt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Kvitterande attesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ReservAttestratt: {
          AssociationName: 'ReservAttestratt',
          DisplayLabel: 'Kvitterande reserv attesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLevBetsatt: {
      CollectionName: 'LRLevBetsatt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LevBetsatt',
        Abstract: false,
        SOLabel: 'Leverantörens betalningssätt',
        SOGLabel: 'Leverantörens betalningssätt',
        SBLabel: 'Leverantörens betalningssätt',
        SBGLabel: 'Leverantörens betalningssätt',
        POLabel: 'Leverantörens betalningssätt',
        POGLabel: 'Leverantörens betalningssätt',
        PBLabel: 'Leverantörens betalningssätt',
        PBGLabel: 'Leverantörens betalningssätt',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörens betalningssätt primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörens betalningssätt versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörens betalningssätt id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörens betalningssätt fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRIORITET: {
          AttributeName: 'PRIORITET',
          DisplayLabel: 'Prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETSATT_ID: {
          AttributeName: 'BETSATT_ID',
          DisplayLabel: 'Betalningssätt ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BANK_ID: {
          AttributeName: 'BANK_ID',
          DisplayLabel: 'Bank ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTO_NR: {
          AttributeName: 'KONTO_NR',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OCR: {
          AttributeName: 'OCR',
          DisplayLabel: 'OCR',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        Utbetalningssatt: {
          AttributeName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Bank: {
          AttributeName: 'Bank',
          DisplayLabel: 'Bank, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Betsatt: {
          AttributeName: 'Betsatt',
          DisplayLabel: 'Betsatt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NUMERISKA_FAKTURANR: {
          AttributeName: 'NUMERISKA_FAKTURANR',
          DisplayLabel: 'Endast numeriska fakturanr',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          Required: true,
        },
        sqlUtbetsatt: {
          AttributeName: 'sqlUtbetsatt',
          DisplayLabel: 'Utbetalningssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontonrUtanStreck: {
          AttributeName: 'KontonrUtanStreck',
          DisplayLabel: 'Kontonr utan streck',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        UseOCR: {
          AttributeName: 'UseOCR',
          DisplayLabel: 'OCR',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        UseOCR2: {
          AttributeName: 'UseOCR2',
          DisplayLabel: 'OCR - intern användning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UTLAND_BETSATT_TYP: {
          AttributeName: 'UTLAND_BETSATT_TYP',
          DisplayLabel: 'Typ av kontonummer',
          Hint: 'IBAN/BBAN',
          DataType: 'Enum',
          EnumValues: new Map([['IBAN', 'IBAN'], ['BBAN', 'BBAN']]),
          EnumSortValues: new Map([['IBAN', 'I'], ['BBAN', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="IBAN=IBAN;BBAN=BBAN"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AUTOGIRO: {
          AttributeName: 'AUTOGIRO',
          DisplayLabel: 'Autogiro',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FACT_ORG_NR: {
          AttributeName: 'FACT_ORG_NR',
          DisplayLabel: 'Factoringleverantör, organisationsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatOrgNr',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Utbetalningssatt: {
          AssociationName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLeverantor: {
      CollectionName: 'LRLeverantor',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '10002'], ['AllowEdit', '10002'], ['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'Leverantor',
        Abstract: false,
        SOLabel: 'Leverantör',
        SOGLabel: 'Leverantörs',
        SBLabel: 'Leverantören',
        SBGLabel: 'Leverantörens',
        POLabel: 'Leverantörer',
        POGLabel: 'Leverantörers',
        PBLabel: 'Leverantörerna',
        PBGLabel: 'Leverantörernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVERANTORSNR: {
          AttributeName: 'LEVERANTORSNR',
          DisplayLabel: 'Leverantörsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LEVERANTOR_KATEGORI_ID: {
          AttributeName: 'LEVERANTOR_KATEGORI_ID',
          DisplayLabel: 'Leverantörkategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Organisation / Person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Normal/Avslutad',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['AVSLUTAD', 'Avslutad']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['AVSLUTAD', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;AVSLUTAD=Avslutad"',
          AttributeGroup: 'Övrigt',
        },
        REGDATUM: {
          AttributeName: 'REGDATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'ValutaID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRISLISTA_ID: {
          AttributeName: 'PRISLISTA_ID',
          DisplayLabel: 'Prislista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          AttributeGroup: 'Övrigt',
        },
        LEVERANSVILLKOR_ID: {
          AttributeName: 'LEVERANSVILLKOR_ID',
          DisplayLabel: 'Leveransvillkor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPARRAD_FROM_DATUM: {
          AttributeName: 'SPARRAD_FROM_DATUM',
          DisplayLabel: 'Spärrad fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        RIKSBANKSKOD: {
          AttributeName: 'RIKSBANKSKOD',
          DisplayLabel: 'Riksbankskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SPRAK_ID: {
          AttributeName: 'SPRAK_ID',
          DisplayLabel: 'Språk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALNINGSVILLKOR_ID: {
          AttributeName: 'BETALNINGSVILLKOR_ID',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Moms',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDNR: {
          AttributeName: 'KUNDNR',
          DisplayLabel: 'Vårt kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        ANGE_KUNDNR_SOM_FAKTREF: {
          AttributeName: 'ANGE_KUNDNR_SOM_FAKTREF',
          DisplayLabel: 'Ange kundnr som fakturaref',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        TILLGODOH_HOS_BG_PG: {
          AttributeName: 'TILLGODOH_HOS_BG_PG',
          DisplayLabel: 'Hantera tillgodohavande hos PlusGirot/Bankgirot',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Övrigt',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Adress: {
          AttributeName: 'Adress',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Telefon: {
          AttributeName: 'Telefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Leverantorskategori: {
          AttributeName: 'Leverantorskategori',
          DisplayLabel: 'Leverantörskategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Sorteringsnamn: {
          AttributeName: 'Sorteringsnamn',
          DisplayLabel: 'Sorteringsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SaldoIngaende: {
          AttributeName: 'SaldoIngaende',
          DisplayLabel: 'IngåendeSaldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SaldoAktuellt: {
          AttributeName: 'SaldoAktuellt',
          DisplayLabel: 'Aktuellt saldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KontosaldoIngaende: {
          AttributeName: 'KontosaldoIngaende',
          DisplayLabel: 'Ingående saldo för konto',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontosaldoUtgaende: {
          AttributeName: 'KontosaldoUtgaende',
          DisplayLabel: 'Utgående saldo för konto',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontosaldoAktuellt: {
          AttributeName: 'KontosaldoAktuellt',
          DisplayLabel: 'Aktuellt kontosaldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        ReskontraSaldoAktuellt: {
          AttributeName: 'ReskontraSaldoAktuellt',
          DisplayLabel: 'Reskontrasaldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LevKategori: {
          AttributeName: 'LevKategori',
          DisplayLabel: 'Leverantörskategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Postnr: {
          AttributeName: 'Postnr',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AdressRad: {
          AttributeName: 'AdressRad',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        NamnAdress: {
          AttributeName: 'NamnAdress',
          DisplayLabel: 'Namn och adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPTyp: {
          AttributeName: 'OPTyp',
          DisplayLabel: 'OPTyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
        },
        FSKATT_KONTROLLERAD_DATUM: {
          AttributeName: 'FSKATT_KONTROLLERAD_DATUM',
          DisplayLabel: 'Datum F-Skattesedel',
          Hint: 'Datum då F-Skattesedel kontrollerades senast',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        OPLBorttagen: {
          AttributeName: 'OPLBorttagen',
          DisplayLabel: 'OPLBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevkatBorttagen: {
          AttributeName: 'LevkatBorttagen',
          DisplayLabel: 'LevkatBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prislista: {
          AttributeName: 'Prislista',
          DisplayLabel: 'Prislista - benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Leveransvillkor: {
          AttributeName: 'Leveransvillkor',
          DisplayLabel: 'Leveransvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Betalningsvillkor: {
          AttributeName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Moms: {
          AttributeName: 'Moms',
          DisplayLabel: 'Moms',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AdressKundnrFSkatt: {
          AttributeName: 'AdressKundnrFSkatt',
          DisplayLabel: 'AdressKundnrFSkatt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevBorttagenOPL: {
          AttributeName: 'LevBorttagenOPL',
          DisplayLabel: 'Borttagna adresser',
          Hint: 'Leverantörer vars adress tagits bort',
          DataType: 'Enum',
          EnumValues: new Map([['LEVERANTORER_VARS_ADRESS_TAGITS_BORT', 'Leverantörer vars adress tagits bort']]),
          EnumSortValues: new Map([['LEVERANTORER_VARS_ADRESS_TAGITS_BORT', 'Y']]),
          Attribute: 'None',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LEVERANTORER_VARS_ADRESS_TAGITS_BORT=Leverantörer vars adress tagits bort"',
        },
        LeverantorNrNamn: {
          AttributeName: 'LeverantorNrNamn',
          DisplayLabel: 'Leverantör',
          Hint: 'Nummer och namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FakturabeloppPerPeriod: {
          AttributeName: 'FakturabeloppPerPeriod',
          DisplayLabel: 'Summa fakturabelopp',
          Hint: 'Fakturabelopp summerat under angivet fakturadatumintervall.',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Övrigt',
          AttributeParams: {'lr_lev_fbp_fromdatum': {type: 'String', defaultValue: ''}, 'lr_lev_fbp_tomdatum': {type: 'String', defaultValue: ''}},
        },
        AntalFakturorPerPeriod: {
          AttributeName: 'AntalFakturorPerPeriod',
          DisplayLabel: 'Antal fakturor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeParams: {'lr_lev_fbp_fromdatum': {type: 'String', defaultValue: ''}, 'lr_lev_fbp_tomdatum': {type: 'String', defaultValue: ''}},
        },
        ORDINARIE_REFERENS_TYP: {
          AttributeName: 'ORDINARIE_REFERENS_TYP',
          DisplayLabel: 'Använd referenstyp',
          Hint: 'Beställarreferens/Beställarreferens 2/Faktureringsobjekt/Avtal/Kontrakt/Er kontakt',
          DataType: 'Enum',
          EnumValues: new Map([['BESTALLARREFERENS', 'Beställarreferens'], ['BESTALLARREFERENS_2', 'Beställarreferens 2'], ['FAKTURERINGSOBJEKT', 'Faktureringsobjekt'], ['AVTAL_KONTRAKT', 'Avtal/Kontrakt'], ['ER_KONTAKT', 'Er kontakt']]),
          EnumSortValues: new Map([['BESTALLARREFERENS', 'B1'], ['BESTALLARREFERENS_2', 'B2'], ['FAKTURERINGSOBJEKT', 'FO'], ['AVTAL_KONTRAKT', 'AK'], ['ER_KONTAKT', 'EK']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESTALLARREFERENS=Beställarreferens;BESTALLARREFERENS_2=Beställarreferens 2;FAKTURERINGSOBJEKT=Faktureringsobjekt;AVTAL_KONTRAKT=Avtal/Kontrakt;ER_KONTAKT=Er kontakt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarOppnaFakturor: {
          AttributeName: 'HarOppnaFakturor',
          DisplayLabel: 'Har öppna fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarOppnaJournaler: {
          AttributeName: 'HarOppnaJournaler',
          DisplayLabel: 'Har öppna journaler',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        GDPRReferensdatum: {
          AttributeName: 'GDPRReferensdatum',
          DisplayLabel: 'Referensdatum GDPR',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          AttributeGroup: 'Övrigt',
        },
        UTLANDSK_MOMS_ID: {
          AttributeName: 'UTLANDSK_MOMS_ID',
          DisplayLabel: 'Utländsk moms',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTROLLERA_EJ_MOMS: {
          AttributeName: 'KONTROLLERA_EJ_MOMS',
          DisplayLabel: 'Kontrollera inte moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BERAKNA_EJ_MOMS: {
          AttributeName: 'BERAKNA_EJ_MOMS',
          DisplayLabel: 'Beräkna inte moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarEfakturor: {
          AttributeName: 'HarEfakturor',
          DisplayLabel: 'Har e-fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarSkannadOchTolkadeFakturor: {
          AttributeName: 'HarSkannadOchTolkadeFakturor',
          DisplayLabel: 'Har skannade/tolkade fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarKOBFakturor: {
          AttributeName: 'HarKOBFakturor',
          DisplayLabel: 'Har KOB-fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        GRANSKA_FORANKLAD_DEFBOK: {
          AttributeName: 'GRANSKA_FORANKLAD_DEFBOK',
          DisplayLabel: 'Granska i förenklade definitivbokningen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarFelISOKontoinsattning: {
          AttributeName: 'HarFelISOKontoinsattning',
          DisplayLabel: 'ISO kontoinsättning saknar streck',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarEjAttesteradeAndringar: {
          AttributeName: 'HarEjAttesteradeAndringar',
          DisplayLabel: 'Har ej attesterade ändringar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantorBlob',
          AssociatedComponentName: 'LeverantorBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Leverantorskategori: {
          AssociationName: 'Leverantorskategori',
          DisplayLabel: 'Leverantörskategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorkat',
          AssociatedComponentName: 'Leverantorkat',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leveransvillkor: {
          AssociationName: 'Leveransvillkor',
          DisplayLabel: 'Leveransvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLeveransvillkor',
          AssociatedComponentName: 'Leveransvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sprak: {
          AssociationName: 'Sprak',
          DisplayLabel: 'Språk',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtlandskMoms: {
          AssociationName: 'UtlandskMoms',
          DisplayLabel: 'Utländsk moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'UtlandskMomsAutomatkontering',
          JoinAssociation: true,
          ValidInComps: ['EKUtlandskMomsAutomatkontering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturor: {
          AssociationName: 'Fakturor',
          DisplayLabel: 'Fakturor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        LevBetalningssatt: {
          AssociationName: 'LevBetalningssatt',
          DisplayLabel: 'Leverantörens betalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLevBetsatt',
          AssociatedComponentName: 'LevBetsatt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestforslag: {
          AssociationName: 'Attestforslag',
          DisplayLabel: 'Leverantörsfakturareferenser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslag',
          AssociatedComponentName: 'Attestforslag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLeverantorBlob: {
      CollectionName: 'LRLeverantorBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LeverantorBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'LRLeverantorBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'LRLeverantorBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'LRLeverantorBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'LRLeverantorBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Bild',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRLeverantorAttest: {
      CollectionName: 'LRLeverantorAttest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '10022']]),
      RootType: {
        TypeValue: 'LeverantorAttest',
        Abstract: false,
        SOLabel: 'Leverantörsattest',
        SOGLabel: 'Leverantörsattests',
        SBLabel: 'Leverantörsattesten',
        SBGLabel: 'Leverantörsattestens',
        POLabel: 'Leverantörsattester',
        POGLabel: 'Leverantörsattesters',
        PBLabel: 'Leverantörsattesterna',
        PBGLabel: 'Leverantörsattesternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörsattestens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörsattestens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörsattestens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTEST_TIMESTAMP: {
          AttributeName: 'ATTEST_TIMESTAMP',
          DisplayLabel: 'Attesterad, tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTEST_USER_ID: {
          AttributeName: 'ATTEST_USER_ID',
          DisplayLabel: 'Attesterad, användar id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ska attesteras/Attesterad/Ej godkänd/Korrigerad',
          DataType: 'Enum',
          EnumValues: new Map([['SKA_ATTESTERAS', 'Ska attesteras'], ['ATTESTERAD', 'Attesterad'], ['EJ_GODKAND', 'Ej godkänd'], ['KORRIGERAD', 'Korrigerad']]),
          EnumSortValues: new Map([['SKA_ATTESTERAS', 'S'], ['ATTESTERAD', 'A'], ['EJ_GODKAND', 'E'], ['KORRIGERAD', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKA_ATTESTERAS=Ska attesteras;ATTESTERAD=Attesterad;EJ_GODKAND=Ej godkänd;KORRIGERAD=Korrigerad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        ForstaLoggTid: {
          AttributeName: 'ForstaLoggTid',
          DisplayLabel: 'Första ändring, tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ANDRA_ATTEST_USER_ID: {
          AttributeName: 'ANDRA_ATTEST_USER_ID',
          DisplayLabel: 'Andra Attesterad, användar id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANDRA_ATTEST_TIMESTAMP: {
          AttributeName: 'ANDRA_ATTEST_TIMESTAMP',
          DisplayLabel: 'Andra attesterad, tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAMINNELSE_DATUM: {
          AttributeName: 'PAMINNELSE_DATUM',
          DisplayLabel: 'Senaste påminnelsen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAMINNELSE_SKICKAT_TILL: {
          AttributeName: 'PAMINNELSE_SKICKAT_TILL',
          DisplayLabel: 'Påminnelser skickat till, ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AttestUser: {
          AssociationName: 'AttestUser',
          DisplayLabel: 'Attesterad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AndraAttestUser: {
          AssociationName: 'AndraAttestUser',
          DisplayLabel: 'Attesterad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorAttestLogg',
          AssociatedComponentName: 'LeverantorAttestLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLeverantorAttestLogg: {
      CollectionName: 'LRLeverantorAttestLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LeverantorAttestLogg',
        Abstract: false,
        SOLabel: 'Leverantörsattest, logg',
        SOGLabel: 'Leverantörsattests, logg',
        SBLabel: 'Leverantörsattesten, logg',
        SBGLabel: 'Leverantörsattestens, logg',
        POLabel: 'Leverantörsattester, logg',
        POGLabel: 'Leverantörsattesters, logg',
        PBLabel: 'Leverantörsattesterna, logg',
        PBGLabel: 'Leverantörsattesternas, logg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörsattestens, logg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörsattestens, logg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörsattestens, logg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTBETSATT_LOPNR: {
          AttributeName: 'UTBETSATT_LOPNR',
          DisplayLabel: 'Utbetsätt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOGGTYPE: {
          AttributeName: 'LOGGTYPE',
          DisplayLabel: 'Typ av ändring',
          Hint: 'Tillägg/Borttag/Ändring',
          DataType: 'Enum',
          EnumValues: new Map([['TILLAGG', 'Tillägg'], ['BORTTAG', 'Borttag'], ['ANDRING', 'Ändring']]),
          EnumSortValues: new Map([['TILLAGG', 'I'], ['BORTTAG', 'D'], ['ANDRING', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLAGG=Tillägg;BORTTAG=Borttag;ANDRING=Ändring"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        LOGG_TEXT: {
          AttributeName: 'LOGG_TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        LOGG_TIMESTAMP: {
          AttributeName: 'LOGG_TIMESTAMP',
          DisplayLabel: 'Logg, timestamp',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOGG_USER_SIGN: {
          AttributeName: 'LOGG_USER_SIGN',
          DisplayLabel: 'Logg, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GiltigEnlBGPG: {
          AttributeName: 'GiltigEnlBGPG',
          DisplayLabel: 'Giltig enligt BG/PG',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        LOGG_KONTO_NR: {
          AttributeName: 'LOGG_KONTO_NR',
          DisplayLabel: 'Logg, kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGG_BETSATT_ID: {
          AttributeName: 'LOGG_BETSATT_ID',
          DisplayLabel: 'Logg, betsatt id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOGG_AUTOGIRO: {
          AttributeName: 'LOGG_AUTOGIRO',
          DisplayLabel: 'Logg, Autogiro',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGG_UTLAND_BETSATT_TYP: {
          AttributeName: 'LOGG_UTLAND_BETSATT_TYP',
          DisplayLabel: 'Logg, Typ av kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGG_BANK_ID: {
          AttributeName: 'LOGG_BANK_ID',
          DisplayLabel: 'Logg, Bank',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGG_FACT_ORG_NR: {
          AttributeName: 'LOGG_FACT_ORG_NR',
          DisplayLabel: 'Logg, faktoring orgnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 26,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UserSign: {
          AttributeName: 'UserSign',
          DisplayLabel: 'Användarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UserName: {
          AttributeName: 'UserName',
          DisplayLabel: 'Användarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UserID: {
          AttributeName: 'UserID',
          DisplayLabel: 'Användarens id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BGPGUrl: {
          AttributeName: 'BGPGUrl',
          DisplayLabel: 'Länk till BG/PG',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Utbetalningssatt: {
          AssociationName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leverantorsattest: {
          AssociationName: 'Leverantorsattest',
          DisplayLabel: 'Leverantörsattest',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorAttest',
          AssociatedComponentName: 'LeverantorAttest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRAttestforslag: {
      CollectionName: 'LRAttestforslag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Attestforslag',
        Abstract: false,
        SOLabel: 'Leverantörsfakturareferens',
        SOGLabel: 'Leverantörsfakturareferens',
        SBLabel: 'Leverantörsfakturareferensen',
        SBGLabel: 'Leverantörsfakturareferensens',
        POLabel: 'Leverantörsfakturareferenser',
        POGLabel: 'Leverantörsfakturareferensers',
        PBLabel: 'Leverantörsfakturareferenserna',
        PBGLabel: 'Leverantörsfakturareferensernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörsfakturareferensens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörsfakturareferensens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörsfakturareferensens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörsfakturareferensens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Används ej - Attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Används ej - Attesträtt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGANDE_ENHET_ID: {
          AttributeName: 'MOTTAGANDE_ENHET_ID',
          DisplayLabel: 'Mottagande enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURAKOD_ID: {
          AttributeName: 'FAKTURAKOD_ID',
          DisplayLabel: 'Fakturakod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTTYP: {
          AttributeName: 'ATTESTTYP',
          DisplayLabel: 'Används inte längre: Attesttyp',
          Hint: 'Används inte längre - Beslutsattest/Mottagningsattest',
          DataType: 'Enum',
          EnumValues: new Map([['BESLUTSATTEST', 'Beslutsattest'], ['MOTTAGNINGSATTEST', 'Mottagningsattest']]),
          EnumSortValues: new Map([['BESLUTSATTEST', 'B'], ['MOTTAGNINGSATTEST', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESLUTSATTEST=Beslutsattest;MOTTAGNINGSATTEST=Mottagningsattest"',
        },
        LEVERANTOR_ID: {
          AttributeName: 'LEVERANTOR_ID',
          DisplayLabel: 'Leverantör, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURARADSKOD_ID: {
          AttributeName: 'FAKTURARADSKOD_ID',
          DisplayLabel: 'FAKTURARADSKOD_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTGRUPP_ID: {
          AttributeName: 'ATTESTGRUPP_ID',
          DisplayLabel: 'Används ej - ATTESTGRUPP_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGNINGSATTEST_OMR_ID: {
          AttributeName: 'MOTTAGNINGSATTEST_OMR_ID',
          DisplayLabel: 'Används ej - MOTTANINGSATTEST_OMR_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGNINGSATTEST_LOPNR: {
          AttributeName: 'MOTTAGNINGSATTEST_LOPNR',
          DisplayLabel: 'Används ej - MOTTAGNINGSATTEST_LOPNR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REFERENS: {
          AttributeName: 'REFERENS',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        REFERENS_SOKTYP: {
          AttributeName: 'REFERENS_SOKTYP',
          DisplayLabel: 'Söktyp för referens',
          Hint: 'Exakt/Börjar på/Fritext',
          DataType: 'Enum',
          EnumValues: new Map([['EXAKT', 'Exakt'], ['BORJAR_PA', 'Börjar på'], ['FRITEXT', 'Fritext']]),
          EnumSortValues: new Map([['EXAKT', 'E'], ['BORJAR_PA', 'B'], ['FRITEXT', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXAKT=Exakt;BORJAR_PA=Börjar på;FRITEXT=Fritext"',
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Attestanter/Kontering/Attestanter och kontering',
          DataType: 'Enum',
          EnumValues: new Map([['ATTESTANTER', 'Attestanter'], ['KONTERING', 'Kontering'], ['ATTESTANTER_OCH_KONTERING', 'Attestanter och kontering']]),
          EnumSortValues: new Map([['ATTESTANTER', 'A'], ['KONTERING', 'K'], ['ATTESTANTER_OCH_KONTERING', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATTESTANTER=Attestanter;KONTERING=Kontering;ATTESTANTER_OCH_KONTERING=Attestanter och kontering"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_FOR: {
          AttributeName: 'GILTIG_FOR',
          DisplayLabel: 'Giltig för',
          Hint: 'KOB-fakturor/Övriga fakturor',
          DataType: 'Enum',
          EnumValues: new Map([['KOB_FAKTUROR', 'KOB-fakturor'], ['OVRIGA_FAKTUROR', 'Övriga fakturor']]),
          EnumSortValues: new Map([['KOB_FAKTUROR', 'K'], ['OVRIGA_FAKTUROR', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KOB_FAKTUROR=KOB-fakturor;OVRIGA_FAKTUROR=Övriga fakturor"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        FAKTURARADSKOD: {
          AttributeName: 'FAKTURARADSKOD',
          DisplayLabel: 'Fakturaradskod/Artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Attestantreferens: {
          AttributeName: 'Attestantreferens',
          DisplayLabel: 'Attestantreferens',
          Hint: 'Den del av referensen som  styr attestanter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konteringsreferens: {
          AttributeName: 'Konteringsreferens',
          DisplayLabel: 'Konteringsreferens',
          Hint: 'Den del av referensen som styr kontering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MotAttestanter: {
          AttributeName: 'MotAttestanter',
          DisplayLabel: 'Mottagningsattestanter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BesAttestanter: {
          AttributeName: 'BesAttestanter',
          DisplayLabel: 'Beslutsattestanter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Attestgrupper: {
          AttributeName: 'Attestgrupper',
          DisplayLabel: 'Attestgrupper',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAnvand: {
          AttributeName: 'SenastAnvand',
          DisplayLabel: 'Senast använd',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturakod: {
          AssociationName: 'Fakturakod',
          DisplayLabel: 'Fakturakod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFakturakod',
          AssociatedComponentName: 'Fakturakod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        MottagandeEnhet: {
          AssociationName: 'MottagandeEnhet',
          DisplayLabel: 'Mottagande enhet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaradskod: {
          AssociationName: 'Fakturaradskod',
          DisplayLabel: 'Fakturaradskod',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturaradskod',
          AssociatedComponentName: 'Fakturaradskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringar: {
          AssociationName: 'Konteringar',
          DisplayLabel: 'Konteringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslagKontering',
          AssociatedComponentName: 'AttestforslagKontering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ForslagDel: {
          AssociationName: 'ForslagDel',
          DisplayLabel: 'Förslagsdel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestforslagDel',
          AssociatedComponentName: 'AttestforslagDel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLeverantorfaktura: {
      CollectionName: 'LRLeverantorfaktura',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Bokfgrupp'], ['USER_DEF_REPORT_ROUTINE', '10019'], ['AllowEdit', '15002'], ['AllowSelection', '17002']]),
      RootType: {
        TypeValue: 'Faktura',
        Abstract: true,
        SOLabel: 'Leverantörsfaktura',
        SOGLabel: 'Leverantörsfaktura',
        SBLabel: 'Leverantörsfakturan',
        SBGLabel: 'Leverantörsfakturan',
        POLabel: 'Leverantörsfakturor',
        POGLabel: 'Leverantörsfakturor',
        PBLabel: 'Leverantörsfakturorna',
        PBGLabel: 'Leverantörsfakturorna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Debetfaktura',
            Abstract: false,
            SOLabel: 'Debetfaktura',
            SOGLabel: 'Debetfaktura',
            SBLabel: 'Debetfakturan',
            SBGLabel: 'Debetfakturan',
            POLabel: 'Debetfakturor',
            POGLabel: 'Debetfakturor',
            PBLabel: 'Debetfakturorna',
            PBGLabel: 'Debetfakturorna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Kreditfaktura',
            Abstract: false,
            SOLabel: 'Kreditfaktura',
            SOGLabel: 'Kreditfaktura',
            SBLabel: 'Kreditfakturan',
            SBGLabel: 'Kreditfakturan',
            POLabel: 'Kreditfakturor',
            POGLabel: 'Kreditfakturor',
            PBLabel: 'Kreditfakturorna',
            PBGLabel: 'Kreditfakturorna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörsfakturan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörsfakturan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['DEBETFAKTURA', 'Debetfaktura'], ['KREDITFAKTURA', 'Kreditfaktura']]),
          EnumSortValues: new Map([['DEBETFAKTURA', 'D'], ['KREDITFAKTURA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBETFAKTURA=Debetfaktura;KREDITFAKTURA=Kreditfaktura"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörsfakturan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörsfakturan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVERANTOR_ID: {
          AttributeName: 'LEVERANTOR_ID',
          DisplayLabel: 'LeverantörsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_NR: {
          AttributeName: 'FAKTURA_NR',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 27,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SLUTBETALD: {
          AttributeName: 'SLUTBETALD',
          DisplayLabel: 'Slutbetald',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ankomstregistrerad/Definitivbokad/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['ANKOMSTREGISTRERAD', 'Ankomstregistrerad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['ANKOMSTREGISTRERAD', 'A'], ['DEFINITIVBOKAD', 'D'], ['MAKULERAD', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANKOMSTREGISTRERAD=Ankomstregistrerad;DEFINITIVBOKAD=Definitivbokad;MAKULERAD=Makulerad"',
        },
        ANKREG_DATUM: {
          AttributeName: 'ANKREG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        ANKREG_ANV_ID: {
          AttributeName: 'ANKREG_ANV_ID',
          DisplayLabel: 'Registrerat av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPARRAD: {
          AttributeName: 'SPARRAD',
          DisplayLabel: 'Spärrad (används ej)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Övrigt',
        },
        BETALNINGSUPPDRAG_ID: {
          AttributeName: 'BETALNINGSUPPDRAG_ID',
          DisplayLabel: 'Betalningsuppdrag ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURADATUM: {
          AttributeName: 'FAKTURADATUM',
          DisplayLabel: 'Fakturadatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinDate="-36m";MaxDate="+7d";MinRecommendedDate="-2m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        FORFALLO_DATUM: {
          AttributeName: 'FORFALLO_DATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+48m";MinDate="-48m";MaxRecommendedDate="+3m";MinRecommendedDate="-1m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        HANDELSE_BOKF_GRUPP_ID: {
          AttributeName: 'HANDELSE_BOKF_GRUPP_ID',
          DisplayLabel: 'Registreringshändelsens bokfgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Registreringshändelsens id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANKREG_BOKF_GRUPP_ID: {
          AttributeName: 'ANKREG_BOKF_GRUPP_ID',
          DisplayLabel: 'Bokf.grupp för ankomstregistrering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ANKREG_ID: {
          AttributeName: 'ANKREG_ID',
          DisplayLabel: 'Händelse id för ankomstregistrering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        DEFBOK_BOKF_GRUPP_ID: {
          AttributeName: 'DEFBOK_BOKF_GRUPP_ID',
          DisplayLabel: 'Bokf.grupp för definitivbokning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        DEFBOK_ID: {
          AttributeName: 'DEFBOK_ID',
          DisplayLabel: 'Händelseid för definitivbokningen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SLUTBETALD_DATUM: {
          AttributeName: 'SLUTBETALD_DATUM',
          DisplayLabel: 'Slutbetald, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Momsid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FakturaBelopp: {
          AttributeName: 'FakturaBelopp',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Belopp',
        },
        Fakturabelopp2: {
          AttributeName: 'Fakturabelopp2',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        MomsBelopp: {
          AttributeName: 'MomsBelopp',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        MomsBelopp2: {
          AttributeName: 'MomsBelopp2',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        ValutaBelopp: {
          AttributeName: 'ValutaBelopp',
          DisplayLabel: 'Fakturabelopp i valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        ValutaBelopp2: {
          AttributeName: 'ValutaBelopp2',
          DisplayLabel: 'Fakturabelopp i valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        ValutaMomsBelopp: {
          AttributeName: 'ValutaMomsBelopp',
          DisplayLabel: 'Momsbelopp i valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        ValutaMomsBelopp2: {
          AttributeName: 'ValutaMomsBelopp2',
          DisplayLabel: 'Momsbelopp i valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        FakturaSaldo: {
          AttributeName: 'FakturaSaldo',
          DisplayLabel: 'Fakturasaldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        FakturaSaldo2: {
          AttributeName: 'FakturaSaldo2',
          DisplayLabel: 'Fakturasaldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        FakturaValutaSaldo: {
          AttributeName: 'FakturaValutaSaldo',
          DisplayLabel: 'Fakturasaldo i valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        FakturaValutaSaldo2: {
          AttributeName: 'FakturaValutaSaldo2',
          DisplayLabel: 'Fakturasaldo i valuta',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        FakturaRubrik: {
          AttributeName: 'FakturaRubrik',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SenasteBetalnDatum: {
          AttributeName: 'SenasteBetalnDatum',
          DisplayLabel: 'Senaste betalningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        Fakturatyp: {
          AttributeName: 'Fakturatyp',
          DisplayLabel: 'Fakturatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        RegBokfar: {
          AttributeName: 'RegBokfar',
          DisplayLabel: 'Bokföringsår för registrering',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        RegVernr: {
          AttributeName: 'RegVernr',
          DisplayLabel: 'Verifikationsnummer för registrering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegVerdatum: {
          AttributeName: 'RegVerdatum',
          DisplayLabel: 'Bokföringsdatum för registrering',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Leverantor: {
          AttributeName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Leverantorsnr: {
          AttributeName: 'Leverantorsnr',
          DisplayLabel: 'Leverantörsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ValutaId: {
          AttributeName: 'ValutaId',
          DisplayLabel: 'ValutaId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Valutakod: {
          AttributeName: 'Valutakod',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
        },
        BeloppTillBetalning: {
          AttributeName: 'BeloppTillBetalning',
          DisplayLabel: 'Belopp på väg till betalning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Belopp',
        },
        RegVernr2: {
          AttributeName: 'RegVernr2',
          DisplayLabel: 'RegVernr2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegVerdatum2: {
          AttributeName: 'RegVerdatum2',
          DisplayLabel: 'RegVerdatum2',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegJournalID: {
          AttributeName: 'RegJournalID',
          DisplayLabel: 'RegJournalID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnkregVerdatum: {
          AttributeName: 'AnkregVerdatum',
          DisplayLabel: 'Bokf.datum för ankomst.reg',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        RegVertext: {
          AttributeName: 'RegVertext',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnkregBelopp: {
          AttributeName: 'AnkregBelopp',
          DisplayLabel: 'AnkregBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        AnkregValutaBelopp: {
          AttributeName: 'AnkregValutaBelopp',
          DisplayLabel: 'AnkregValutaBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        BESTALLNINGS_NR: {
          AttributeName: 'BESTALLNINGS_NR',
          DisplayLabel: 'Arbetsorder/Bestnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        Betalningssaldo: {
          AttributeName: 'Betalningssaldo',
          DisplayLabel: 'Betalningssaldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        ELEKTRONISK_ATTEST: {
          AttributeName: 'ELEKTRONISK_ATTEST',
          DisplayLabel: 'Elektronisk attest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        Detaljstatus: {
          AttributeName: 'Detaljstatus',
          DisplayLabel: 'Fakturastatus, detaljerad',
          Hint: 'Status ej definierad/Ej utdelad för attest/Ej utdelad för beslutsattest/Hos central administratör/Under utredning/Felaktig beloppsattest/Otillräcklig attest/Mottagningsattesteras/Beslutsattesteras/I utkorg/Attesterad/Definitivbokad/På väg till betalning/Spärrad/Delbetald/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['STATUS_EJ_DEFINIERAD', 'Status ej definierad'], ['EJ_UTDELAD_FOR_ATTEST', 'Ej utdelad för attest'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', 'Ej utdelad för beslutsattest'], ['HOS_CENTRAL_ADMINISTRATOR', 'Hos central administratör'], ['UNDER_UTREDNING', 'Under utredning'], ['FELAKTIG_BELOPPSATTEST', 'Felaktig beloppsattest'], ['OTILLRACKLIG_ATTEST', 'Otillräcklig attest'], ['MOTTAGNINGSATTESTERAS', 'Mottagningsattesteras'], ['BESLUTSATTESTERAS', 'Beslutsattesteras'], ['I_UTKORG', 'I utkorg'], ['ATTESTERAD', 'Attesterad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['SPARRAD', 'Spärrad'], ['DELBETALD', 'Delbetald'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['STATUS_EJ_DEFINIERAD', '010'], ['EJ_UTDELAD_FOR_ATTEST', '020'], ['EJ_UTDELAD_FOR_BESLUTSATTEST', '022'], ['HOS_CENTRAL_ADMINISTRATOR', '025'], ['UNDER_UTREDNING', '030'], ['FELAKTIG_BELOPPSATTEST', '035'], ['OTILLRACKLIG_ATTEST', '038'], ['MOTTAGNINGSATTESTERAS', '040'], ['BESLUTSATTESTERAS', '050'], ['I_UTKORG', '055'], ['ATTESTERAD', '060'], ['DEFINITIVBOKAD', '070'], ['PA_VAG_TILL_BETALNING', '080'], ['SPARRAD', '090'], ['DELBETALD', '100'], ['BETALD', '110'], ['MAKULERAD', '120']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STATUS_EJ_DEFINIERAD=Status ej definierad;EJ_UTDELAD_FOR_ATTEST=Ej utdelad för attest;EJ_UTDELAD_FOR_BESLUTSATTEST=Ej utdelad för beslutsattest;HOS_CENTRAL_ADMINISTRATOR=Hos central administratör;UNDER_UTREDNING=Under utredning;FELAKTIG_BELOPPSATTEST=Felaktig beloppsattest;OTILLRACKLIG_ATTEST=Otillräcklig attest;MOTTAGNINGSATTESTERAS=Mottagningsattesteras;BESLUTSATTESTERAS=Beslutsattesteras;I_UTKORG=I utkorg;ATTESTERAD=Attesterad;DEFINITIVBOKAD=Definitivbokad;PA_VAG_TILL_BETALNING=På väg till betalning;SPARRAD=Spärrad;DELBETALD=Delbetald;BETALD=Betald;MAKULERAD=Makulerad"',
          InterfaceType: 'ifChecklist',
        },
        DefAnkVernr: {
          AttributeName: 'DefAnkVernr',
          DisplayLabel: 'Verifikationsnr',
          Hint: 'Verifikationsnr från definitivbokning och ankomstregistrering, ex 20078 (90453)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        INVOICE_BUNTNR: {
          AttributeName: 'INVOICE_BUNTNR',
          DisplayLabel: 'Tolkade fakturor, buntnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tolkning',
        },
        INVOICE_ID: {
          AttributeName: 'INVOICE_ID',
          DisplayLabel: 'Tolkade fakturor, fakturaid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tolkning',
        },
        AttesteradAvSign: {
          AttributeName: 'AttesteradAvSign',
          DisplayLabel: 'AttesteradAvSign',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnkregNr: {
          AttributeName: 'AnkregNr',
          DisplayLabel: 'Vernr för ankomstregistrering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        InternFakturabelopp: {
          AttributeName: 'InternFakturabelopp',
          DisplayLabel: 'InternFakturabelopp',
          Hint: 'Anv internt, skall vara identisk med Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Fakturastatus: {
          AttributeName: 'Fakturastatus',
          DisplayLabel: 'Fakturastatus',
          Hint: 'Ankomstregistrerad/Definitivbokad/På väg till betalning/Delbetald/Betald/Makulerad',
          DataType: 'Enum',
          EnumValues: new Map([['ANKOMSTREGISTRERAD', 'Ankomstregistrerad'], ['DEFINITIVBOKAD', 'Definitivbokad'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['DELBETALD', 'Delbetald'], ['BETALD', 'Betald'], ['MAKULERAD', 'Makulerad']]),
          EnumSortValues: new Map([['ANKOMSTREGISTRERAD', '10'], ['DEFINITIVBOKAD', '20'], ['PA_VAG_TILL_BETALNING', '30'], ['DELBETALD', '40'], ['BETALD', '50'], ['MAKULERAD', '60']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANKOMSTREGISTRERAD=Ankomstregistrerad;DEFINITIVBOKAD=Definitivbokad;PA_VAG_TILL_BETALNING=På väg till betalning;DELBETALD=Delbetald;BETALD=Betald;MAKULERAD=Makulerad"',
          InterfaceType: 'ifChecklist',
        },
        BetalningSparrad: {
          AttributeName: 'BetalningSparrad',
          DisplayLabel: 'Spärrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        FaktstatusSparr: {
          AttributeName: 'FaktstatusSparr',
          DisplayLabel: 'FaktstatusSparr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarFakturabild: {
          AttributeName: 'HarFakturabild',
          DisplayLabel: 'Har fakturabild',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        AntalFakturadelar: {
          AttributeName: 'AntalFakturadelar',
          DisplayLabel: 'AntalFakturadelar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        INVOICE_ER_REF: {
          AttributeName: 'INVOICE_ER_REF',
          DisplayLabel: 'Tolkade fakturor, er referens',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Tolkning',
        },
        BetalningSparrad2: {
          AttributeName: 'BetalningSparrad2',
          DisplayLabel: 'BetalningSpärrad2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGANDE_ENHET_ID: {
          AttributeName: 'MOTTAGANDE_ENHET_ID',
          DisplayLabel: 'MOTTAGANDE_ENHET_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FakturakodId: {
          AttributeName: 'FakturakodId',
          DisplayLabel: 'FakturakodId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'INVOICE_FAKTURAKOD': {type: 'String', defaultValue: ''}},
        },
        Fakturaformat: {
          AttributeName: 'Fakturaformat',
          DisplayLabel: 'Fakturaformat',
          Hint: 'JPG/TIF/TIFF/BMP/Invoice/KOB/Svefaktura',
          DataType: 'Enum',
          EnumValues: new Map([['JPG', 'JPG'], ['TIF_TIFF', 'TIF/TIFF'], ['BMP', 'BMP'], ['INVOICE', 'Invoice'], ['KOB', 'KOB'], ['SVEFAKTURA', 'Svefaktura']]),
          EnumSortValues: new Map([['JPG', 'JPEG'], ['TIF_TIFF', 'TIF'], ['BMP', 'BMP'], ['INVOICE', 'INV'], ['KOB', 'KOB'], ['SVEFAKTURA', 'SVE']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JPG=JPG;TIF_TIFF=TIF/TIFF;BMP=BMP;INVOICE=Invoice;KOB=KOB;SVEFAKTURA=Svefaktura"',
        },
        Verifikationsnr: {
          AttributeName: 'Verifikationsnr',
          DisplayLabel: 'Verifikationsnr',
          Hint: 'Verifikationsnr för någon av fakturans händelser',
          DataType: 'Int',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Bokfar: {
          AttributeName: 'Bokfar',
          DisplayLabel: 'Bokföringsår',
          Hint: 'Bokföringsår för någon av fakturans händelser',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RuleSidNr1: {
          AttributeName: 'RuleSidNr1',
          DisplayLabel: 'RuleSidNr1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        PaminnelseSkickad: {
          AttributeName: 'PaminnelseSkickad',
          DisplayLabel: 'Påminnelse skickad till första attestant',
          Hint: 'Används för att kontrollera att man fått iväg första påminnelsen vid bokföring av journal - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SkannadSvefaktura: {
          AttributeName: 'SkannadSvefaktura',
          DisplayLabel: 'Skannad via Svefaktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SenasteJusteringsdatum: {
          AttributeName: 'SenasteJusteringsdatum',
          DisplayLabel: 'Justerad datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Attestmeddelande: {
          AttributeName: 'Attestmeddelande',
          DisplayLabel: 'Attestmeddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteAttestmeddelandet: {
          AttributeName: 'SenasteAttestmeddelandet',
          DisplayLabel: 'Senaste attestmeddelandet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestmeddelandeSQL: {
          AttributeName: 'AttestmeddelandeSQL',
          DisplayLabel: 'Attestmeddelande',
          Hint: 'Kan användas i tabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Utbetalningssatt: {
          AttributeName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Utbetalningsvag: {
          AttributeName: 'Utbetalningsvag',
          DisplayLabel: 'Utbetalningsväg, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ObetaldPerDatum: {
          AttributeName: 'ObetaldPerDatum',
          DisplayLabel: 'Obetald per datum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        PrimarAttestgrupp: {
          AttributeName: 'PrimarAttestgrupp',
          DisplayLabel: 'Primär attestgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        FinnsOhamtadeBilagor: {
          AttributeName: 'FinnsOhamtadeBilagor',
          DisplayLabel: 'Finns ej hämtade bilagor från KOB',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        ANVANT_LEVFAKTREF_NR: {
          AttributeName: 'ANVANT_LEVFAKTREF_NR',
          DisplayLabel: 'Använd leverantörsfakturareferens',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NullID: {
          AttributeName: 'NullID',
          DisplayLabel: 'NullID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MotkontoKontodel: {
          AttributeName: 'MotkontoKontodel',
          DisplayLabel: 'Används av arkiveringsfunktionen för att hitta levres.skuld.konto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SaldoPerDatum: {
          AttributeName: 'SaldoPerDatum',
          DisplayLabel: 'Saldo per datum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'spd_datum': {type: 'Date', defaultValue: ''}},
        },
        FakturaForAnlaggningsnr: {
          AttributeName: 'FakturaForAnlaggningsnr',
          DisplayLabel: 'Faktura för anläggningsnr',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        FakturaForUpprakningsnr: {
          AttributeName: 'FakturaForUpprakningsnr',
          DisplayLabel: 'Fakturor för investering',
          Hint: 'Input på formatet B0002-1, där B0002 är anläggningsnr och 1 är investeringsnumret',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        FakturaForInvesteringsrad: {
          AttributeName: 'FakturaForInvesteringsrad',
          DisplayLabel: 'Faktura för investeringsrad',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
        },
        DefinitivbokadDatum: {
          AttributeName: 'DefinitivbokadDatum',
          DisplayLabel: 'Definitivbokad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        ForstaUtbetorderDatum: {
          AttributeName: 'ForstaUtbetorderDatum',
          DisplayLabel: 'Utbetalningsorder, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        AntalDgrBetEfterForfallo: {
          AttributeName: 'AntalDgrBetEfterForfallo',
          DisplayLabel: 'Antal dagar från förfallodatum till betalning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notinterval,
          AttributeGroup: 'Datum',
        },
        AnkomstregistreradDatum: {
          AttributeName: 'AnkomstregistreradDatum',
          DisplayLabel: 'Ankomstregistrerad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
        },
        HarDokument: {
          AttributeName: 'HarDokument',
          DisplayLabel: 'Har dokument',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        AntalDokument: {
          AttributeName: 'AntalDokument',
          DisplayLabel: 'Antal dokument',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        HarMeddelande: {
          AttributeName: 'HarMeddelande',
          DisplayLabel: 'Har meddelande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Matchad: {
          AttributeName: 'Matchad',
          DisplayLabel: 'Matchad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        FakturabeloppKredittext: {
          AttributeName: 'FakturabeloppKredittext',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTO_ANKREG: {
          AttributeName: 'AUTO_ANKREG',
          DisplayLabel: 'Automatiskt ankomstregistrerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FelaktigtSlutbetDatum: {
          AttributeName: 'FelaktigtSlutbetDatum',
          DisplayLabel: 'Felaktigt slutbet datum',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        AttesteradWebAveny: {
          AttributeName: 'AttesteradWebAveny',
          DisplayLabel: 'Attesterad i WebAveny',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        MOMSHANTERING: {
          AttributeName: 'MOMSHANTERING',
          DisplayLabel: 'Momshantering',
          Hint: 'Ej hanterat/Svensk, enligt leverantör/Svensk, enligt koddel/Utländsk, enligt koddel/Utländsk, enligt leverantör',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_HANTERAT', 'Ej hanterat'], ['SVENSK__ENLIGT_LEVERANTOR', 'Svensk, enligt leverantör'], ['SVENSK__ENLIGT_KODDEL', 'Svensk, enligt koddel'], ['UTLANDSK__ENLIGT_KODDEL', 'Utländsk, enligt koddel'], ['UTLANDSK__ENLIGT_LEVERANTOR', 'Utländsk, enligt leverantör']]),
          EnumSortValues: new Map([['EJ_HANTERAT', 'I'], ['SVENSK__ENLIGT_LEVERANTOR', 'L'], ['SVENSK__ENLIGT_KODDEL', 'V'], ['UTLANDSK__ENLIGT_KODDEL', 'U'], ['UTLANDSK__ENLIGT_LEVERANTOR', '1']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_HANTERAT=Ej hanterat;SVENSK__ENLIGT_LEVERANTOR=Svensk, enligt leverantör;SVENSK__ENLIGT_KODDEL=Svensk, enligt koddel;UTLANDSK__ENLIGT_KODDEL=Utländsk, enligt koddel;UTLANDSK__ENLIGT_LEVERANTOR=Utländsk, enligt leverantör"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        TolkatMomsbelopp: {
          AttributeName: 'TolkatMomsbelopp',
          DisplayLabel: 'Tolkat momsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Övrigt',
        },
        KalkMomssats: {
          AttributeName: 'KalkMomssats',
          DisplayLabel: 'Kalkylerad momssats',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
          AttributeGroup: 'Övrigt',
        },
        IngaendeMomsBaskonto: {
          AttributeName: 'IngaendeMomsBaskonto',
          DisplayLabel: 'Ingående moms baskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Momsbelopptolerans: {
          AttributeName: 'Momsbelopptolerans',
          DisplayLabel: 'Momsbelopp, tolerans',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        HarPeriodisering: {
          AttributeName: 'HarPeriodisering',
          DisplayLabel: 'Periodiserad vid attest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        BetalningsdagarEnligtFaktura: {
          AttributeName: 'BetalningsdagarEnligtFaktura',
          DisplayLabel: 'Betalningsdagar enligt faktura',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Övrigt',
        },
        FaktiskaBetalningsdagar: {
          AttributeName: 'FaktiskaBetalningsdagar',
          DisplayLabel: 'Faktiska betalningsdagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Övrigt',
        },
        ForsenadBetalning: {
          AttributeName: 'ForsenadBetalning',
          DisplayLabel: 'Betalning försenad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifChecklist',
        },
        DUBLETT_IGNORERAD: {
          AttributeName: 'DUBLETT_IGNORERAD',
          DisplayLabel: 'Dubblett ignorerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        Fakturaformat2: {
          AttributeName: 'Fakturaformat2',
          DisplayLabel: 'Fakturaformat',
          Hint: 'KOB\0A-faktura/Skannad och tolkad/E-faktura/Bild, JPG/Bild, Tif/Bild, BMP/Bild, ReadSoft',
          DataType: 'Enum',
          EnumValues: new Map([['KOB__FAKTURA', 'KOB\0A-faktura'], ['SKANNAD_OCH_TOLKAD', 'Skannad och tolkad'], ['E_FAKTURA', 'E-faktura'], ['BILD__JPG', 'Bild, JPG'], ['BILD__TIF', 'Bild, Tif'], ['BILD__BMP', 'Bild, BMP'], ['BILD__READSOFT', 'Bild, ReadSoft']]),
          EnumSortValues: new Map([['KOB__FAKTURA', 'KOB'], ['SKANNAD_OCH_TOLKAD', 'TOLKAD'], ['E_FAKTURA', 'EFAKT'], ['BILD__JPG', 'JPG'], ['BILD__TIF', 'TIF'], ['BILD__BMP', 'BMP'], ['BILD__READSOFT', 'INV']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KOB__FAKTURA=KOB#0A-faktura;SKANNAD_OCH_TOLKAD=Skannad och tolkad;E_FAKTURA=E-faktura;BILD__JPG=Bild, JPG;BILD__TIF=Bild, Tif;BILD__BMP=Bild, BMP;BILD__READSOFT=Bild, ReadSoft"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Övrigt',
        },
        GRANSKAD_DEFBOK: {
          AttributeName: 'GRANSKAD_DEFBOK',
          DisplayLabel: 'Granskad i förenklad definitivbokning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Granskning',
        },
        GRANSKAD_DEFBOK_SIGN: {
          AttributeName: 'GRANSKAD_DEFBOK_SIGN',
          DisplayLabel: 'Granskad i förenklad definitivbokning, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Granskning',
        },
        GRANSKAD_DEFBOK_DATUM: {
          AttributeName: 'GRANSKAD_DEFBOK_DATUM',
          DisplayLabel: 'Granskad i förenklad definitivbokning, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Granskning',
        },
        HarRiktadeMeddelanden: {
          AttributeName: 'HarRiktadeMeddelanden',
          DisplayLabel: 'Har riktade meddelanden',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarRiktadeMeddelandenEkonom: {
          AttributeName: 'HarRiktadeMeddelandenEkonom',
          DisplayLabel: 'Har riktade meddelande till ekonom',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarMomspliktigRad: {
          AttributeName: 'HarMomspliktigRad',
          DisplayLabel: 'Har momspliktig kontering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        Kontonr: {
          AttributeName: 'Kontonr',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBankgiroNr',
          InterfaceType: 'ifNumeric',
        },
        PaVagTillBetalningBelopp: {
          AttributeName: 'PaVagTillBetalningBelopp',
          DisplayLabel: 'Belopp, på väg till betalning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          AttributeGroup: 'Belopp',
        },
        PaVagTillBetalningLopnr: {
          AttributeName: 'PaVagTillBetalningLopnr',
          DisplayLabel: 'På väg till betalning, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PaVagTillBetalningValutabelopp: {
          AttributeName: 'PaVagTillBetalningValutabelopp',
          DisplayLabel: 'På väg till betalning valutabelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantorfakturaBlob',
          AssociatedComponentName: 'FakturaBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['LEV_NOCOMBINE', 'True']]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Bokfgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Registrering: {
          AssociationName: 'Registrering',
          DisplayLabel: 'Fakturahändelse, definitivbokning/ankomstregistrering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'LRBokfhandelseFaktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        HandelseBokfgrupp: {
          AssociationName: 'HandelseBokfgrupp',
          DisplayLabel: 'HandelseBokfgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ankomstregistrering: {
          AssociationName: 'Ankomstregistrering',
          DisplayLabel: 'Ankomstregistrering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'LRBokfhandelseFaktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ElektroniskFaktura: {
          AssociationName: 'ElektroniskFaktura',
          DisplayLabel: 'Elektronisk faktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabild',
          AssociatedComponentName: 'Fakturabild',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ForeslagenFakturakod: {
          AssociationName: 'ForeslagenFakturakod',
          DisplayLabel: 'Föreslagen Fakturakod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFakturakod',
          AssociatedComponentName: 'Fakturakod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Definitivbokning: {
          AssociationName: 'Definitivbokning',
          DisplayLabel: 'Definitivbokning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'LRBokfhandelseFaktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestanter: {
          AssociationName: 'Attestanter',
          DisplayLabel: 'Attestanter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLevfaktAttestant',
          AssociatedComponentName: 'LevfaktAttestant',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturahandelser: {
          AssociationName: 'Fakturahandelser',
          DisplayLabel: 'Fakturahändelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'LRBokfhandelseFaktura',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningar: {
          AssociationName: 'Betalningar',
          DisplayLabel: 'Betalningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalning',
          AssociatedComponentName: 'Betalning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturadel: {
          AssociationName: 'Fakturadel',
          DisplayLabel: 'Fakturadel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturaDel',
          AssociatedComponentName: 'FakturaDel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsforslag: {
          AssociationName: 'Konteringsforslag',
          DisplayLabel: 'Kontering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRKonteringsForslag',
          AssociatedComponentName: 'KonteringsForslag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturasidor: {
          AssociationName: 'Fakturasidor',
          DisplayLabel: 'Fakturasidor',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRFakturabild',
          AssociatedComponentName: 'Fakturabild',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRFakturaDok',
          AssociatedComponentName: 'FakturaDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestmeddelande: {
          AssociationName: 'Attestmeddelande',
          DisplayLabel: 'Attestmeddelande',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestmeddelande',
          AssociatedComponentName: 'Attestmeddelande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRLeverantorfakturaBlob: {
      CollectionName: 'LRLeverantorfakturaBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FakturaBlob',
        Abstract: false,
        SOLabel: 'Leverantörsfaktura, blob',
        SOGLabel: 'Leverantörsfaktura, blob',
        SBLabel: 'Leverantörsfaktura, blob',
        SBGLabel: 'Leverantörsfaktura, blob',
        POLabel: 'Leverantörsfaktura, blob',
        POGLabel: 'Leverantörsfaktura, blob',
        PBLabel: 'Leverantörsfaktura, blob',
        PBGLabel: 'Leverantörsfaktura, blob',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörsfaktura, blob primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörsfaktura, blob versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörsfaktura, blob id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörsfaktura, blob fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTMEDDELANDE: {
          AttributeName: 'ATTESTMEDDELANDE',
          DisplayLabel: 'Attestmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        MEDDELANDE_ANDRAT: {
          AttributeName: 'MEDDELANDE_ANDRAT',
          DisplayLabel: 'Meddelande ändrat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRLeverantorkat: {
      CollectionName: 'LRLeverantorkat',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Leverantorkat',
        Abstract: false,
        SOLabel: 'Leverantörskategorin',
        SOGLabel: 'Leverantörskategorin',
        SBLabel: 'Leverantörskategori',
        SBGLabel: 'Leverantörskategori',
        POLabel: 'Leverantörskategorier',
        POGLabel: 'Leverantörskategorier',
        PBLabel: 'Leverantörskategorierna',
        PBGLabel: 'Leverantörskategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leverantörskategori primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leverantörskategori versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leverantörskategori id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leverantörskategori fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        INTERN: {
          AttributeName: 'INTERN',
          DisplayLabel: 'Intern',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Moms',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVNRSERIE_ID: {
          AttributeName: 'LEVNRSERIE_ID',
          DisplayLabel: 'Leverantörsnummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKostnadskonto: {
          AttributeName: 'KBKostnadskonto',
          DisplayLabel: 'KBKostnadskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBLevskuldkonto: {
          AttributeName: 'KBLevskuldkonto',
          DisplayLabel: 'KBLevskuldkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD_BETKAT: {
          AttributeName: 'STANDARD_BETKAT',
          DisplayLabel: 'Standard betalningskategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kostnadskonto: {
          AssociationName: 'Kostnadskonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Levskuldkonto: {
          AssociationName: 'Levskuldkonto',
          DisplayLabel: 'Leverantörsskulders konto',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Levnrserie: {
          AssociationName: 'Levnrserie',
          DisplayLabel: 'Leverantörsnummerserie',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leverantorer: {
          AssociationName: 'Leverantorer',
          DisplayLabel: 'Leverantörer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LRBetalredovisningMeddelande: {
      CollectionName: 'LRBetalredovisningMeddelande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetalredovisningMeddelande',
        Abstract: false,
        SOLabel: 'Meddelande',
        SOGLabel: 'Meddelandes',
        SBLabel: 'Meddelandet',
        SBGLabel: 'Meddelandets',
        POLabel: 'Meddelanden',
        POGLabel: 'Meddelandens',
        PBLabel: 'Meddelandena',
        PBGLabel: 'Meddelandenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Meddelandets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Meddelandets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Meddelandets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        POSTTYP: {
          AttributeName: 'POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MEDDELANDE1: {
          AttributeName: 'MEDDELANDE1',
          DisplayLabel: 'Meddelande 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MEDDELANDE2: {
          AttributeName: 'MEDDELANDE2',
          DisplayLabel: 'Meddelande 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Post: {
          AssociationName: 'Post',
          DisplayLabel: 'Post',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningPost',
          AssociatedComponentName: 'BetalredovisningPost',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LRBetalredovisningRelated: {
      CollectionName: 'LRBetalredovisningRelated',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetalredovisningRelated',
        Abstract: false,
        SOLabel: 'Post',
        SOGLabel: 'Posts',
        SBLabel: 'Posten',
        SBGLabel: 'Postens',
        POLabel: 'Poster',
        POGLabel: 'Posters',
        PBLabel: 'Posterna',
        PBGLabel: 'Posternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Postens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Postens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Postens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NM: {
          AttributeName: 'NM',
          DisplayLabel: 'Nm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CTRY: {
          AttributeName: 'CTRY',
          DisplayLabel: 'PstlAdr_Ctry',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STRTNM: {
          AttributeName: 'STRTNM',
          DisplayLabel: 'PstlAdr_StrtNm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PSTCD: {
          AttributeName: 'PSTCD',
          DisplayLabel: 'PstlAdr_PstCd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TWNNM: {
          AttributeName: 'TWNNM',
          DisplayLabel: 'PstlAdr_TwnNm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IBAN: {
          AttributeName: 'IBAN',
          DisplayLabel: 'IBAN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIC: {
          AttributeName: 'BIC',
          DisplayLabel: 'BIC',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OTHRID: {
          AttributeName: 'OTHRID',
          DisplayLabel: 'Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CD: {
          AttributeName: 'CD',
          DisplayLabel: 'SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRBetalredovisningPost: {
      CollectionName: 'LRBetalredovisningPost',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetalredovisningPost',
        Abstract: false,
        SOLabel: 'Post',
        SOGLabel: 'Posts',
        SBLabel: 'Posten',
        SBGLabel: 'Postens',
        POLabel: 'Poster',
        POGLabel: 'Posters',
        PBLabel: 'Posterna',
        PBGLabel: 'Posternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Postens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Postens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Postens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_TRANSKOD: {
          AttributeName: 'BG_TRANSKOD',
          DisplayLabel: 'Bg, transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_MOTTAGARNR: {
          AttributeName: 'BG_MOTTAGARNR',
          DisplayLabel: 'Bg, mottagarnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_BELOPP: {
          AttributeName: 'BG_BELOPP',
          DisplayLabel: 'Bg, belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_BETALTYPSKOD: {
          AttributeName: 'BG_BETALTYPSKOD',
          DisplayLabel: 'Bg, betaltypskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_HANVISBGNR: {
          AttributeName: 'BG_HANVISBGNR',
          DisplayLabel: 'Bg, hänvisningsbankgironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_AVSINFO: {
          AttributeName: 'BG_AVSINFO',
          DisplayLabel: 'Bg, avsändarinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_NAMN_Transkod: {
          AttributeName: 'BG_NAMN_Transkod',
          DisplayLabel: 'Bg, namn transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_NAMN_Namn: {
          AttributeName: 'BG_NAMN_Namn',
          DisplayLabel: 'Bg, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_NAMN_EXTRANAMN: {
          AttributeName: 'BG_NAMN_EXTRANAMN',
          DisplayLabel: 'Bg, extranamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 33,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_INFO_TRANSKOD: {
          AttributeName: 'BG_INFO_TRANSKOD',
          DisplayLabel: 'Bg, info transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_INFO_INFOTEXT: {
          AttributeName: 'BG_INFO_INFOTEXT',
          DisplayLabel: 'Bg, information text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_ADRESS_TRANSKOD: {
          AttributeName: 'BG_ADRESS_TRANSKOD',
          DisplayLabel: 'Bg, adr transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_ADRESS_ADRESS: {
          AttributeName: 'BG_ADRESS_ADRESS',
          DisplayLabel: 'Bg, adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_ADRESS_POSTNR: {
          AttributeName: 'BG_ADRESS_POSTNR',
          DisplayLabel: 'Bg, postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_ADRESS_ORT: {
          AttributeName: 'BG_ADRESS_ORT',
          DisplayLabel: 'Bg, ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_KONTO_TRANSKOD: {
          AttributeName: 'BG_KONTO_TRANSKOD',
          DisplayLabel: 'Bg, konto transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_KONTO_CLEARINGNR: {
          AttributeName: 'BG_KONTO_CLEARINGNR',
          DisplayLabel: 'Bg, konto clearingnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_KONTO_KONTONR: {
          AttributeName: 'BG_KONTO_KONTONR',
          DisplayLabel: 'Bg, kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_KONTO_REFERENS: {
          AttributeName: 'BG_KONTO_REFERENS',
          DisplayLabel: 'Bg, konto referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_KONTO_LONKOD: {
          AttributeName: 'BG_KONTO_LONKOD',
          DisplayLabel: 'Bg, konto lönkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_OCRREF: {
          AttributeName: 'BG_OCRREF',
          DisplayLabel: 'Bg, OCR Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SISTABEVDATUM: {
          AttributeName: 'BG_SISTABEVDATUM',
          DisplayLabel: 'Bg, sista bevakningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_STATUSKOD: {
          AttributeName: 'BG_STATUSKOD',
          DisplayLabel: 'Bg, statuskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_REST_TRANSKOD: {
          AttributeName: 'BG_REST_TRANSKOD',
          DisplayLabel: 'Bg, rest transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_REST_INLDATUM: {
          AttributeName: 'BG_REST_INLDATUM',
          DisplayLabel: 'Bg, rest inläsningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_REST_URSPRBELOPP: {
          AttributeName: 'BG_REST_URSPRBELOPP',
          DisplayLabel: 'Bg, rest ursprungligt belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_REST_RESTBELOPP: {
          AttributeName: 'BG_REST_RESTBELOPP',
          DisplayLabel: 'Bg, restbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_MOTTAGARPGNR: {
          AttributeName: 'BG_MOTTAGARPGNR',
          DisplayLabel: 'Bg, mottagarens Postgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_BEHANDLINGSKOD: {
          AttributeName: 'BG_BEHANDLINGSKOD',
          DisplayLabel: 'Bg, behandlingskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_HANVBGNR: {
          AttributeName: 'BG_HANVBGNR',
          DisplayLabel: 'Bg, hänsvisningsbankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Adress: {
          AttributeName: 'Adress',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PostNr: {
          AttributeName: 'PostNr',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Ort: {
          AttributeName: 'Ort',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MottagarNr: {
          AttributeName: 'MottagarNr',
          DisplayLabel: 'Mottagarnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Belopp: {
          AttributeName: 'Belopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        PG_PO3_POSTTYP: {
          AttributeName: 'PG_PO3_POSTTYP',
          DisplayLabel: 'Pg, posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_BETALTYP: {
          AttributeName: 'PG_PO3_BETALTYP',
          DisplayLabel: 'Pg, betalningstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAGARNR: {
          AttributeName: 'PG_PO3_MOTTAGARNR',
          DisplayLabel: 'Pg, mottagarens nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 11,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_BOKFDATUM: {
          AttributeName: 'PG_PO3_BOKFDATUM',
          DisplayLabel: 'Pg, bokföringsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_BELOPP: {
          AttributeName: 'PG_PO3_BELOPP',
          DisplayLabel: 'Pg, belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MEDDELANDE: {
          AttributeName: 'PG_PO3_MEDDELANDE',
          DisplayLabel: 'Pg, meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ATERFORINGSKONTO: {
          AttributeName: 'PG_PO3_ATERFORINGSKONTO',
          DisplayLabel: 'Pg, återföringskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_CLEARINGNR: {
          AttributeName: 'PG_PO3_CLEARINGNR',
          DisplayLabel: 'Pg, clearing nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_EGENNOTERING_POSTTYP: {
          AttributeName: 'PG_PO3_EGENNOTERING_POSTTYP',
          DisplayLabel: 'Pg, egennot posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_EGENNOTERING_EGENNOTERING: {
          AttributeName: 'PG_PO3_EGENNOTERING_EGENNOTERING',
          DisplayLabel: 'Pg, egna noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 18,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_EGENNOTERING_EGENREF: {
          AttributeName: 'PG_PO3_EGENNOTERING_EGENREF',
          DisplayLabel: 'Pg, egennot egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_POSTTYP: {
          AttributeName: 'PG_PO3_ALTAVS_POSTTYP',
          DisplayLabel: 'Pg, alt avs posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_NAMN: {
          AttributeName: 'PG_PO3_ALTAVS_NAMN',
          DisplayLabel: 'Pg, alt avs namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_POSTNR: {
          AttributeName: 'PG_PO3_ALTAVS_POSTNR',
          DisplayLabel: 'Pg, alt avs post nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 9,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_POSTORT: {
          AttributeName: 'PG_PO3_ALTAVS_POSTORT',
          DisplayLabel: 'Pg, alt avs postort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_ADRESS: {
          AttributeName: 'PG_PO3_ALTAVS_ADRESS',
          DisplayLabel: 'Pg, alt avs adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_ALTAVS_ADRESS2: {
          AttributeName: 'PG_PO3_ALTAVS_ADRESS2',
          DisplayLabel: 'Pg, alt avs adress 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAG_NAMN: {
          AttributeName: 'PG_PO3_MOTTAG_NAMN',
          DisplayLabel: 'Pg, mottagare namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAG_POSTNR: {
          AttributeName: 'PG_PO3_MOTTAG_POSTNR',
          DisplayLabel: 'Pg, mottagare post nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 9,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAG_POSTORT: {
          AttributeName: 'PG_PO3_MOTTAG_POSTORT',
          DisplayLabel: 'Pg, mottagare postort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAG_ADRESS: {
          AttributeName: 'PG_PO3_MOTTAG_ADRESS',
          DisplayLabel: 'Pg, mottagare adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MOTTAG_ADRESS2: {
          AttributeName: 'PG_PO3_MOTTAG_ADRESS2',
          DisplayLabel: 'Pg, mottagare adress 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MEDDELANDE1: {
          AttributeName: 'PG_PO3_MEDDELANDE1',
          DisplayLabel: 'Pg, mottagare meddelande 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_MEDDELANDE2: {
          AttributeName: 'PG_PO3_MEDDELANDE2',
          DisplayLabel: 'Pg, mottagare meddelande 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_DEBET_POSTTYP: {
          AttributeName: 'PG_PO3_DEBET_POSTTYP',
          DisplayLabel: 'Pg, debet posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_DEBET_REF: {
          AttributeName: 'PG_PO3_DEBET_REF',
          DisplayLabel: 'Pg, debet referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_DEBET_BELOPP: {
          AttributeName: 'PG_PO3_DEBET_BELOPP',
          DisplayLabel: 'Pg, debet belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_DEBET_EGENREF: {
          AttributeName: 'PG_PO3_DEBET_EGENREF',
          DisplayLabel: 'Pg, debet egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 38,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_KREDIT_POSTTYP: {
          AttributeName: 'PG_PO3_KREDIT_POSTTYP',
          DisplayLabel: 'Pg, kredit posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_KREDIT_REF: {
          AttributeName: 'PG_PO3_KREDIT_REF',
          DisplayLabel: 'Pg, kredit referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_KREDIT_BELOPP: {
          AttributeName: 'PG_PO3_KREDIT_BELOPP',
          DisplayLabel: 'Pg, kredit belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_KREDIT_EGENREF: {
          AttributeName: 'PG_PO3_KREDIT_EGENREF',
          DisplayLabel: 'Pg, kredit egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 38,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_PO3_DEBKRED_REFERERAR_LOPNR: {
          AttributeName: 'PG_PO3_DEBKRED_REFERERAR_LOPNR',
          DisplayLabel: 'Pg, refererar löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Pg',
        },
        PG_DA1_POSTTYP: {
          AttributeName: 'PG_DA1_POSTTYP',
          DisplayLabel: 'Pg, da posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_CLEARINGNR: {
          AttributeName: 'PG_DA1_CLEARINGNR',
          DisplayLabel: 'Pg, da clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAGARKONTO: {
          AttributeName: 'PG_DA1_MOTTAGARKONTO',
          DisplayLabel: 'Pg, da mottagarkonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_BELOPP: {
          AttributeName: 'PG_DA1_BELOPP',
          DisplayLabel: 'Pg, da belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_INTERNREF: {
          AttributeName: 'PG_DA1_INTERNREF',
          DisplayLabel: 'Pg, da intern referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 32,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_INRIKES: {
          AttributeName: 'PG_DA1_INRIKES',
          DisplayLabel: 'Pg, da inrikes',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_INTERNBET: {
          AttributeName: 'PG_DA1_INTERNBET',
          DisplayLabel: 'Pg, da intern/Extern',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_NORMAL: {
          AttributeName: 'PG_DA1_NORMAL',
          DisplayLabel: 'Pg, da normalbetalning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_VAXLING_POSTTYP: {
          AttributeName: 'PG_DA1_VAXLING_POSTTYP',
          DisplayLabel: 'Pg, da växling posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_VAXLING_BELOPP: {
          AttributeName: 'PG_DA1_VAXLING_BELOPP',
          DisplayLabel: 'Pg, da växling belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_VAXLING_KURS: {
          AttributeName: 'PG_DA1_VAXLING_KURS',
          DisplayLabel: 'Pg, da växling valutakurs',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 9,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_VAXLING_VALUTA: {
          AttributeName: 'PG_DA1_VAXLING_VALUTA',
          DisplayLabel: 'Pg, da växling valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_EGENNOTERING_POSTTYP: {
          AttributeName: 'PG_DA1_EGENNOTERING_POSTTYP',
          DisplayLabel: 'Pg, da egennot posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_EGENNOTERING_EGENNOTERING: {
          AttributeName: 'PG_DA1_EGENNOTERING_EGENNOTERING',
          DisplayLabel: 'Pg, da egen notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 18,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_EGENNOTERING_EGENREF: {
          AttributeName: 'PG_DA1_EGENNOTERING_EGENREF',
          DisplayLabel: 'Pg, da egennot egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAG_POSTTYP: {
          AttributeName: 'PG_DA1_MOTTAG_POSTTYP',
          DisplayLabel: 'Pg, da mottag posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAG_KONTO: {
          AttributeName: 'PG_DA1_MOTTAG_KONTO',
          DisplayLabel: 'MottagaPg, da mottag konto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 18,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAG_NAMN: {
          AttributeName: 'PG_DA1_MOTTAG_NAMN',
          DisplayLabel: 'Pg, da mottag namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAG_LANDKOD: {
          AttributeName: 'PG_DA1_MOTTAG_LANDKOD',
          DisplayLabel: 'Pg, da mottag landkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_DA1_MOTTAG_BETALTYP: {
          AttributeName: 'PG_DA1_MOTTAG_BETALTYP',
          DisplayLabel: 'Pg, da mottag betalningstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 17,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_POR_FEL_POSTTYP: {
          AttributeName: 'PG_POR_FEL_POSTTYP',
          DisplayLabel: 'Pg, for fel posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_POR_FEL_FELKOD: {
          AttributeName: 'PG_POR_FEL_FELKOD',
          DisplayLabel: 'Pg, for fel felkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        PG_POR_FEL_FELMEDDELANDE: {
          AttributeName: 'PG_POR_FEL_FELMEDDELANDE',
          DisplayLabel: 'Pg, for felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 68,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Pg',
        },
        BG_SALDO1_TRANSKOD: {
          AttributeName: 'BG_SALDO1_TRANSKOD',
          DisplayLabel: 'Bg, saldo1 transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_INGSALDO_FAKT: {
          AttributeName: 'BG_SALDO1_INGSALDO_FAKT',
          DisplayLabel: 'Bg, saldo1 ingående saldo fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_NEGATIV: {
          AttributeName: 'BG_SALDO1_NEGATIV',
          DisplayLabel: 'Bg, saldo1 negativt saldo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_INGSALDO_KREDIT: {
          AttributeName: 'BG_SALDO1_INGSALDO_KREDIT',
          DisplayLabel: 'Bg, saldo1 ingående saldo kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_MINUS: {
          AttributeName: 'BG_SALDO1_MINUS',
          DisplayLabel: 'Bg, saldo1 minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_TOTSUM_FAKT: {
          AttributeName: 'BG_SALDO1_TOTSUM_FAKT',
          DisplayLabel: 'Bg, saldo1 totalsumma fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_NEGBELOPP: {
          AttributeName: 'BG_SALDO1_NEGBELOPP',
          DisplayLabel: 'Bg, saldo1 negativt belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_TOTSUM_KREDIT: {
          AttributeName: 'BG_SALDO1_TOTSUM_KREDIT',
          DisplayLabel: 'Bg, saldo1 totalsumma kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO1_MINUS2: {
          AttributeName: 'BG_SALDO1_MINUS2',
          DisplayLabel: 'Bg, saldo1 minustecken2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_TRANSKOD: {
          AttributeName: 'BG_SALDO2_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_TOTSUM_BETFAKT: {
          AttributeName: 'BG_SALDO2_TOTSUM_BETFAKT',
          DisplayLabel: 'Totalsumma betalade fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_AVR_KREDIT: {
          AttributeName: 'BG_SALDO2_AVR_KREDIT',
          DisplayLabel: 'Avräknat för kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_MINUS: {
          AttributeName: 'BG_SALDO2_MINUS',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_TOTSUM_MAKULERADE: {
          AttributeName: 'BG_SALDO2_TOTSUM_MAKULERADE',
          DisplayLabel: 'Totalsumma makulerade fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_TOTSUM_MAKULERADE_KREDIT: {
          AttributeName: 'BG_SALDO2_TOTSUM_MAKULERADE_KREDIT',
          DisplayLabel: 'Totalsumma makulerade kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO2_MINUS2: {
          AttributeName: 'BG_SALDO2_MINUS2',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_TRANSKOD: {
          AttributeName: 'BG_SALDO3_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_TOTSUM_ATERRED: {
          AttributeName: 'BG_SALDO3_TOTSUM_ATERRED',
          DisplayLabel: 'Totalsumma återredovisade fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_NEGATIV: {
          AttributeName: 'BG_SALDO3_NEGATIV',
          DisplayLabel: 'Negativt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_ATERRED_KREDIT: {
          AttributeName: 'BG_SALDO3_ATERRED_KREDIT',
          DisplayLabel: 'Återredovisade kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_MINUS: {
          AttributeName: 'BG_SALDO3_MINUS',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_NEGATIV_SALDO: {
          AttributeName: 'BG_SALDO3_NEGATIV_SALDO',
          DisplayLabel: 'Negativt utgående saldo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_UTG_SALDO_FAKT: {
          AttributeName: 'BG_SALDO3_UTG_SALDO_FAKT',
          DisplayLabel: 'Utgående saldo fakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_UTG_SALDO_KREDIT: {
          AttributeName: 'BG_SALDO3_UTG_SALDO_KREDIT',
          DisplayLabel: 'Utgående saldo kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_SALDO3_MINUS2: {
          AttributeName: 'BG_SALDO3_MINUS2',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bg',
        },
        BG_BEVAK_TRANSKOD: {
          AttributeName: 'BG_BEVAK_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_DATUM: {
          AttributeName: 'BG_BEVAK_DATUM',
          DisplayLabel: 'Datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_SUMMA_FAKT: {
          AttributeName: 'BG_BEVAK_SUMMA_FAKT',
          DisplayLabel: 'Summa fakturor och avdrag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_MINUS: {
          AttributeName: 'BG_BEVAK_MINUS',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_SUMMA_KREDIT: {
          AttributeName: 'BG_BEVAK_SUMMA_KREDIT',
          DisplayLabel: 'Summa kreditfakturor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_MINUS2: {
          AttributeName: 'BG_BEVAK_MINUS2',
          DisplayLabel: 'Minustecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_BEVAK_KOMMENTARSKOD: {
          AttributeName: 'BG_BEVAK_KOMMENTARSKOD',
          DisplayLabel: 'Kommentarskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_STOPPAD_TRANSKOD: {
          AttributeName: 'BG_STOPPAD_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_STOPPAD_POST: {
          AttributeName: 'BG_STOPPAD_POST',
          DisplayLabel: 'Post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 78,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_KOMMENTAR_TRANSKOD: {
          AttributeName: 'BG_KOMMENTAR_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_KOMMENTAR_ALF_FELKOD: {
          AttributeName: 'BG_KOMMENTAR_ALF_FELKOD',
          DisplayLabel: 'Alfabetisk felkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_KOMMENTAR_NUM_FELKOD: {
          AttributeName: 'BG_KOMMENTAR_NUM_FELKOD',
          DisplayLabel: 'Numerisk felkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_KOMMENTAR_KOMMENTAR: {
          AttributeName: 'BG_KOMMENTAR_KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 70,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVVISAD_TRANSKOD: {
          AttributeName: 'BG_AVVISAD_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BG_AVVISAD_POST: {
          AttributeName: 'BG_AVVISAD_POST',
          DisplayLabel: 'Post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 78,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EgenNotering: {
          AttributeName: 'EgenNotering',
          DisplayLabel: 'Ref till faktura',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        EgenReferens: {
          AttributeName: 'EgenReferens',
          DisplayLabel: 'Ref till betalning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Identification: {
          AttributeName: 'Identification',
          DisplayLabel: 'Identification',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BETALNING_BOKF_GRUPP_ID: {
          AttributeName: 'BETALNING_BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BETALNING_LEVFAKT_ID: {
          AttributeName: 'BETALNING_LEVFAKT_ID',
          DisplayLabel: 'Leverantörsfaktura',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BETALNING_LOPNR: {
          AttributeName: 'BETALNING_LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Vaxlingskurs: {
          AttributeName: 'Vaxlingskurs',
          DisplayLabel: 'Växlingskurs',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        VER_BOKF_AR: {
          AttributeName: 'VER_BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VER_VER_NR: {
          AttributeName: 'VER_VER_NR',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Bokford: {
          AttributeName: 'Bokford',
          DisplayLabel: 'Bokförd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PG_DEBKRED_POSTTYP: {
          AttributeName: 'PG_DEBKRED_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DEBKRED_REF: {
          AttributeName: 'PG_DEBKRED_REF',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DEBKRED_BELOPP: {
          AttributeName: 'PG_DEBKRED_BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DEBKRED_EGENREF: {
          AttributeName: 'PG_DEBKRED_EGENREF',
          DisplayLabel: 'Egen referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 28,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DEBKRED_TYP: {
          AttributeName: 'PG_DEBKRED_TYP',
          DisplayLabel: 'Debet/Kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PG_DEBKRED_REF_LOPNR: {
          AttributeName: 'PG_DEBKRED_REF_LOPNR',
          DisplayLabel: 'Refererar till löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FaktnrRef: {
          AttributeName: 'FaktnrRef',
          DisplayLabel: 'Fakturanr/Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ISO_NTRYREF: {
          AttributeName: 'ISO_NTRYREF',
          DisplayLabel: 'NtryRef',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_AMT: {
          AttributeName: 'ISO_AMT',
          DisplayLabel: 'Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_CDTDBTIND: {
          AttributeName: 'ISO_CDTDBTIND',
          DisplayLabel: 'CdtDbtInd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_STS: {
          AttributeName: 'ISO_STS',
          DisplayLabel: 'Sts',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BOOKGDT: {
          AttributeName: 'ISO_BOOKGDT',
          DisplayLabel: 'BookgDt_Dt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_VALDT: {
          AttributeName: 'ISO_VALDT',
          DisplayLabel: 'ValDt_Dt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_DOMN_CD: {
          AttributeName: 'ISO_BKTXCD_DOMN_CD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_FMLY_CD: {
          AttributeName: 'ISO_BKTXCD_FMLY_CD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Fmly_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_FMLY_SUBFMLYCD: {
          AttributeName: 'ISO_BKTXCD_FMLY_SUBFMLYCD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Fmly_SubFmlyCd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_MSGID: {
          AttributeName: 'ISO_DETAILS_REFS_MSGID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_MsgId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_PMTINFID: {
          AttributeName: 'ISO_DETAILS_REFS_PMTINFID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_PmtInfId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_INSTRID: {
          AttributeName: 'ISO_DETAILS_REFS_INSTRID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_InstId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_ENDTOENDID: {
          AttributeName: 'ISO_DETAILS_REFS_ENDTOENDID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_EndToEndId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_ACCTSVCRREF: {
          AttributeName: 'ISO_DETAILS_REFS_ACCTSVCRREF',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_AcctSvcrRef',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_TXID: {
          AttributeName: 'ISO_DETAILS_REFS_TXID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_TxId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_INSTDAMT_AMT: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_INSTDAMT_AMT',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_InstdAmt_Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_AMT: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_AMT',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_CDTR_ID: {
          AttributeName: 'ISO_DETAILS_CDTR_ID',
          DisplayLabel: 'Related creditor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_DBTR_ID: {
          AttributeName: 'ISO_DETAILS_DBTR_ID',
          DisplayLabel: 'Related debtor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_CDTRACCT_ID: {
          AttributeName: 'ISO_DETAILS_CDTRACCT_ID',
          DisplayLabel: 'Related creditoraccount id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_DBTRACCT_ID: {
          AttributeName: 'ISO_DETAILS_DBTRACCT_ID',
          DisplayLabel: 'Related debtoraccount id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_ULTMTCDTR_ID: {
          AttributeName: 'ISO_DETAILS_ULTMTCDTR_ID',
          DisplayLabel: 'Related ultimate creditor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_ULTMTDBTR_ID: {
          AttributeName: 'ISO_DETAILS_ULTMTDBTR_ID',
          DisplayLabel: 'Related ultimate debtor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_CDTRAGT_ID: {
          AttributeName: 'ISO_DETAILS_CDTRAGT_ID',
          DisplayLabel: 'Related creditor agent id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_DBTRAGT_ID: {
          AttributeName: 'ISO_DETAILS_DBTRAGT_ID',
          DisplayLabel: 'Related debtor agent id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_CD: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_CD',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Tp_CdOrPrtry_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_ISSR: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_ISSR',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Tp_Issr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_REF: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_REF',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Ref',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCINF_CD: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCINF_CD',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocInf_Tp_CdOrPrtry_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCINF_NB: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCINF_NB',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocInf_Nb',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCAMT: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCAMT',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocAmt_RmtdAmt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTNOTEAMT: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTNOTEAMT',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocAmt_CdtNoteAmt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_SRCCCY: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_SRCCCY',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_SrcCcy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_TRGTCCY: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_TRGTCCY',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_TrgtCcy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_XCHGRATE: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_XCHGRATE',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_XchgRate',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ValutaBelopp: {
          AttributeName: 'ValutaBelopp',
          DisplayLabel: 'Valutabelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        INFO: {
          AttributeName: 'INFO',
          DisplayLabel: 'Information',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKFORDER_ID: {
          AttributeName: 'BOKFORDER_ID',
          DisplayLabel: 'Bokforder id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VerNrOchTyp: {
          AttributeName: 'VerNrOchTyp',
          DisplayLabel: 'VerNrOchTyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Betalningsredovisning: {
          AssociationName: 'Betalningsredovisning',
          DisplayLabel: 'Betalningsredovisning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRBetalredovisning',
          AssociatedComponentName: 'Betalningsredovisning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Betalning: {
          AssociationName: 'Betalning',
          DisplayLabel: 'Betalning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalning',
          AssociatedComponentName: 'Betalning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Creditor: {
          AssociationName: 'Creditor',
          DisplayLabel: 'Creditor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Debtor: {
          AssociationName: 'Debtor',
          DisplayLabel: 'Debtor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        CreditorAccount: {
          AssociationName: 'CreditorAccount',
          DisplayLabel: 'Creditor account',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DebtorAccount: {
          AssociationName: 'DebtorAccount',
          DisplayLabel: 'Debtor account',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UltimateCreditor: {
          AssociationName: 'UltimateCreditor',
          DisplayLabel: 'Ultimate creditor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UltimateDebtor: {
          AssociationName: 'UltimateDebtor',
          DisplayLabel: 'Ultimate debtor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        CreditorAgent: {
          AssociationName: 'CreditorAgent',
          DisplayLabel: 'Creditor agent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DebtorAgent: {
          AssociationName: 'DebtorAgent',
          DisplayLabel: 'Debtor agent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningRelated',
          AssociatedComponentName: 'BetalredovisningRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokforder: {
          AssociationName: 'Bokforder',
          DisplayLabel: 'Utanordning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforder',
          AssociatedComponentName: 'Bokforder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        XXMeddelande: {
          AssociationName: 'XXMeddelande',
          DisplayLabel: 'Meddelande',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningMeddelande',
          AssociatedComponentName: 'BetalredovisningMeddelande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Avrakning: {
          AssociationName: 'Avrakning',
          DisplayLabel: 'Avräkning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningAvrakning',
          AssociatedComponentName: 'BetalredovisningAvrakning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        DebKred: {
          AssociationName: 'DebKred',
          DisplayLabel: 'DebetKredit',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningDebKreb',
          AssociatedComponentName: 'BetalredovisningDebKreb',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Meddelande: {
          AssociationName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalredovisningMeddelande',
          AssociatedComponentName: 'BetalredovisningMeddelande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LROrgStorleksklass: {
      CollectionName: 'LROrgStorleksklass',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrgStorleksklass',
        Abstract: false,
        SOLabel: 'Storleksklass',
        SOGLabel: 'Storleksklass',
        SBLabel: 'Storleksklass',
        SBGLabel: 'Storleksklass',
        POLabel: 'Storleksklass',
        POGLabel: 'Storleksklass',
        PBLabel: 'Storleksklass',
        PBGLabel: 'Storleksklass',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Storleksklass primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Storleksklass versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Storleksklass fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORG_NR: {
          AttributeName: 'ORG_NR',
          DisplayLabel: 'Organisationsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STORLEKSKLASS_KOD: {
          AttributeName: 'STORLEKSKLASS_KOD',
          DisplayLabel: 'Storleksklass',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="S0_9=Företag som har 0 - 9 anställda;S10_49=Företag som har 10 - 49 anställda;S50_249=Företag som har 50 - 249 anställda"',
          FormatterValidateParams: 'ValidValues="Företag som har 0 - 9 anställda=S0_9Företag som har 10 - 49 anställda=;S10_49;Företag som har 50 - 249 anställda=S50_249"',
          GUIEditable: true,
          MaxInputLength: 70,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    LRUtbetalningsBekraftelse: {
      CollectionName: 'LRUtbetalningsBekraftelse',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Utbetalningsbekraftelse',
        Abstract: false,
        SOLabel: 'Utbetalningsbekräftelse',
        SOGLabel: 'Utbetalningsbekräftelse',
        SBLabel: 'Utbetalningsbekräftelse',
        SBGLabel: 'Utbetalningsbekräftelse',
        POLabel: 'Utbetalningsbekräftelse',
        POGLabel: 'Utbetalningsbekräftelse',
        PBLabel: 'Utbetalningsbekräftelse',
        PBGLabel: 'Utbetalningsbekräftelse',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utbetalningsbekräftelse primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utbetalningsbekräftelse versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utbetalningsbekräftelse id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utbetalningsbekräftelse fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XML: {
          AttributeName: 'XML',
          DisplayLabel: 'XML',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LRBetalningsuppdrag: {
      CollectionName: 'LRBetalningsuppdrag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningsuppdrag',
        Abstract: false,
        SOLabel: 'Utbetalningsorder',
        SOGLabel: 'Utbetalningsorders',
        SBLabel: 'Utbetalningsordern',
        SBGLabel: 'Utbetalningsorderns',
        POLabel: 'Utbetalningsorder',
        POGLabel: 'Utbetalningsorders',
        PBLabel: 'Utbetalningsorderna',
        PBGLabel: 'Utbetalningsordernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utbetalningsorderns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utbetalningsorderns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utbetalningsorderns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utbetalningsorderns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTBETALNINGSVAG_ID: {
          AttributeName: 'UTBETALNINGSVAG_ID',
          DisplayLabel: 'Utbetalningsväg ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Produktionsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'Användare ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        FIL_LOPNUMMER: {
          AttributeName: 'FIL_LOPNUMMER',
          DisplayLabel: 'Utbetalningsfilens löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FIL_PRODDATUM: {
          AttributeName: 'FIL_PRODDATUM',
          DisplayLabel: 'Utbetalningsfilens produktionsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REDOVISA_PER_GRUPP: {
          AttributeName: 'REDOVISA_PER_GRUPP',
          DisplayLabel: 'Redovisa per bokföringsgrupp',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
          Required: true,
        },
        ANGIVET_BETALNINGSDATUM: {
          AttributeName: 'ANGIVET_BETALNINGSDATUM',
          DisplayLabel: 'Angivet betalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urvals id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Utbetalningsvag: {
          AttributeName: 'Utbetalningsvag',
          DisplayLabel: 'Utbetalningsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Anvandare: {
          AttributeName: 'Anvandare',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SkapadUtbetfil: {
          AttributeName: 'SkapadUtbetfil',
          DisplayLabel: 'Skapad utbetalningsfil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Totalbelopp: {
          AttributeName: 'Totalbelopp',
          DisplayLabel: 'Totalbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AntalFakturor: {
          AttributeName: 'AntalFakturor',
          DisplayLabel: 'Antal fakturor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        STATUS_ELEKTRONISK_BETALNING: {
          AttributeName: 'STATUS_ELEKTRONISK_BETALNING',
          DisplayLabel: 'Status, elektronisk betalning',
          Hint: 'Skickad/Hanterad/Delvis hanterad/Ej hanterad/Skickad, ej kvitterad på 2 dagar',
          DataType: 'Enum',
          EnumValues: new Map([['SKICKAD', 'Skickad'], ['HANTERAD', 'Hanterad'], ['DELVIS_HANTERAD', 'Delvis hanterad'], ['EJ_HANTERAD', 'Ej hanterad'], ['SKICKAD__EJ_KVITTERAD_PA_2_DAGAR', 'Skickad, ej kvitterad på 2 dagar']]),
          EnumSortValues: new Map([['SKICKAD', 'S'], ['HANTERAD', 'H'], ['DELVIS_HANTERAD', 'D'], ['EJ_HANTERAD', 'E'], ['SKICKAD__EJ_KVITTERAD_PA_2_DAGAR', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKICKAD=Skickad;HANTERAD=Hanterad;DELVIS_HANTERAD=Delvis hanterad;EJ_HANTERAD=Ej hanterad;SKICKAD__EJ_KVITTERAD_PA_2_DAGAR=Skickad, ej kvitterad på 2 dagar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FELTEXT: {
          AttributeName: 'FELTEXT',
          DisplayLabel: 'Feltext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KVITTENSFIL: {
          AttributeName: 'KVITTENSFIL',
          DisplayLabel: 'Kvittensfil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FelaktigaBetalningar: {
          AttributeName: 'FelaktigaBetalningar',
          DisplayLabel: 'Felaktiga betalningar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Utbetalningsvag: {
          AssociationName: 'Utbetalningsvag',
          DisplayLabel: 'Utbetalningsväg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningsvag',
          AssociatedComponentName: 'Utbetalningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Skapad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningar: {
          AssociationName: 'Betalningar',
          DisplayLabel: 'Betalningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalning',
          AssociatedComponentName: 'Betalning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokforder: {
          AssociationName: 'Bokforder',
          DisplayLabel: 'Utanordningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforder',
          AssociatedComponentName: 'Bokforder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default LR;
